export default {
  locales: {
    pl: "Polish",
  },
  fatca: "FATCA",
  crs: "CRS",
  acttrader: "ActTrader",
  compairacc: "Proszę porównać konta",
  ecnacc: "KONTO ECN",
  openacc: "Otwarte konto",
  crypto: "Cyrptowaluty",
  stock: "Akcje",
  forex: "Forex",
  indices: "Wskaźniki",
  commodities: "Towary",
  negativebalance: "Ochrona przed ujemnym saldem",
  minorderdest: "Min. odległość zamówienia",
  stopout: "stop-out",
  margincall: "Margin Call",
  yes: "Tak",
  no: "Nie",
  lot: "dużo",
  usd: "USD",
  eur: "EUR",
  gbp: "GBP",
  aud: "AUD",
  basecurrency: "Waluty bazowe",
  upto: "do",
  mindeposit: "Min. Depozyt",
  account: "Konto",
  zulu: "zulu",
  zulu_trade: "Zulu Trade",
  plus: "plus",
  max: "max",
  min: "min",
  leverage: "Dźwignia finansowa",
  per: "za",
  commission: "Komisja",
  minpip: "min. pip",
  spreads: "Spready",
  spread: "Rozprzestrzenianie się",
  ecn: "ECN",
  keyinfo: "Kluczowe dokumenty informacyjne",
  mifid: "Przepisy MIFID",
  privacypolicy: "Polityka prywatności",
  contact: "Kontakt 24/5",
  webtrader: "Web-Trader",
  login: "Proszę się zalogować",
  joinNow: "Proszę dołączyć teraz",
  aboutAAAfx: {
    name: "O AAAFx",
    submenu: {
      why: {
        title: "Dlaczego AAAFx",
        tagline: "Proszę wiedzieć, kim jesteśmy",
      },
      safety: {
        title: "Bezpieczeństwo funduszy",
        tagline: "Wspieramy Państwa",
      },
      servers: {
        title: "Nasze serwery",
        tagline: "Najlepsze systemy zapewniające najlepsze wyniki",
      },
      regulations: {
        title: "Przepisy i licencje",
        tagline: "Niezawodny i bezpieczny handel",
      },
      legalDocs: {
        title: "Dokumenty prawne",
        tagline: "Proszę przeczytać wszystkie dokumenty prawne",
      },
      careers: {
        title: "Kariera",
        tagline: "Proszę dołączyć do naszego zespołu",
      },
      contactUs: {
        title: "Proszę się z nami skontaktować",
        tagline: "Chętnie się z Państwem skontaktujemy",
      },
    },
    title:
      "Triple A Experts Investment Services Single Member SA jest spółką autoryzowaną i regulowaną przez Grecką Komisję Rynku Kapitałowego (id:2/540/17.2.2010) z siedzibą pod adresem Triple A Experts Investment Services Single Member S. A, 580 Vouliagmenis Avenue 16452, Argyroupoli Attica.",
  },
  trading: {
    name: "Handel",
    submenu: {
      products: {
        title: "Produkty handlowe",
        tagline: "Instrumenty handlowe, które oferujemy",
      },
      accountTypes: {
        title: "Typy kont",
        tagline: "Proszę wybrać to, co odpowiada Państwa wymaganiom",
      },
      tradingConditions: {
        title: "Warunki handlowe",
        tagline: "Wszystko dla Państwa dobra",
      },
      depWithdrawal: {
        title: "Wpłaty i wypłaty",
        tagline: "Bezproblemowe zarządzanie pieniędzmi",
      },
    },
  },
  platforms: {
    name: "Platformy",
    submenu: {
      mt4: {
        title: "MT4",
        tagline: "Najpopularniejsza platforma handlowa",
      },
      mt5: {
        title: "MT5",
        tagline: "Zaawansowany i wielofunkcyjny",
      },
      act: {
        name: "ACT",
        title: "ActTrader",
        tagline: "Łatwy w użyciu i najwygodniejszy",
      },
      comparison: {
        title: "Porównanie platform",
        tagline: "Proszę podjąć świadomą decyzję",
      },
    },
  },
  promotions: {
    name: "Promocje",
    submenu: {
      bonus: {
        title: "Bonus od depozytu",
        tagline: "Podwojenie Państwa marży bez żadnych kosztów",
      },
      refer: {
        title: "Poleć i zarabiaj",
        tagline: "Proszę zaprosić znajomych i podzielić się korzyściami",
      },
      vps: {
        title: "Darmowy VPS",
        tagline: "Proszę skorzystać z bezpłatnego szybkiego handlu",
      },
    },
  },
  tools: {
    name: "Narzędzia i zasoby",
    submenu: {
      zulu: {
        title: "ZuluTrade",
        tagline: "Dołącz do największej sieci handlu społecznościowego",
      },
      calculators: {
        title: "Kalkulatory handlowe",
        tagline: "Łatwe obliczenia dla Państwa",
      },
      ecoCalendar: {
        title: "Kalendarz ekonomiczny",
        tagline: "Bądź na bieżąco i handluj mądrze",
      },
      partnerships: {
        title: "Partnerstwa",
        tagline: "Współpracuj z nami i rozwijaj się",
      },
      faq: {
        title: "Najczęściej zadawane pytania",
        tagline: "Odpowiedzi na najczęściej zadawane pytania",
      },
    },
  },
  legalinfo: {
    name: "Informacje prawne",
    para1:
      "Triple A Experts Investment Services Single Member SA jest spółką autoryzowaną i regulowaną przez Grecką Komisję Rynku Kapitałowego (id:2/540/17.2.2010) z siedzibą pod adresem Triple A Experts Investment Services S.A., 14 Akti Kondyli street, 18545 Pireus, Grecja.",
    para2:
      "Sikhula Venture Capital (Pty) Ltd. jest autoryzowana i regulowana przez południowoafrykański Urząd Nadzoru Sektora Finansowego (FSCA nr 2017/315029/07).",
    para3:
      "www.aaafx.com jest obsługiwany przez Triple A Experts Investment Services Single Member SA",
    para4:
      "www.aaafx.com jest obsługiwany przez Triple A Experts Investment Services Single Member SA.",
  },
  riskdisc: {
    name: "Ujawnianie ryzyka",
    para_one:
      "Kontrakty CFD są złożonymi instrumentami i wiążą się z wysokim ryzykiem szybkiej utraty pieniędzy z powodu dźwigni finansowej.",
    para_two:
      "rachunków inwestorów detalicznych traci pieniądze podczas handlu kontraktami CFD z AAAFx. Należy rozważyć, czy rozumieją Państwo, jak działają kontrakty CFD i czy mogą sobie Państwo pozwolić na podjęcie wysokiego ryzyka utraty pieniędzy. Szczegółowe informacje znajdą Państwo",
    link: "tutaj.",
  },
  accounttypepage: {
    title: "Typy kont",
    tagline1:
      "Proszę wybrać konto, które odpowiada Państwa potrzebom handlowym! Mamy ekscytujące oferty dla",
    tagline2: "każdego inwestora, w bardzo uproszczony sposób.",
    zeroPointZero: "0.0",
    hundredDollar: "$100k",
    fiveDollar: "$5",
    threeDollar: "$3",
    thirtyX: "30X",
    hundered: "$100",
    tenThousand: "$10,000",
    chf: "CHF",
    seventyFifty: "70/50%",
    para1: {
      desc1:
        "Istnieją trzy różne typy rachunków, które spełniają wymagania początkującego inwestora, profesjonalnego inwestora lub inwestora instytucjonalnego. Niektóre ze wspólnych ekscytujących funkcji zapewnionych na wszystkich rachunkach to:",
      point1: "Broker regulowany przez UE",
      point2: "Ultra cienkie pasty do smarowania",
      point3: "Wszystkie strategie handlowe dozwolone",
      point4:
        "Bez min. Odległość zamówienia - proszę składać zamówienia według własnego uznania",
      point5: "Ochrona przed ujemnym saldem",
      point6: "Handel mikrolotami",
      desc2:
        "Bez żadnej dyskryminacji oferujemy instytucjonalne spready i płynność wszystkim inwestorom.",
    },
    accdesc: {
      title: "Opis konta",
      point1: {
        title: "Rachunek ECN",
        desc: "Proszę cieszyć się surowymi spreadami ECN i błyskawiczną realizacją transakcji przy bardzo niskich kosztach. Niskie opłaty prowizyjne i niskie opłaty swapowe w połączeniu z naszą zaawansowaną technologią sprawiają, że Państwa doświadczenie handlowe jest wzorowe pod każdym względem. Nie nakładamy również żadnych ograniczeń na żadną strategię handlową.",
      },
      point2: {
        title: "Rachunek ECN plus",
        desc: "Dla traderów z minimalnym depozytem w wysokości 10 000 USD lub tych z kategorii AAA w Programie Lojalnościowym, ECN zero jest nagrodą, na którą warto czekać. Jest to najlepsza możliwa kombinacja dla każdego inwestora - zerowa prowizja na rynku Forex z surowymi cienkimi spreadami, bez marży. Mogą Państwo cieszyć się tym wszystkim wraz z naszą błyskawiczną realizacją transakcji.",
      },
      point3: {
        title: "Rachunek handlowy ECN Zulu",
        desc: "Proszę stać się częścią największej społeczności inwestorów, otwierając u nas rachunek Zulu. Rachunek ten jest automatycznie połączony z platformą Zulu, nie są wymagane żadne dodatkowe działania. W związku z tym automatycznie mogą Państwo korzystać z cienkich jak brzytwa spreadów, niskiej prowizji, naszej zaawansowanej technologii, dużej płynności i błyskawicznej realizacji zleceń, a także bezpośredniego dostępu do światowej klasy społeczności handlowej.",
      },
      para1:
        "Bardziej elastyczne warunki handlowe (zwiększona dźwignia) mogą mieć zastosowanie w przypadku klientów sklasyfikowanych jako Profesjonalni. Proszę zalogować się na swoje konto i sprawdzić, czy kwalifikujesz się do klasyfikacji Klienta Profesjonalnego lub napisać do nas na adres",
    },
    supportEmail: "support{'@'}aaafx.com",
  },
  acttraderpage: {
    title: "ActTrader",
    para1:
      "Chcą Państwo handlować, ale nie mają pewności co do zaawansowanych platform handlowych?",
    para2:
      " Dzięki naszej platformie transakcyjnej ActTrader mają Państwo wszystko pod kontrolą. ActTrader jest liderem w branży handlu online od 2000 roku, wyposażonym w najlepszą w swojej klasie technologię. Platforma koncentruje się na prostocie, czytelności i kwestionowaniu istniejących tradycji handlowych za pomocą solidnej technologii, dzięki czemu użytkownik może skupić się na opcjach handlowych. ActTrader był świadkiem wielokrotnego wzrostu wolumenu obrotu do 5 bilionów dolarów miesięcznie, co potwierdza wysoką płynność na platformie.",
    para3: "Proszę rozpocząć płynną podróż handlową z ActTrader:",
    questionnaire: {
      question1: {
        heading: "Kroki, aby pobrać ActTrader Desktop",
        point: "1. Proszę pobrać platformę z powyższego linku.",
        point1: "2. Proszę uruchomić plik .exe",
        point2:
          "3. Proszę wprowadzić numer rachunku handlowego i hasło na platformie ACT.",
        point3:
          " 4. Proszę wybrać typ rachunku: Demo dla rachunku demonstracyjnego / Real dla rachunku rzeczywistego.",
        point4: "5. Proszę wybrać preferowany język.",
        point5: '6. Proszę kliknąć na "login"',
        point6: "7. Pojawi się małe okienko. Proszę wybrać strefę czasową.",
        point7:
          "8. Ponownie pojawi się małe okienko. Proszę wybrać układ platformy początkujący / zaawansowany.",
      },
      question2: {
        heading: "Kroki, aby odinstalować ActTrader Desktop",
        point: "1. Proszę kliknąć przycisk Start w systemie Windows",
        point1: "2. Aplikacja ACT zostanie dołączona do listy programów.",
        point2:
          '3. Proszę kliknąć prawym przyciskiem myszy na nazwę aplikacji i wybrać "Odinstaluj".',
      },
      question3: {
        heading: "Kroki logowania się do internetowego systemu Act Trader",
        point: "1. Proszę kliknąć łącze Web Trader",
        aTag: "tutaj",
        point1:
          '2. Proszę wybrać "Demo web trader" dla rachunku demo lub "Live web trader" dla rachunku rzeczywistego.',
        point2: "3. Otworzy się nowa karta.",
        point3:
          "4. Proszę wprowadzić dane logowania. Są Państwo teraz zalogowani.",
      },
      question4: {
        heading: "Kroki, aby pobrać ActTrader Android",
        point: "1. Proszę zainstalować aplikację z powyższego linku.",
        point1:
          "2. Proszę kliknąć zainstalowaną aplikację na urządzeniu z systemem Android.",
        point2: '3. Proszę nacisnąć "Agree" na umowie licencyjnej.',
        point3:
          "4. Proszę wprowadzić numer rachunku handlowego w nazwie użytkownika i hasło.",
        point4:
          "5. Proszę wybrać typ rachunku: AAAFX Demo dla rachunku demonstracyjnego i AAAFX Live dla rachunku rzeczywistego.",
        point5: '6. Proszę kliknąć na "login"',
      },
      question5: {
        heading: "Kroki, aby odinstalować ActTrader Android",
        point:
          "1. W menu proszę wybrać Ustawienia > Aplikacje > Zarządzaj aplikacjami",
        point1: "2. Proszę znaleźć ACT na liście i kliknąć na jego nazwę.",
        point2: "3. Proszę dotknąć Odinstaluj.",
      },
      question6: {
        heading: "Kroki, aby pobrać ActTrader iOS",
        point: "1. Proszę otworzyć aplikację ActPhone.",
        point1:
          "2. Proszę wprowadzić dane logowania udostępnione Państwu w wiadomości e-mail.",
        point2:
          "3. W sekcji Typ rachunku proszę przewinąć w dół i wybrać AAAFX Demo dla rachunku Demo lub AAAFX Live dla rachunku Live.",
        point3: "4. Proszę wybrać Sign In i poczekać na załadowanie konta.",
      },
      question7: {
        heading: "Kroki, aby odinstalować ActTrader iOS",
        point:
          "1. Proszę długo nacisnąć ikonę aplikacji ActTrader, aż wszystkie ikony na ekranie zaczną się trząść.",
        point1:
          '2. Proszę kliknąć "x" w lewym górnym rogu ikony aplikacji ActTrader.',
      },
    },
    journey: "Proszę rozpocząć płynną podróż handlową z ActTrader:",
    heading:
      "AAAFx ActTrader obiecuje umożliwić użytkownikowi zbadanie wielu możliwości handlowych z dostosowanymi warunkami i możliwością przeglądu wszystkiego od zera.",
    features: "Kluczowe cechy platformy AAAFx ActTrader:",
    platform:
      "Wciąż się Państwo wahają? Proszę spojrzeć na krótki przegląd funkcji oferowanych przez platformę ActTrader:",
    depth: "Dogłębne narzędzia analityczne:",
    ul: {
      li: "Szeroki wybór już zainstalowanych wskaźników",
      li1: "Wiele narzędzi do rysowania na wykresach",
      li2: "Uproszczona praca z opcją handlu jednym kliknięciem",
      li3: "Skonfigurować kluczowe alerty cenowe, aby nigdy nie przegapić żadnej okazji.",
      li4: "Eksport danych konta bezpośrednio do programu Excel z najwyższą wygodą",
      liTag: "Dodawanie/usuwanie dodatkowej przestrzeni roboczej",
      liTag1: "Formatowanie ustawień daty/godziny",
      liTag2:
        "Dodaj kolory do swojego terminala handlowego i stwórz przyjemne miejsce pracy dla siebie",
      liTag3: "Strumieniuj ceny platformy tak, jak lubisz",
      liTag4: "Ponad 70 walut forex",
      liTag5: "Popularne towary, w tym złoto i ropa naftowa",
      liTag6: "11 globalnych indeksów - Nasdaq, Dow Jones itp.",
      liTag7: "6 głównych i najczęściej wymienianych kryptowalut",
    },
    tradingWindow: "Personalizacja okna handlowego:",
    instument: "Oferowane instrumenty:",
    liveAccount: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    demoAccount: "OTWARTE KONTO DEMO",
  },
  loginPage: {
    h3Tag: "Proszę czekać. Przekierowanie do Państwa konta",
  },
  compensation: {
    title: "Fundusz kompensacyjny",
    questions: {
      ques: "Czym jest Komisja Finansowa?",
      ans: "Komisja Finansowa jest unikalnie utworzonym niezależnym organem, który sprawia, że traderzy czują się bezpieczni i chronieni. Głównym celem Komisji Finansowej jest szybkie i skuteczne rozwiązywanie sporów między traderami a brokerami. Działa ona w sposób, w którym przejrzystość, szybkość i edukacja są nadrzędnymi wartościami. Wszystkie usługi Komisji Finansowej są całkowicie bezpłatne dla naszych klientów.",
      ques1: "Jak to działa?",
      ans1: "Fundusz Rekompensat jest finansowany przez Komisję Finansową poprzez alokację 10% składek członkowskich do funduszu, które są przechowywane na oddzielnym rachunku bankowym i nie mogą być wykorzystywane do finansowania operacji lub innych działań organizacji. Fundusz zapewnia klientom AAAFx zabezpieczenie w wysokości do 20.000 EUR w przypadku pojedynczej skargi.",
      ques2: "Dlaczego dołączyliśmy do Komisji Finansowej?",
      ans2: "Komisja Finansowa została utworzona przez wiodących specjalistów z branży, których głównym celem jest zwiększenie przejrzystości rynku i standardów usług w całej branży Forex. Jest to zgodne z tym, w co naprawdę wierzymy w AAAFx - uczciwość i przejrzystość. Utrzymywanie klientów w centrum naszej działalności jest jedną z naszych podstawowych ideologii. Dlatego też połączyliśmy siły z Komisją Finansową, aby zapewnić naszym klientom skuteczne i terminowe rozstrzyganie sporów.",
    },
    steps: "Jakie są etapy sporu",
    process: "Proces rozwiązywania?",
    complaint: "Skarga",
    pTag: "Klient może skontaktować się z Komisją, jeśli",
    brTag: "otrzymali Państwo oficjalną odpowiedź od",
    brTag1: "brokera w związku z nierozstrzygniętym sporem, który",
    brTag2: "klient uzna za niezadowalające.",
    investigation: "Dochodzenie",
    pTag1: "Gdy ich komisja ds. rozstrzygania sporów",
    brTag3: "otrzymał skargę, dochodzenie i",
    brTag4: "rozpoczynają się badania i podejmowana jest decyzja",
    brTag5: "w ciągu 1-2 tygodni.",
    text: "Wynagrodzenie",
    pTag2: "Gdy brokerzy odmawiają zastosowania się do decyzji",
    brTag6: "podjęte przez Komisję Finansową, a",
    brTag7: "rekompensata jest wypłacana przedsiębiorcy ze specjalnego",
    brTag8: "fundusz kompensacyjny.",
    decision: "Decyzja",
    resolutionRegarding: "Rezolucja komisji dotycząca",
    brTag9: "ocena sporu jest wiążąca dla",
    brTag10: "brokera i muszą być przestrzegane przez",
    brTag11: "brokera.",
  },
  zuluTools: {
    title: "ZULUTRADE",
    pTag: "Nie handluj sam - dołącz do największej sieci handlu społecznościowego",
    para: "W AAAFx mają Państwo szansę handlować z płynnością na poziomie instytucjonalnym i korzystać z naszych doskonałych warunków handlowych. Jednak handel może być czasami bardzo obciążający dla Państwa czasu, a także emocji, co może być przeszkodą dla udanego doświadczenia handlowego dla niektórych osób.",
    bTag: "W AAAFx mają Państwo szansę handlować płynnością na poziomie instytucjonalnym i korzystać z naszych doskonałych warunków handlowych. Jednak handel może być czasami bardzo obciążający dla Państwa czasu, jak również emocji, co może być przeszkodą dla udanego doświadczenia handlowego dla niektórych osób.",
    bTag1:
      "Założona w 2007 roku, ZuluTrade pomaga inwestorom w odkrywaniu wyjątkowych traderów z całego świata i kopiowaniu ich strategii, aby handlować dla siebie. Jest to internetowa platforma handlu społecznościowego i kopiowania, która umożliwia użytkownikom przyjęcie eksperckiego planu działania dla ich transakcji. Ocenia ona wyniki ekspertów i pozwala traderowi łatwo zauważyć i skopiować transakcje z ich portfela. Obecnie jest to jedna z najpopularniejszych sieci handlu społecznościowego.",
    copier: "Zostań kopistą",
    pTag1:
      "Dzięki naszemu rachunkowi ZuluTrade uzyskują Państwo automatyczny i bezpośredni dostęp do wielu możliwości osiągania zysków poprzez połączenie z Zulu.",
    brTag:
      "Mogą Państwo po prostu przejrzeć wyniki handlowe traderów-ekspertów, skopiować je i po prostu się zrelaksować!",
    register: "REJESTRACJA",
    master: "Zostań Mistrzem",
    pTag2:
      "Jeśli chcą Państwo zostać mistrzem handlu i chcą Państwo, aby inni mogli zobaczyć i skopiować Państwa doświadczenie handlowe, również mają Państwo taką możliwość. Państwa rachunek AAAFx jest automatycznie połączony z Zulu.",
    brTag1:
      "Mogą więc Państwo zarabiać na swoim rachunku handlowym, a także pobierać opłaty za wyniki od swoich kopiarek!",
    offers:
      "ZuluTrade oferuje różnorodne funkcje i produkty, niektóre z nich wymieniono poniżej:",
    platform: "Platforma społecznościowa ZuluTrade:",
    pTag3:
      "Niezależnie od tego, czy są Państwo inwestorami i chcą podzielić się udaną strategią inwestycyjną, czy też są Państwo inwestorami i chcą omówić inwestorów Zulu i ich wyniki, tutaj znajduje się jedno forum. ZuluTrade posiada rozbudowaną platformę społecznościową, która obejmuje blogi, dyskusje handlowe i kanały społecznościowe. Oznacza to możliwość interakcji ze społecznością inwestorów i uczenia się od nich.",
    zuluGuard: "ZuluTrade Guard:",
    pTag4:
      "ZuluTrade Guard oferuje ochronę rachunku poprzez monitorowanie zachowania eksperta i nie podąża za dostawcą sygnału w przypadku wprowadzenia jakichkolwiek zmian w strategii handlowej.",
    brTag2:
      "Robi to poprzez obliczenie wartości wyjścia dla otwartych transakcji na rachunku, a gdy próg zostanie osiągnięty, transakcje są zamykane",
    automator: "Automator:",
    pTag5:
      "Automator to skrót od Automated Trading. Odnosi się do handlu za pomocą wstępnie zdefiniowanych reguł wejścia i wyjścia z transakcji wykonywanych przez zautomatyzowany program. Pomaga to w eliminacji emocji handlowych i oszczędza czas.",
    combos: "Kombinacje:",
    pTag6:
      "Inwestorzy są grupowani przez ZuluTrade w kombinacje oparte na ich apetycie na ryzyko i strategiach. Inwestor może wybrać kombinację do naśladowania. Każda kombinacja jest zarządzana przez certyfikowany zespół ds. zarządzania portfelem Zulu Trade.",
    quickSteps: "Trzy szybkie kroki, aby rozpocząć kopiowanie:",
    openFund: "Proszę otworzyć i zasilić AAAFx",
    zuluAccount: "Rachunek ECN zulu",
    cred: "Proszę otrzymać dane logowania do Zulu w wiadomości e-mail",
    zuluTrade: "Proszę rozpocząć kopiowanie transakcji z Zulu Trade",
    openLive: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    openDemo: "OTWARTE KONTO DEMO",
  },
  zuluTrade: {
    mt4: "MT4",
    zulutrade: "ZuluTrade",
    h5Tag:
      "Ludzie mają tendencję do osiągania lepszych wyników w społecznościach i podążania za tymi, na których można polegać.",
    pTag: "AAAfx rozumie tę potrzebę i dlatego oferuje Państwu najbardziej poszukiwaną platformę Zulu Trade. Platforma Zulu Trade została założona w 2007 roku, w czasie, gdy na świecie brakowało odpowiedniego mechanizmu audytu praktyk handlowych i dzielenia się wiedzą handlową między sobą. Platforma ta wyeliminowała również potrzebę siedzenia godzinami przed ekranem i wprowadziła zautomatyzowany i profesjonalny handel finansowy do głównego nurtu.",
    brTag:
      "Zulu Trade to zautomatyzowana platforma transakcyjna, która zapewnia dogłębną analizę statystyczną najlepszych traderów, aby umożliwić użytkownikowi uzyskanie wglądu i ustanowienie systemu kopiowania transakcji i uzyskiwania przewagi",
    startTrading: "Proszę rozpocząć handel w zaledwie 3 prostych krokach:",
    openFund: "Proszę otworzyć i zasilić AAAFx",
    ecnPlus: "Rachunek handlowy ECN Zulu",
    variousTraders: "Analiza wyników różnych traderów.",
    copy: "Proszę wybrać sprzedawcę, którego chcą Państwo skopiować.",
    pTag1:
      "Mogą Państwo również wybierać spośród zdywersyfikowanych strategii zbudowanych z najlepszych kombinacji najlepszych inwestorów w Zulu Trade.Wybierz usługę Combo+ i uzyskaj swój rachunek zarządzany przez Certyfikowany Zespół Zarządzania Portfelem ZuluTrade w trybie w pełni automatycznym lub półautomatycznym, zgodnie z Państwa życzeniem!",
    ztp: "ZTP to platforma internetowa, do której dostęp można uzyskać tutaj",
    webBase: "Platforma internetowa",
    h3Tag:
      "AAAFx zapewnia wyjątkowe doświadczenie handlowe w połączeniu ze światowej klasy funkcjami ZTP:",
  },
  why: {
    title: "Dlaczego AAAFx?",
    honesty: "Doskonałość z uczciwością i przejrzystością",
    believe: "Dlaczego warto wierzyć w AAAFx?",
    pTag: "Mamy ponad dziesięcioletnią historię zapewniania naszym globalnym klientom niezawodnych i doskonałych usług. Zapewniamy naszym klientom pełną przejrzystość, aby mogli podejmować świadome decyzje.",
    brTag:
      "Wiemy, czego potrzeba, aby odnieść sukces jako inwestor, dlatego też naszym celem jest zapewnienie naszym klientom najwyższej jakości warunków handlowych i obsługi klienta. Jesteśmy dumni z tego, że jesteśmy jednym z najbardziej zaufanych brokerów na rynku forex, obsługującym zarówno klientów detalicznych, jak i instytucjonalnych.",
    listing: {
      point: "Bezpieczny i niezawodny broker",
      point1: "Błyskawiczna realizacja",
      point2: "Zero prowizji, surowe spready na rynku Forex",
      point3: "Głęboki basen płynności",
      point4: "3 platformy transakcyjne premium",
      point5: "Centra danych Equinix wyposażone w zaawansowaną technologię",
      point6: "14 lat doświadczenia",
      point7: "Kilka metod dokonywania bezpłatnych wpłat i wypłat",
    },
    more: "Co więcej?",
    socialTrading:
      "Automatyczne połączenie z największą społecznością handlową",
    entireTeam: "Cały zespół AAAFx jest natychmiast do Państwa dyspozycji!!!",
    pledge: "Zobowiązujemy się...",
    liTag:
      "Aby zapewnić Państwu usługę brokerską działającą w najlepszym interesie traderów.",
    liTag1:
      "Przestrzeganie zasad opublikowanych w odpowiednich ramach regulacyjnych.",
    liTag2:
      "Ciągłe poszukiwanie możliwości wprowadzania innowacji i improwizacji.",
    liTag3: "Przestrzeganie naszych podstawowych wartości przez cały czas.",
    founded: "ZAŁOŻONA W",
    serve: "KRAJE, KTÓRE OBSŁUGUJEMY",
    trade: "Instrumenty handlowe",
    platform: "Platformy, które oferujemy",
    support: "Wsparcie LIVE",
    number: {
      twoThousand: "2008",
      thirty: "30",
      twoHundred: "200+",
      three: "3",
      twentyFour: "24/5",
    },
    team: "Nasz zespół...",
    pTag1:
      "Indywidualnie nasze ideały mogą wydawać się oczywiste. Kiedy jednak połączymy je wszystkie razem, otrzymamy własną kulturę korporacyjną. To, kim jesteśmy, co reprezentujemy i jak działamy, jest kształtowane przez nasze wartości.",
    pTag2:
      "Nasze kierownictwo to zespół silnych i zdolnych profesjonalistów, którzy mają ogromne doświadczenie w pracy na Wall Street. Dlatego też dokładnie wiedzą, czego potrzeba, aby odnieść sukces jako trader. Dzięki swojemu ogromnemu doświadczeniu i doświadczeniu biznesowemu posiadają wnikliwą wiedzę na temat wszystkich najlepszych i najgorszych praktyk w branży.",
    wallStreet: "Osoby o silnej woli z dużym doświadczeniem w pracy na ulicy",
    innovation: "Nieustanne dążenie do innowacji i ulepszeń",
    approach: "Podejście zorientowane na klienta,",
    weDo: "we wszystkim, co robimy",
    values: "Nasze wartości, Państwa sukces!!!",
    pTag3:
      "Mamy solidne podstawy, ponieważ we wszystkich naszych biurach wspieramy środowisko oparte na wartościach, które jest napędzane silną wiarą naszego kierownictwa w etykę biznesową.",
    pTag4:
      "Trzymamy się naszych 5 podstawowych wartości, aby mogli Państwo zabłysnąć w globalnej społeczności handlowej.",
    h3Tag: "Zadowoleni klienci w ponad",
    countries: "30 krajów UE*",
    taking: ", biorąc",
    worldClass: "skorzystać z naszych światowej klasy usług.",
    france: "*Z wyjątkiem Belgii i Francji",
    info: "ΕΝΗΜΕΡΩΤΙΚΑ ΣΤΟΙΧΕΙΑ ΕΤΑΙΡΕΙΑΣ/INFORMACJE O FIRMIE",
    data: "ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ/DANE FINANSOWE",
    date: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2024",
    thirtyFirst: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2023",
    thirty: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2023",
    financeStatement: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2022",
    financialData: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2022",
    statement: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2021",
    aTag: {
      li: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2021",
      liTag: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2020",
      liTag1: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2020",
      liTag2: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2019",
      liTag3: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2019",
      liTag4: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2018",
      liTag5: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2018",
      liTag6: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2017",
      liTag7: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2017",
      liTag8: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2016",
      liTag9: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2016",
      li1: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2015",
      li2: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2015",
      li3: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2014",
      li4: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2014",
      li5: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2013",
      li6: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2013",
      li7: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2012",
      li8: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2012",
      li9: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2011",
      liTag10: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2011",
      liTag11: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2010",
      liTag12:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 31-12-2015",
      liTag13:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 31-12-2014",
      liTag14:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 31-12-2013",
      liTag15:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 31-12-2012",
      liTag16:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 31-12-2011",
      liTag17:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 31-12-2010",
    },
    dropdown: {
      title: "ΕΠΟΠΤΙΚΕΣ ΠΛΗΡΟΦΟΡΙΕΣ/INFORMACJE NADZORCZE",
      aTag2: {
        pillar2023:
          "Raport w sprawie dyscypliny rynkowej i ujawniania informacji w ramach filaru III za 2023 r.",
        pillar2022:
          "Raport w sprawie dyscypliny rynkowej i ujawniania informacji w ramach III filaru na rok 2022",
        pillar2021:
          "Raport w sprawie dyscypliny rynkowej i ujawniania informacji w ramach III filaru na 2021 r.",
        regulatory2023:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2023_α80&87_Ν4261_2014",
        corporateGovernance2022:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2022_α80&87_Ν4261_2014",
        financial2021:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2021_α80 ΕΩΣ 87_Ν4261_2014",
        financial2020:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2020",
        financial2019:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2019",
        financial2018:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2018",
        financial2017:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2017",
        financial2016:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2016",
        financial2015:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2015",
        financial2014:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2014",
        financial2013:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2013",
        financial2012:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2012",
        financial2011:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2011",
        financial2010:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2010",
        details2020:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2020_α80 ΕΩΣ 87_Ν4261_2014",
        details2019:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2019_α80 ΕΩΣ 87_Ν4261_2014",
        details2018:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2018_α80 ΕΩΣ 87_Ν4261_2014",
        details2017:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2017_α80 ΕΩΣ 87_Ν4261_2014",
        details2016:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2016_α80 ΕΩΣ 87_Ν4261_2014",
        details2015:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2015_α81&82_Ν4261_2014",
        details2014b:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2015_α80 ΕΩΣ 87_Ν4261_2014",
        details2014:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2014_α81&82_Ν4261_2014",
      },
    },
    announcment: "ΑΝΑΚΟΙΝΩΣΕΙΣ/ANNOUNCEMENTS",
    aTag3: {
      executionVenues2023:
        "2023 ΤΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2023 MIEJSCA WYKONANIA",
      executionVenues2022:
        "2022 ΤΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2022 MIEJSCA WYKONANIA",
      executionVenues2021:
        "2021 ΤΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2021 MIEJSCA WYKONANIA",
      executionVenues2020:
        "2020 TΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2020 MIEJSCE WYKONANIA",
      executionVenues2019:
        "2019 TΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2019 MIEJSCE WYKONANIA",
      executionVenues2018:
        "2018 TΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2018 MIEJSCE WYKONANIA",
      executionVenues2017:
        "2017 TΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2017 MIEJSCE EGZEKUCJI",
      generalMeetingInvite2013:
        "ΠΡΟΣΚΛΗΣΗ ΤΑΚΤΙΚΗΣ ΓΕΝΙΚΗΣ ΣΥΝΕΛΕΥΣΗΣ 28-06-2013",
    },
    accordion: "ΟΡΓΑΝΟΓΡΑΜΜΑ/ SCHEMAT ORGANIZACYJNY FIRMY",
    officialOrganization: "AAAFx - Oficjalny schemat organizacyjny (HCMC)",
    certifiedEmploy: {
      title: "ΠΙΣΤΟΠΟΙΗΜΕΝΟΙ ΥΠΑΛΛΗΛΟΙ/CERTYFIKOWANI PRACOWNICY",
    },
    name: "NAZWA",
    cretificate: "CERTYFIKACJA",
    issuer: "WYDAWCA",
    year: "ROK",
    table: {
      td: "DIMOPOULOS CHRISTOS",
      td1: "Przyjmowanie, przekazywanie i realizacja zleceń w imieniu osób trzecich w zakresie papierów wartościowych (A1)",
      td2: "HCMC",
      td0: "DORDA AIKATERINI",
      td3: "Przyjmowanie, przekazywanie i realizacja zleceń w imieniu osób trzecich w zakresie papierów wartościowych (A1)",
      td4: "KARLIS KONSTANTINOS",
      td5: "Zarządzanie portfelem klienta (C)",
      td6: "KONTOGEORGI ELENI",
      td7: "Przyjmowanie, przekazywanie i realizacja zleceń w imieniu osób trzecich w zakresie papierów wartościowych (A1)",
      td8: "TZIANOUMI GIANNOULA",
      td9: " Świadczenie usług doradztwa inwestycyjnego w zakresie papierów wartościowych, jednostek uczestnictwa w przedsiębiorstwach zbiorowego inwestowania, instrumentów rynku pieniężnego, instrumentów pochodnych i strukturyzowanych produktów finansowych (B)",
      td10: "Inwestor w papiery wartościowe",
      td11: "ASE",
      td12: "POLYCHRONEAS EFSTRATIOS",
      td13: "Przeprowadzanie analiz instrumentów finansowych lub emitentów (D)",
    },
    maria: "CHRYSAITOU MARIA ARGYRO",
    investment:
      "Świadczenie usług doradztwa inwestycyjnego w zakresie papierów wartościowych, jednostek uczestnictwa w przedsiębiorstwach zbiorowego inwestowania, instrumentów rynku pieniężnego, instrumentów pochodnych i strukturyzowanych produktów finansowych (B)",
    text: "PANAGIOTIS KOURBELIS",
    text1: "dział handlowy dla praktyków",
    text2: "GEORGIOS KARMIS",
    responsive: {
      trTag: {
        line: "ΟΝΟΜΑΤΕΠΩΝΥΜΟ",
        line1: "ΠΙΣΤΟΠΟΙΗΣΗ",
        line2: "ΦΟΡΕΑΣ",
        line3: "ΕΤΟΣ ΚΤΗΣΗΣ/ΑΝΑΝΕΩΣΗΣ",
        line4: "Δημόπουλος Χρήστος",
        line5: "Λήψη, Διαβίβαση και Εκτέλεση Εντολών σε Κινητές Αξίες (Α1)",
        line6: "Επιτροπή Επιτροπή",
        line7: "Καρλής Κωνσταντίνος",
        line8: "Διαχείριση Χαρτοφυλακίων (Γ)",
        line9: "Επιτροπή Κεφαλαιαγοράς",
        line10: "Κοντογεώργη Ελένη",
        line11: "Ντόρντα Αικατερίνη",
        line12: "Ντόρντα Αικατερίνη Εκτέλεση Εντολών σε Κινητές Αξίες (Α1)",
        line13: "Τζιανούμη Γιαννούλα",
        line14: "Παροχή Επενδυτικών Συμβουλών (Β)",
        line15: "Παναγιώτης Κουρμπέλης",
        line16: "Ασκούμενος Trading Desk",
        line17:
          "ΓΝΩΣΤΟΠΟΙΗΣΕΙΣ ΚΑΝΟΝΙΣΜΟΥ ΑΕΙΦΟΡΙΑΣ (SFDR)/SUSTAINABILITY REGULATION DISCLOSURES (SFDR)",
        line18:
          "Ujawnianie informacji dotyczących regulacji w zakresie zrównoważonego rozwoju (SFDR)",
        line19:
          "Γνωστοποιήσεις Κανονισμού Αειφορίας (SFDR) και Πολιτική Βιωσιμότητας (ESG)",
        line20: "Πιστοποιημένος Διαπραγματευτής Αξιών",
        line21: "Χρηματιστήριο Αξιών Αθηνών",
        line22: "Χρυσαΐτου Μαρία Αργυρώ",
        line23: "Γεώργιος Καρμής",
      },
    },
  },
  faq: {
    heading: "Często zadawane pytania",
  },
  comparePlatform: {
    heading: "Proszę porównać platformy transakcyjne",
    content: '"Im więcej tym lepiej"',
    h6Tag:
      "AAAFx zapewnia kompleksowe i najlepsze rozwiązanie dla potrzeb każdego inwestora dzięki mnogości oferowanych platform transakcyjnych.",
    pTag: "Każda platforma oferuje podstawowe zasady najszybszej realizacji zleceń, różne konfigurowalne opcje, umożliwiające korzystanie ze wskaźników i doradców eksperckich oraz najlepsze dostępne ceny rynkowe.",
    condition: "Warunki handlowe",
    timeFrames: "Ramy czasowe",
    leverage: "Dźwignia finansowa",
    microLot: "Handel mikrolotami",
    yes: "Tak",
    scalping: "Hedging i Scalping",
    attachment: "Załącznik EA/Wskaźniki",
    other: "Inne narzędzia",
    economic: "Wbudowany kalendarz ekonomiczny",
    no: "Nie",
    report: "Format raportów konta",
    html: "HTML",
    language: "Konwerter języków platform",
    priceAlert: "Alerty cenowe",
    device: "Kompatybilność operacyjna urządzenia",
    window: "Pulpit Windows",
    mac: "Mac/iPad",
    android: "Android",
    ios: "iOS",
    webBased: "Internetowy",
    sutability: "Przydatność",
    beginner: "Początkujący",
    intermediate: "Produkty pośrednie",
    advance: "Zaawansowany",
    openAccount: "Otwarte konto",
    platform: "Którą platformę wybrałby Pan dla siebie?",
    choice:
      "To może być trudny wybór. Poniżej przedstawiamy, co mogą Państwo rozważyć:",
    point: "Jak łatwy jest dla Państwa interfejs użytkownika?",
    point1: "Która platforma pasuje do Państwa strategii handlowych?",
    point2: "Czy mają Państwo wsparcie dla tej platformy?",
    point3:
      "Jeśli chodzi o ostatnie pytanie, jesteśmy do Państwa dyspozycji. Zapewniamy pełne wsparcie techniczne w przypadku jakichkolwiek problemów z jakąkolwiek platformą.",
    point4: "W przypadku pozostałych dwóch pytań może Pan/Pani otworzyć plik",
    point5: "Konto demo",
    point6:
      "i poznać wszystkie niuanse naszych fantastycznych platform transakcyjnych!",
  },
  depWith: {
    heading: "Wpłaty i wypłaty",
    title:
      "Różnorodność łatwych i wygodnych opcji, bez żadnych kosztów z naszej strony",
    pTag: "Wpłaty i wypłaty z Państwa rachunku handlowego nigdy nie były tak proste! Proszę zainwestować w swój rachunek handlowy bez ponoszenia dodatkowych opłat. Mamy różne niezawodne opcje wpłat i wypłat, aby Państwa podróż handlowa była płynna i łatwa.",
    serviceFee: "0% Opłata za usługę",
    charge: "Nie pobieramy żadnych opłat ani od wpłat, ani od wypłat",
    safety: "Bezpieczeństwo transakcji",
    funds:
      "Fundusze są przechowywane w bankach Tier-1 i są oddzielone od funduszy własnych firmy",
    quickProcessing: "Szybkie przetwarzanie",
    deposit: "Wpłaty i wypłaty w AAAFX są przetwarzane natychmiastowo",
    minDeposit: "Minimalna kwota depozytu",
    globalCurrency: "Akceptowane waluty globalne",
    control: "Zwiększona kontrola",
    security: "Obowiązkowy KYC zapewnia większe bezpieczeństwo",
    with: "WYCOFANIA",
    seamless:
      "Bezproblemowe wypłaty uszczęśliwiają każdego tradera, prawda? Do tego właśnie dążymy dla naszych klientów. Oto kilka szybkich i łatwych opcji wypłaty Państwa ciężko zarobionych pieniędzy w ciągu 12 godzin.",
    step: "Kroki, aby wypłacić środki z Państwa rachunku AAAFx Live:",
    step1: "1. Proszę zalogować się do Portalu Klienta.",
    step2:
      '2. Proszę skonfigurować konto bankowe w sekcji "Konfiguracja banku".',
    step3: '3. Proszę kliknąć "Środki", a następnie "Wypłać".',
    depositText: "Depozyt",
    withdrawal: "Wypłaty",
    bankCard: "Karty bankowe",
    region: "Region",
    currencies: "Waluty",
    min: "Min. Depozyt",
    service: "Opłata za usługę",
    processing: "Czas przetwarzania",
    worldWide: "Na całym świecie",
    instant: "NATYCHMIAST",
    fund: "FUNDUSZ",
    bankWire: "Przelew bankowy",
    days: "2-3 DNI ROBOCZE",
    europe: "Europa",
    southEast: "Azja Południowo-Wschodnia",
    latinAmerica: "Ameryka Łacińska",
    mexico: "Meksyk",
    eastAfrica: "Afryka Wschodnia",
    global: "Globalny",
    info: "Dodatkowe informacje:",
    step4:
      "1. wszystkie wypłaty będą przetwarzane za pomocą metody, która została użyta do dokonania wpłaty na rachunek handlowy.",
    step5:
      "2) AAAFx nie pobiera żadnych opłat transakcyjnych ani od wpłat, ani od wypłat.",
    step6:
      "3. zwracamy koszty transakcji poniesione przez Państwa do wysokości 5% kwoty depozytu na Państwa rachunek handlowy.",
    live: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    demo: "OTWARTE KONTO DEMO",
  },
  whiteLabels: {
    banner: {
      menu: {
        white_label: "White Label",
      },
      title: "White Label",
      subtitle: "Nasze doświadczenie, Państwa sukces!",
    },
    pamm_content: {
      intro: {
        heading:
          "Wyjątkowa okazja do założenia własnej firmy brokerskiej z pomocą naszej wiedzy, doświadczenia i wsparcia.",
      },
      description: {
        paragraph_1:
          "Program white-label to świetny sposób na szybkie zdobycie silnej pozycji na rynku. Jest to możliwe dzięki wykorzystaniu naszej technologii, nienagannych warunków handlowych, usług wsparcia i przydatnych narzędzi CRM back-office.",
        paragraph_2:
          "Zespół AAAFx jest oddany Państwa sukcesowi dzięki naszemu technicznemu i profesjonalnemu wsparciu.",
        paragraph_3:
          "Nasz program white label oferuje pełną elastyczność w projektowaniu produktów i usług, dzięki czemu mogą Państwo uzyskać najlepszą okazję do rozwoju swojego przedsięwzięcia.",
        paragraph_4:
          "Wybór odpowiedniego brokera jest pierwszym krokiem do osiągnięcia Państwa celów.",
        paragraph_5:
          "Proszę się przygotować i dokonać właściwego wyboru już teraz!",
      },
    },
    expectations_section: {
      heading: "Czego się spodziewać?",
      list: {
        item_1: "Współpraca z największą siecią handlu społecznościowego",
        item_2: "Dedykowani opiekunowie klienta dla inwestorów i menedżerów",
        item_3: "Elastyczność w ustalaniu parametrów i warunków konta",
        item_4: "Bardzo niskie prowizje z surowymi spreadami",
        item_5: "Bezpieczeństwo środków u zaufanego brokera",
        item_6: "Niewielka inwestycja wymagana do rozpoczęcia",
        item_7: "Przejrzystość dla inwestorów - brak ukrytych klauzul",
        item_8: "Pełna kontrola dla inwestorów związana z wpłatami i wypłatami",
      },
    },
    contact_section: {
      title:
        "Czy są Państwo gotowi na otrzymanie spersonalizowanych rozwiązań dla swojego nowego przedsięwzięcia?",
      contact_us: "Proszę skontaktować się z nami teraz",
      email_link: "tutaj",
      email_info: "lub proszę do nas napisać na adres",
      email_address: "support{'@'}aaafx.com",
    },
  },
  vpsHosting: {
    banner: {
      title: "Darmowy hosting VPS",
    },
    bonus_trade_section: {
      description:
        "Mogą Państwo wygodnie handlować z dowolnego miejsca na świecie bez przerw w połączeniu i nie martwić się o przerwy w dostawie Internetu lub prądu. Ważne jest, aby zminimalizować wszelkie opóźnienia podczas handlu, ponieważ niewielkie opóźnienie może kosztować Państwa fortunę.",
      customer_approach:
        "Zgodnie z naszym podejściem zorientowanym na klienta, zawsze chcemy, aby nasi klienci mieli jak najlepsze doświadczenie handlowe. AAAFx oferuje usługi wirtualnego serwera prywatnego, bez żadnych dodatkowych kosztów dla Państwa.",
      advantages_title: "Zalety handlu przy użyciu VPS",
      advantages_list: {
        item_1:
          "VPS umożliwia realizację Państwa transakcji w dowolnym momencie z minimalnym opóźnieniem, co skutkuje mniejszym poślizgiem.",
        item_2:
          "VPS zapewnia niekończące się działanie platformy handlowej i sprawia, że jest ona bardziej odpowiednia, jeśli korzystają Państwo z robotów handlowych lub sygnałów handlowych.",
        item_3:
          "Pozwala to na handel z dowolnego miejsca na świecie, nawet jeśli odpowiednie połączenie internetowe nie jest dostępne, zabraknie prądu lub system ulegnie awarii.",
        item_4:
          "VPS zapewnia anonimowość, prywatność i bezpieczeństwo, dzięki czemu mogą Państwo spokojnie handlować, wiedząc, że najważniejsze dane są bezpieczne.",
      },
    },
    accordion_section: {
      how_to_get_vps: {
        title: "Jak mogę otrzymać darmowy serwer VPS?",
        content:
          "Jeśli są Państwo klientem z nieznacznie wysokim wolumenem obrotu (z depozytem w wysokości co najmniej 5000 USD), kwalifikują się Państwo do bezpłatnego VPS.",
      },
      why_free_vps: {
        title: "Dlaczego AAAFX oferuje darmowy VPS?",
        content:
          "Nasz partner technologiczny zapewnia nam tani hosting VPN w zamian za wysokie wolumeny. Lubimy przekazywać korzyści, które uzyskujemy, naszym klientom.",
      },
      lesser_deposit: {
        title: "Co jeśli mój depozyt jest niższy?",
        content:
          "To żaden problem. Nadal mogą Państwo skorzystać z naszego VPS za bardzo niską opłatą w wysokości zaledwie 25 USD miesięcznie. Opłata ta zostanie automatycznie pobrana z Państwa konta handlowego.",
      },
      other_vps: {
        title:
          "Co jeśli chcę użyć innego VPS zamiast VPS oferowanego przez AAAFx?",
        content:
          "Jeśli chcą Państwo korzystać z własnego serwera VPS lub od strony trzeciej, możemy zapewnić zwrot kosztów serwera VPS w wysokości do 25 USD/miesiąc, pod warunkiem, że całkowity depozyt netto za dany miesiąc wynosi co najmniej 5000 USD. Aby skorzystać z tego zwrotu, proszę udostępnić nam szczegóły zakupu VPS i potwierdzenie miesięcznej płatności.",
      },
    },
    vps_configuration_section: {
      title: "Bezpłatna konfiguracja VPS",
      configuration: {
        intel: {
          title: "INTEL",
          description: "Procesor",
        },
        ram: {
          title: "1300 MB",
          description: "RAM",
        },
        bandwidth: {
          title: "25 GB",
          description: "Przepustowość",
        },
        disk_space: {
          title: "2 TB",
          description: "Miejsce na dysku",
        },
      },
    },
    apply_vps_section: {
      title: "Jak ubiegać się o darmowy VPS?",
      steps: {
        step_1: {
          description: "Proszę otworzyć rachunek rzeczywisty",
        },
        step_2: {
          description:
            "Depozyt minimum 5 000 USD lub równowartość w innej walucie",
        },
        step_3: {
          description: "Proszę napisać do nas na adres",
          email: "support{'@'}aaafx.com",
        },
      },
    },
  },
  tradingCondition: {
    heading: "Warunki handlowe",
    pTag: "Funkcje, które sprawią, że będą Państwo handlować z większym zyskiem! Środowisko handlowe najlepiej dostosowane do wszystkich rodzajów strategii handlowych.",
    h5Tag:
      "Proszę zapoznać się ze wszystkimi warunkami, aby zaplanować nienaganne doświadczenie handlowe:",
    content:
      "AAAFx przedstawia warunki handlowe odpowiednie dla każdego inwestora - zarówno początkującego, jak i eksperta. Chcemy, aby nasi klienci mogli handlować z najwyższą pewnością i komfortem.",
    deepLiquidity: "Handel ECN z dużą płynnością",
    buySell:
      "Rachunki ECN (Electronic Communication Network) są przeznaczone do dopasowywania zleceń kupna i sprzedaży poprzez bezpośredni dostęp do dostawców płynności.",
    brTag:
      "Za pośrednictwem naszych Prime LP jesteśmy w stanie przekazywać najlepsze ceny rynkowe i płynność wszystkim naszym klientom w płynny sposób. Dzięki temu uzyskują Państwo natychmiastowy dostęp do głębokiej puli płynności przy znikomych kosztach spreadu.",
    powerfulArsenal: "AAAFx Potężny arsenał handlowy",
    arsenalContent:
      "Wiemy, jak ważny jest wybór odpowiedniej platformy transakcyjnej do realizacji Państwa strategii handlowej! Zadbaliśmy o wszystkie Państwa wymagania, aby handlować szybko dzięki łatwej nawigacji i interfejsowi użytkownika oraz zarabiać na ponad 200 instrumentach handlowych dostępnych na trzech pełnych platformach handlowych - MT4, MT5, ActTrader. Wisienką na torcie jest połączenie z Zulu Trade za pośrednictwem konta Zulu, które pomoże Państwu natychmiast połączyć się z największą społecznością handlową.",
    zeroCommission: "Zero prowizji i cienkie jak brzytwa spready",
    commissionContent:
      "Zapewniamy Państwu najlepsze warunki do handlu po najniższych kosztach. Dzięki naszemu rachunkowi ECN plus mogą Państwo handlować bez prowizji na wszystkich parach Forex. Dzięki ultra cienkim spreadom zaczynającym się od 0,0 pipsa na wszystkich naszych instrumentach handlowych, mogą Państwo zacząć korzystać z naszej instytucjonalnej płynności po bardzo niskich kosztach. Otrzymujemy te warunki handlowe od naszych najlepszych dostawców płynności, aby zapewnić Państwu najlepszą obsługę w Państwa podróży handlowej.",
    fastExecution: "Błyskawiczna realizacja",
    executionContent:
      "Najwyższa jakość i lokalizacja naszych serwerów umożliwia najszybszą możliwą realizację transakcji z prędkością nawet 10 ms. Mogą Państwo składać zlecenia handlowe do 100 lotów. Są Państwo wolni od opóźnień, rekwotowań i dealing desków. Dzięki temu nasza platforma jest idealna dla wszystkich rodzajów traderów - scalperów, początkujących, użytkowników EA, traderów manualnych itp.",
    fundingOptions: "Różnorodność opcji finansowania",
    fundingContent:
      "Bezproblemowe wpłaty i wypłaty znacznie ułatwiają i usprawniają Państwa podróż handlową. Mogą Państwo wybrać metodę wpłaty spośród wielu dostępnych opcji. Wiemy, że przy zasilaniu Państwa rachunków handlowych liczy się każdy grosz. Dlatego też nie pobieramy żadnych opłat podczas przyjmowania wpłat lub przetwarzania wypłat. Wypłaty są przetwarzane bardzo szybko i bezproblemowo, a do wyboru mają Państwo różne tryby wypłat.",
    lowRollover: "Niskie opłaty za rolowanie",
    rolloverContent:
      "Wielu traderów lubi przetrzymywać swoje transakcje przez noc i w tym celu stawki swap mają znaczenie. Każda para handlowa ma własne opłaty swapowe (z wyjątkiem kont islamskich). Stawki te są stosowane o godzinie 00:00 czasu serwera. Rynki są zamknięte w weekend, jednak banki nadal naliczają odsetki nawet od pozycji utrzymywanych w weekend. Tak więc, jeśli utrzymują Państwo pozycję przez noc w piątek, poniosą Państwo 3-krotne koszty swapu. Oferujemy konkurencyjne i niskie opłaty swapowe, dzięki czemu mają Państwo większą elastyczność w decydowaniu, kiedy chcą zamknąć swoje transakcje.",
    doubt:
      "Mają Państwo wątpliwości co do warunków handlowych? Proszę spróbować",
    demoAccount: "Konto demo",
    stayAware: "Proszę być świadomym i korzystać z obszernych informacji",
    calculate: "Kalkulatory handlowe",
    getAll: "aby wszystkie liczby się zgadzały!",
    liveAccount: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    openAccount: "OTWARTE KONTO DEMO",
  },
  tradingCalculator: {
    title: "Kalkulatory handlowe",
    madeEasy: "Łatwe obliczenia dla Państwa",
    neverMiss: "Nigdy nie trać zysków handlowych z powodu złych obliczeń!",
    pTag: "Dzięki naszym kalkulatorom handlowym mogą Państwo w mgnieniu oka dokonać dokładnej oceny sytuacji. Dokładamy wszelkich starań, aby pomóc Państwu jak najlepiej wykorzystać swoje transakcje, oszczędzając czas i skupiając całą uwagę na kluczowych decyzjach handlowych, zamiast angażować się w żmudne obliczenia. Wybraliśmy najbardziej przydatne kalkulatory do handlu i umieściliśmy je tutaj dla Państwa. Nie muszą Państwo niczego pobierać. Wystarczy wybrać żądany kalkulator, wprowadzić dane wejściowe, a kalkulator poda odpowiedź!",
    swap: "Kalkulator zamiany",
    margin: "Kalkulator marży",
    pip: "Pip Kalkulator",
    calculate: "Kalkulator",
  },
  forexStock: {
    innerPages: {
      forex: "Forex",
      indices: "Wskaźniki",
      commodities: "Towary",
      stocks: "Akcje",
      crypto: "Kryptowaluty",
    },
    title: "FOREX",
    trade: "Handel na znanych parach forex z AAAFx",
    min: "min.",
    commission: "Komisja",
    execution: "wykonanie",
    spread: "Rozprzestrzenianie się",
    upTo: "Do",
    leverage: "Dźwignia finansowa",
    paris: "Pary",
    contract: "Kontrakt Forex",
    specification: "Specyfikacje",
    flexible:
      "Bardziej elastyczne warunki handlowe (zwiększona dźwignia) mogą mieć zastosowanie w przypadku klientów sklasyfikowanych jako Profesjonalni. Proszę zalogować się na swoje konto i sprawdzić, czy kwalifikujesz się do klasyfikacji Klienta Profesjonalnego lub napisać do nas na adres",
    email: "support{'@'}aaafx.com",
    instument: "Instrument",
    bid: "Bid",
    ask: "Proszę pytać",
    size: "Wielkość kontraktu",
    minTrade: "Min. Rozmiar handlowy",
    tickValue: "Wartość ticka",
    hours: "Godziny handlu",
    h3Tag: "Czym jest handel na rynku Forex?",
    pTag: "Rynek Forex jest ekspansywnym globalnym rynkiem wymiany walut międzynarodowych. Handel na rynku Forex to ogólne kupno i sprzedaż walut z głównym zamiarem osiągnięcia zysku. Globalny rynek Forex jest największym i najbardziej płynnym rynkiem na świecie, z dziennym wolumenem transakcji przekraczającym 6 bilionów dolarów.",
    how: "Jak to działa?",
    trading:
      "Handel na rynku Forex polega na kupowaniu jednej waluty i sprzedawaniu jej za inną walutę po obowiązującym rynkowym kursie wymiany. Nie ma dostawy żadnej waluty, a różnica między ceną sprzedaży a ceną kupna jest po prostu korygowana na rachunku handlowym. W związku z tym te pary walutowe są jak kontrakty CFD na rynku Forex po cenach spot. Jeśli chcą Państwo handlować na głównym rynku forex, będą Państwo musieli wyłożyć setki tysięcy dolarów. Jednak dzięki dźwigni finansowej i kontraktom CFD wystarczy zaledwie 100 jednostek waluty i można zacząć czerpać korzyści z ruchów cen. Co więcej, mogą Państwo również skorzystać z różnicy w stopach procentowych między dwiema walutami za pośrednictwem stawek swap. Jeśli utrzymują Państwo otwartą pozycję w parze walutowej przez noc, a oprocentowanie waluty, którą Państwo kupili jest wyższe niż oprocentowanie waluty, którą Państwo sprzedali, uzyskają Państwo pewien dochód z odsetek. W przeciwnym razie zapłacą Państwo pewną opłatę. Odsetki te znane są jako stopa swap lub stopa rollover.",
    account: "Konto",
    type: "Rodzaje",
    compare: "Proszę porównać rodzaje kont",
    online: "Nasze Online",
    tradingText: "Handel",
    platform: "Platformy",
    desktop: "Pulpit",
    webTrade: "Web Trader",
    android: "Android",
    ios: "iOS",
    learn: "DOWIEDZ SIĘ WIĘCEJ",
    negative: "Ujemne saldo",
    protection: "Ochrona",
    pSubTag: "Niezawodna ochrona Państwa środków na rachunkach AAAFx",
    pTag1:
      "Zawsze staramy się działać w najlepszym interesie naszych klientów. Podczas handlu w niestabilnych czasach, jeśli Państwa rachunek osiągnie wartość ujemną, jesteśmy do Państwa dyspozycji! Zresetujemy ujemne saldo do zera, aby nie ponosili Państwo żadnych dodatkowych strat. Mogą Państwo dokonać wpłaty i ponownie rozpocząć handel. W związku z tym nie mogą Państwo stracić więcej niż wpłacona kwota.",
    live: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    demo: "OTWARTE KONTO DEMO",
  },
  pageNotFound: {
    title:
      "Strona, której Państwo szukają, mogła zostać usunięta, jej nazwa uległa zmianie lub jest tymczasowo niedostępna.",
    redirect: "Proszę przejść do strony głównej AAAFx",
  },
  annualLoser: {
    winner: "Zwycięzca",
    loser: "Przegrani",
    total: "Ogółem",
    percentage: "Odsetek przegranych",
    annually: "Rocznie",
    semi_annually: "Co pół roku",
    quaterly: "Kwartalnie",
    monthly: "Miesięcznie",
  },
  safetyFund: {
    title: "Bezpieczeństwo funduszy",
    heading: "Uczciwość, zaufanie i pełna niezawodność",
    safety: "Bezpieczeństwo i ochrona funduszy",
    investor:
      "Inwestorzy powinni skupić cały swój czas i energię na budowaniu skutecznych strategii, zamiast martwić się o bezpieczeństwo swoich funduszy.",
    protect:
      "Jesteśmy tutaj, aby chronić Państwa środki, ponieważ nasze fundamenty opierają się na Państwa zaufaniu. Chcemy, aby inwestowali Państwo mądrze i bezpiecznie.",
    heading1: "REGULOWANE I STRZEŻONE",
    strict:
      "Zgodność z rygorystycznymi ramami regulacyjnymi Greckiej Komisji Rynku Kapitałowego UE (HCMC)",
    responsible: "ODPOWIEDZIALNY POWIERNIK",
    client:
      "Pieniądze klienta są bezpiecznie przechowywane na bezpiecznych rachunkach bankowych w zaufanych bankach.",
    audit: "DEDYKOWANE AUDYTY I",
    review: "PRZEGLĄDY ZGODNOŚCI",
    internal:
      "Audyty wewnętrzne i zewnętrzne, dedykowana funkcja zgodności w celu ciągłego przeglądu stosowania procedur dotyczących aktywów klienta.",
    negativeBalance: "OCHRONA PRZED UJEMNYM SALDEM",
    pTag: "Klienci nie mogą stracić więcej niż wynosi saldo ich konta. Jeśli ich saldo będzie ujemne, zresetujemy je do zera",
    funds: "ODDZIELNE FUNDUSZE I REJESTRY",
    companyFunds:
      "Ścisła segregacja między funduszami klientów i firmy. Utrzymywane jest wyraźne rozróżnienie między funduszami/zapisami klientów a funduszami/zapisami spółki.",
    policies: "SOLIDNA POLITYKA INFORMATYCZNA",
    secure:
      "Bezpieczne gniazda internetowe w witrynie, technologia Cloudflare i uwierzytelnianie dwuskładnikowe (2FA) dostępne dla wszystkich kont klientów.",
    investorFund: "FUNDUSZ REKOMPENSAT DLA INWESTORÓW",
    perPerson:
      "Inwestorzy AAAFx są chronieni do kwoty 30 000 euro na osobę przez Grecki Fundusz Gwarancyjny zgodnie z Dyrektywą Europejską 93/22/EWG.",
    security: "Zawsze staramy się zapewnić Państwu bezpieczeństwo.",
    awareness: "Ale Państwa świadomość i czujność są równie ważne:",
    never: "Nigdy",
    click: "klikać niezidentyfikowanych linków w wiadomościach e-mail.",
    unSecured:
      "korzystać z niezabezpieczonych sieci bezprzewodowych lub jakichkolwiek urządzeń publicznych w celu uzyskania dostępu do kont finansowych.",
    otps: "odpowiadać na wiadomości e-mail lub SMS, w których wymagane są dane osobowe lub OTP.",
    websites:
      "podawać swoich danych osobowych lub finansowych na niezabezpieczonych stronach internetowych.",
    leave:
      "pozostawiać urządzenia bez nadzoru, gdy są Państwo zalogowani do zabezpieczonych kont osobistych lub finansowych.",
    twoFa: "obsługiwać konto finansowe bez 2FA.",
  },
  regulations: {
    title: "Przepisy i licencje",
    multiple:
      "Posiadamy wiele rejestracji i regulacji na całym świecie. Pełna przejrzystość naszych danych rejestracyjnych oznacza większą niezawodność, bezpieczeństwo i spokój ducha dla naszych klientów!",
    capitalMarket: "Grecka Komisja Rynku Kapitałowego (HCMC), Grecja",
    member:
      "Triple A Experts Investment Services Single Member SA jest autoryzowana i regulowana w Unii Europejskiej przez Grecką Komisję Rynku Kapitałowego. (id:2/540/17.2.2010) Numer Identyfikacji Podatkowej: 998281207.",
    h5Tag: "O HCMC",
    pTag: "Grecka Komisja Rynku Kapitałowego (HCMC) została utworzona jako podmiot prawny w Grecji w celu nadzorowania właściwego stosowania przepisów dotyczących rynku kapitałowego. HCMC jest członkiem Europejskiego Urzędu Nadzoru Giełd i Papierów Wartościowych (ESMA) oraz Międzynarodowej Organizacji Komisji Papierów Wartościowych (IOSCO).",
    about: "Informacje o MiFID II",
    adopted:
      "Parlament Europejski i Rada przyjęły Dyrektywę 2014/65/UE z dnia 15 maja 2014 r. w sprawie rynków instrumentów finansowych oraz zmieniającą dyrektywę 2002/92/WE i dyrektywę 2011/61/UE (wersja przekształcona) (MiFID II), która weszła w życie w dniu 03/01/2018. Jej celem jest regulacja rynków instrumentów finansowych na potrzeby świadczenia usług inwestycyjnych i prowadzenia działalności inwestycyjnej na terenie Europejskiego Obszaru Gospodarczego (EOG). Dyrektywa MiFID została włączona do greckiego ustawodawstwa na mocy ustawy nr 4514/2018. Głównymi celami dyrektywy jest zwiększenie wydajności, zwiększenie przejrzystości finansowej, zwiększenie konkurencji i zapewnienie większej ochrony konsumentów w zakresie usług inwestycyjnych.",
    gdpr: "Informacje o RODO",
    aboutGDPR:
      'Ogólne rozporządzenie o ochronie danych (RODO) jest uważane za jedno z najsurowszych przepisów dotyczących prywatności na świecie. Zostało ono opracowane i przyjęte przez Unię Europejską (UE) i weszło w życie 25 maja 2018 roku. Ustanawia ona ramy prawne, które określają wytyczne dotyczące gromadzenia i swobodnego przepływu danych osobowych osób fizycznych w Unii Europejskiej (UE). "AAAFx" i jego spółki stowarzyszone, w tym spółki zależne, oddziały, przedstawicielstwa, dyrektorzy, kierownicy i pracownicy podejmują wszelkie uzasadnione kroki w celu zapewnienia zgodności z RODO.',
    investor: "Informacje o Funduszu Rekompensat dla Inwestorów",
    hcmc: "Inwestorzy AAAFx są chronieni przez Grecki Fundusz Gwarancyjny zgodnie z Dyrektywą Europejską 93/22/EWG. W przypadku niewywiązania się przez Firmę Inwestycyjną ze swoich zobowiązań, Grecki Fundusz Gwarancyjny podejmie działania w celu zrekompensowania inwestorom kwoty do 30 000 EUR na osobę. Grecki Fundusz Gwarancyjny jest finansowany przez członków ATHEX (Athens Exchange) i jest nadzorowany przez HCMC.",
    group: "Regulamin Grupy",
    sector:
      "Financial Sector Conduct Authority (FSCA), Republika Południowej Afryki",
    southAfrica:
      "Sikhula Venture Capital (Pty) Ltd. jest autoryzowana i regulowana przez południowoafrykański Urząd Nadzoru Sektora Finansowego (FSCA). (Numer licencji: 2017/315029/07).",
    view: "Proszę zobaczyć licencję",
    register: "Rejestracje w innych jurysdykcjach",
  },
  homePage: {
    h3tag: "Przyszłość rynku FOREX to...",
    h1tag: "ULTRA-NISKIE prowizje!",
    ul: {
      lTag: "Surowe pasty do smarowania",
      strong: "z",
      strong1: "0.0",
      lTag1: "pipsy",
      lTag2: "Dźwignia do",
      strong2: "500x*",
      supTag: "profesjonalni klienci",
      lTag3: "Przepisy i rejestracje UE",
      lTag4: "Wpłaty i wypłaty*",
    },
    liveAccount: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    demoAccount: "OTWARTE KONTO DEMO",
    tabs: {
      forex: "Forex",
      indices: "Wskaźniki",
      commodities: "Towary",
      stocks: "Akcje",
      cryptoCurrencies: "Kryptowaluty",
    },
    forex: {
      title: "Ponad 70 par FX",
      point1: "1",
      content: "Najbardziej płynny rynek na świecie",
      pTag: "Dostęp do najbardziej płynnych rynków na świecie",
      point2: "2",
      h5Tag: "Handel mikro lotami",
      pTag1: "Handel zgodnie z dowolną strategią, mikro loty do 100 lotów",
      point3: "3",
      h5Tag1: "Zaawansowane wskaźniki wykresów",
      pTag2:
        "Proszę skorzystać z naszych doskonałych platform handlowych z zaawansowanymi narzędziami",
      startTrading: "ROZPOCZNIJ HANDEL",
      tryDemo: "PROSZĘ WYPRÓBOWAĆ DEMO",
      tableRow: {
        tableHeading: {
          pair: "Para",
          bid: "Bid",
          ask: "Proszę pytać",
          spread: "Spready",
          trade: "Handel",
        },
      },
      buySell: "KUPNO/SPRZEDAŻ",
      SeeAll: "Proszę zobaczyć wszystkie",
    },
    indices: {
      title: "Wskaźniki 11+",
      point1: "1",
      content: "Handel stale rosnącymi wskaźnikami",
      pTag: "takich jak DOW JONES, S&P 500, Nasdaq i wiele innych...",
      point2: "2",
      h5Tag:
        "Niskie spready i niskie wymagania dotyczące depozytu zabezpieczającego",
      pTag1:
        "Mamy najniższe spready, wysoką dźwignię na wszystkich globalnych indeksach",
      point3: "3",
      h5Tag1: "Dywersyfikacja - handel portfelem, a nie pojedynczymi akcjami",
      pTag2: "Oferujemy wszystkie główne globalne indeksy do handlu",
      startTrading: "ROZPOCZNIJ HANDEL",
      tryDemo: "PROSZĘ WYPRÓBOWAĆ DEMO",
      tableRow: {
        tableHeading: {
          pair: "Para",
          bid: "Bid",
          ask: "Proszę pytać",
          spread: "Spready",
          trade: "Handel",
        },
      },
      buySell: "KUPNO/SPRZEDAŻ",
      SeeAll: "Proszę zobaczyć wszystkie",
    },
    commodities: {
      title: "9 Towary",
      point1: "1",
      content: "Szeroki zakres towarów",
      pTag: "Dostępne wszystkie główne metale szlachetne, ropa naftowa i gaz ziemny",
      point2: "2",
      h5Tag: "Inwestuj mniej, zyskaj więcej",
      pTag1: "Łatwe zdobywanie cennych aktywów dzięki dźwigni finansowej",
      point3: "3",
      h5Tag1: "Zero opóźnień, minimalny poślizg",
      pTag2: "Minimalny wpływ zmienności przy prędkości wykonania 10 ms.",
      startTrading: "ROZPOCZNIJ HANDEL",
      tryDemo: "PROSZĘ WYPRÓBOWAĆ DEMO",
      tableRow: {
        tableHeading: {
          pair: "Para",
          bid: "Bid",
          ask: "Proszę pytać",
          spread: "Spready",
          trade: "Handel",
        },
      },
      buySell: "KUPNO/SPRZEDAŻ",
      SeeAll: "Proszę zobaczyć wszystkie",
    },
    stocks: {
      title: "Ponad 100 akcji",
      point1: "1",
      content: "Handel akcjami Blue Chip",
      pTag: "Włączenie do portfela zaufanych akcji spółek blue chip",
      point2: "2",
      h5Tag: "Zarabianie dywidend bez posiadania akcji",
      pTag1: "Ekscytujące dochody z dywidend od najlepszych spółek",
      point3: "3",
      h5Tag1: "Proszę zająć pozycję długą lub krótką, w zależności od rynku",
      pTag2:
        "Handel nie tylko rosnącymi, ale i spadającymi akcjami, przy użyciu dowolnej strategii handlowej",
      startTrading: "ROZPOCZNIJ HANDEL",
      tryDemo: "PROSZĘ WYPRÓBOWAĆ DEMO",
      tableRow: {
        tableHeading: {
          pair: "Para",
          bid: "Bid",
          ask: "Proszę pytać",
          spread: "Spready",
          trade: "Handel",
        },
      },
      buySell: "KUPNO/SPRZEDAŻ",
      SeeAll: "Proszę zobaczyć wszystkie",
    },
    crypto: {
      title: "6 Kryptowaluty",
      point1: "1",
      content: "Handel pieniędzmi obracającymi kryptowalutami",
      pTag: "Handel najbardziej lukratywnymi aktywami w dzisiejszych czasach",
      point2: "2",
      h5Tag:
        "Najpotężniejsze kryptowaluty bezpośrednio na Państwa platformie transakcyjnej",
      pTag1: "Wszystkie główne kryptowaluty dostępne do handlu",
      point3: "3",
      h5Tag1: "Niezawodny handel zmiennymi aktywami",
      pTag2: "Dostęp do wysokiej płynności z regulowanym, niezawodnym brokerem",
      startTrading: "ROZPOCZNIJ HANDEL",
      tryDemo: "PROSZĘ WYPRÓBOWAĆ DEMO",
      tableRow: {
        tableHeading: {
          pair: "Para",
          bid: "Bid",
          ask: "Proszę pytać",
          spread: "Spready",
          trade: "Handel",
        },
      },
      buySell: "KUPNO/SPRZEDAŻ",
      SeeAll: "Proszę zobaczyć wszystkie",
    },
    youShouldJoin: "Dlaczego powinni Państwo dołączyć?",
    aaafx: "AAAFx",
    content: {
      h3Tag: "Najlepsze warunki handlowe",
      ul: {
        liTag: "Najszybsza realizacja transakcji z niemal zerowymi spreadami",
        liTag1: "Niskie prowizje i opłaty za rolowanie",
        liTag2: "Wszystkie strategie handlowe dozwolone",
        liTag3: "Brak ukrytych narzutów",
      },
    },
    content1: {
      h3Tag: "Bezpieczeństwo i niezawodność",
      ul: {
        liTag: "Broker regulowany przez UE.",
        liTag1: "Numer rejestracyjny: 2/540/17.2.2010.",
        liTag2: "Ochrona przed ujemnym saldem.",
        liTag3: "Ścisłe przestrzeganie zgodności z przepisami powierniczymi.",
      },
    },
    content2: {
      h3Tag: "14 lat doświadczenia w branży",
      ul: {
        liTag: "W biznesie od ponad dekady",
        liTag1: "Zespół zdolnych i doświadczonych profesjonalistów",
        liTag2: "Zaufany i przejrzysty broker",
        liTag3: "Głębokie zrozumienie potrzeb handlowców",
      },
    },
    content3: {
      h3Tag: "Głęboka pula płynności",
      ul: {
        liTag: "Płynność na poziomie instytucjonalnym",
        liTag1: "Brak rekwotowań i minimalny poślizg",
        liTag2: "Gwarantowana płynność na wszystkich poziomach cenowych",
        liTag3: "Nadaje się do handlu o wysokim wolumenie",
      },
    },
    content4: {
      h3Tag: "Technologia",
      ul: {
        liTag: "Wysokiej klasy technologia wewnętrzna",
        liTag1: "Serwery w najwyższej klasy centrach danych Equinix",
        liTag2: "Najszybsza prędkość wykonywania poniżej 10 ms",
        liTag3: "Darmowy kolokowany VPS zapewniający jeszcze niższe opóźnienia",
      },
    },
    content5: {
      h3Tag: "Ultraszybkie wypłaty",
      ul: {
        liTag: "Bezpłatne wypłaty w ciągu 24 godzin",
        liTag1: "Brak ograniczeń co do kwoty lub częstotliwości",
        liTag2: "Kilka elastycznych opcji wypłat",
        liTag3: "Przetwarzanie wypłat o wysokim poziomie bezpieczeństwa",
      },
    },
    rawSpread: "Surowe spready, zero prowizji",
    plusAccount: "na parach walutowych z kontem ECN plus",
    pTag: " AAAFx jest tutaj, aby zmniejszyć napięcie i prowizje z Państwa podróży handlowej. Tak, dobrze Państwo przeczytali! Mamy miejsce dla Państwa, aby manewrować tanim doświadczeniem handlowym z nami. Więcej informacji",
    clickHere: "proszę kliknąć tutaj",
    brTag:
      "Dajemy Państwu pełen potencjał do osiągnięcia najlepszego możliwego wyniku. Korzystając z najnowocześniejszej technologii, umożliwiliśmy Państwu natychmiastowy dostęp do głębokiej puli płynności po niskich kosztach.",
    ecn: "ECN",
    commission: "Komisja",
    minSpread: "min. Rozrzut",
    minDeposit: "min. Depozyt",
    plus: "plus",
    forexCommission: "Prowizja na rynku Forex",
    pips: "pipsy",
    compare: "Proszę porównać rodzaje kont",
    experience:
      "Doświadczeni, zaufani i regulowani z obietnicą ochrony Państwa funduszy",
    security: "Bezpieczeństwo nie jest produktem, ale procesem.",
    strongValue:
      "Dzięki silnemu systemowi wartości zapewniamy światowej klasy doświadczenie handlowe. Przestrzegamy surowych ram regulacyjnych w celu ochrony Państwa środków. Jesteśmy regulowani przez Grecką Komisję Rynku Kapitałowego (HCMC), która podlega greckim i europejskim przepisom.",
    ourClient:
      "Nasi klienci polegają na nas, ponieważ podejmujemy wszelkie środki, aby zapewnić bezpieczeństwo ich środków i płynną realizację ich transakcji.",
    success: "Handel z pokojem, handel dla sukcesu!",
    live: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    demo: "OTWARTE KONTO DEMO",
    zuluTrade: "ZuluTrade",
    treasure: "Skarbiec dla inwestorów na rynku Forex!",
    copyTrade: "Skopiuj mistrza tradingu lub zostań nim!",
    socialTrading:
      "Dzięki naszemu rachunkowi Zulu mogą Państwo uzyskać dostęp do największej sieci handlu społecznościowego za pośrednictwem niezawodnego brokera. Umożliwia on automatyczne kopiowanie transakcji niektórych odnoszących sukcesy traderów, którzy prezentują swoje wyniki handlowe na żywo.",
    investor:
      "inwestorów osiąga zyski, gdy prawidłowo kopiują najlepszych traderów.",
    topTrader: "Zostań najlepszym traderem lub podążaj za najlepszym traderem.",
    yourTrading: "Państwa handel",
    arsenal: "Arsenal",
    actTrader: "Act Trader",
    mostAdvance: "Najbardziej zaawansowana technologia",
    comming: "Już wkrótce",
    desktop: "Pulpit",
    ios: "iOS",
    android: "Android",
    web: "Sieć",
    mt4: "MetaTrader 4",
    popularPlatform: "Najpopularniejsza platforma",
    mt5: "MetaTrader 5",
    nextGen: "Platforma nowej generacji",
    firstTrade:
      "Proszę zawrzeć swoją pierwszą transakcję z AAAFx w mniej niż 15 minut",
    register: "Zarejestrować się",
    min: "W ciągu min",
    kyc: "KYC",
    photo: "Ważny dokument tożsamości ze zdjęciem",
    addressProof: "Aktualny dowód adresu zamieszkania",
    deposit: "Depozyt",
    instantly: "Natychmiast",
    method: "Ponad 5 metod wpłat",
    trade: "Handel",
    range: "Szereg rynków",
    spread: "Surowe pasty do smarowania",
    ultraLow: "Bardzo niska prowizja",
    create: "PROSZĘ UTWORZYĆ KONTO",
  },
  contactUsPage: {
    heading: "Proszę się z nami skontaktować",
    headingDescription:
      "Nasz zespół wsparcia jest do Państwa dyspozycji 24 godziny na dobę, 5 dni w tygodniu",
    requestCallBack: "Proszę poprosić o oddzwonienie:",
    FullName: "Imię i nazwisko",
    EmailAddress: "Adres e-mail",
    PhoneNumber: "Numer telefonu",
    Are_you_an_existing_client: "Czy są Państwo obecnymi klientami?",
    Yes: "Tak",
    No: "Nie",
    Select_your_Timezone: "Proszę wybrać strefę czasową",
    How_can_we_help_you: "Jak możemy Państwu pomóc?",
    Select_a_topic: "Proszę wybrać temat",
    NewAccounts: "Nowe konta",
    CustomerSupport: "Obsługa klienta",
    TechnicalQueries: "Zapytania techniczne",
    IBProgram: "Program IB",
    PAMM_Accounts: "Rachunki PAMM",
    WhiteLabel: "White Label",
    BestTimeToCallMessage:
      "Kiedy najlepiej do Państwa zadzwonić? Proszę wybrać tutaj",
    SelectPreferredTime: "Proszę wybrać preferowaną godzinę",
    eightAM: "8:00",
    tenAM: "10:00",
    twelveNoon: "12:00",
    twoPM: "14:00",
    fourPM: "16:00",
    sixPM: "18:00",
    eightPM: "20:00",
    Message: "Wiadomość",
    I_agree_to_AAAFx: "Zgadzam się z AAAFx",
    PrivacyPolicy: "Polityka prywatności",
    LiveChat: "Czat na żywo",
    AvailableMondayToFriday: "(24/5, poniedziałek-piątek)",
    CallUs: "Proszę do nas zadzwonić",
    GreeceAndAthens: "Grecja, Ateny",
    GreeceAndAthensContactNumber: "+30 213 0176300",
    AvailableMondayToFridayTime: "Od poniedziałku do piątku 9:00-18:00",
    EmailAddresses: "Adresy e-mail",
    Support: "WSPARCIE",
    Complaints: "SKARGI",
    FollowUs: "Proszę nas śledzić",
    RegisteredAddress: "Zarejestrowany adres",
    ProvidedRegisteredAddressOne:
      "Triple A Experts Investment Services Single Member S.A",
    ProvidedRegisteredAddressTwo: "580 Vouliagmenis Avenue 16452",
    ProvidedRegisteredAddressThree: "Argyroupoli Attyka",
  },
  depositBonusPage: {
    heading: "Bonus od depozytu",
    headingDescription: "Dlaczego godzić się na mniej?",
    subHeadingOne:
      "Z AAAFX Bonus, proszę handlować podwójnie z tym samym depozytem",
    subHeadingOneDescription:
      "Obecnie udostępniamy ofertę promocyjną umożliwiającą skorzystanie z darmowego kredytu (inaczej pieniędzy bonusowych) w tej samej kwocie, w jakiej dokonują Państwo wpłaty. Te pieniądze bonusowe natychmiast podwajają Państwa depozyt zabezpieczający, dzięki czemu mogą Państwo handlować więcej i potencjalnie zarabiać więcej.",
    What_is_Bonus: "Co to jest Bonus?",
    What_is_Bonus_desc:
      "Bonus jest dodawany jako dodatkowy depozyt zabezpieczający do Państwa rachunku handlowego. Jest on natychmiast dodawany jako kredyt do Państwa rachunku handlowego i zwiększa całkowity kapitał Państwa rachunku handlowego.",
    Why_should_I_avail_Bonus: "Dlaczego powinienem skorzystać z Bonusu?",
    Why_should_I_avail_Bonus_pointOne:
      "Podwójny depozyt zabezpieczający dostępny bez dodatkowych kosztów",
    Why_should_I_avail_Bonus_pointOne_desc:
      "Załóżmy, że wpłacą Państwo 1000 USD, a my dodamy kolejne 1000 USD do Państwa rachunku. W ten sposób otrzymają Państwo całkowity kapitał w wysokości $2,000 do handlu. Mogą Państwo skorzystać z darmowych środków bonusowych natychmiast po dokonaniu wpłaty.",
    Why_should_I_avail_Bonus_pointTwo:
      "Natychmiastowe dodanie dodatkowych środków do konta",
    Why_should_I_avail_Bonus_pointTwo_desc:
      'Aby skorzystać z bonusu, należy po prostu zalogować się do bezpiecznej strefy klienta po dokonaniu wpłaty i kliknąć "Skorzystaj z bonusu". Zostanie on natychmiast dodany do Państwa rachunku handlowego.',
    Why_should_I_avail_Bonus_pointThree: "ZYSKI Z PREMII NALEŻĄ DO PAŃSTWA",
    Why_should_I_avail_Bonus_pointThree_desc:
      "Nie są nam Państwo nic winni z tytułu zysków uzyskanych z obrotu własnym depozytem lub bonusem dodanym przez nas. Mogą Państwo wypłacić wszystkie zarobione zyski ze swojego konta w dowolnym momencie.",
    Why_should_I_avail_Bonus_pointFour: "Poziom opóźnionego zatrzymania",
    Why_should_I_avail_Bonus_pointFour_desc:
      'Kolejną zaletą korzystania z pieniędzy bonusowych jest to, że w przypadku niefortunnego losowania, Stop-out Państwa konta zostanie opóźniony. Państwa transakcje nie zostaną przymusowo zamknięte przez system, dopóki "WSZYSTKIE" własne środki nie zostaną utracone w handlu. Regularny poziom stop-out wynosi 50%, tj. gdy stosunek "kapitału własnego" do "wykorzystanej marży" osiągnie 50%, Państwa konto zostanie zatrzymane. Ta dodatkowa poduszka daje dodatkową możliwość, aby transakcje poszły w przeciwnym kierunku i potencjalnie stały się zyskowne.',
    Why_should_I_avail_Bonus_pointFive:
      "Wspieramy Państwa w przypadku ujemnego salda",
    Why_should_I_avail_Bonus_pointFive_desc:
      "Jeśli przez przypadek stracą Państwo własne środki, a saldo stanie się ujemne, zapewniamy Państwu pełną ochronę. Nie mogą Państwo stracić więcej niż wpłacone środki. Zresetujemy Państwa ujemne saldo konta do zera.",
    Why_should_I_avail_Bonus_pointSix:
      "Czy moje straty mogą zostać rozliczone z premią?",
    Why_should_I_avail_Bonus_pointSix_desc:
      "Straty nie mogą być zanurzone w bonusie. Gdy wszystkie Państwa środki zostaną utracone podczas handlu, wszelkie otwarte transakcje zostaną zamknięte po obowiązujących cenach rynkowych.",
    ReadAllTermsCondition: "Proszę przeczytać wszystkie warunki bonusu",
    here: "tutaj",
    ClaimBonus: "PROSZĘ UBIEGAĆ SIĘ O BONUS",
    ClaimBonusQuestion:
      "Pytania? Proszę skontaktować się z nami przez czat na żywo lub napisać do nas na adres",
  },
  depositWithdrawalPage: {
    heading: "Wpłaty i wypłaty",
    headingDescription:
      "Różnorodność łatwych i wygodnych opcji, bez żadnych kosztów z naszej strony",
    subHeading:
      "Wpłaty i wypłaty z Państwa rachunku handlowego nigdy nie były tak proste! Proszę zainwestować w swój rachunek handlowy bez ponoszenia dodatkowych opłat. Mamy różne niezawodne opcje wpłat i wypłat, aby Państwa podróż handlowa była płynna i łatwa.",
    subHeadingPointOne: "0% Opłata za usługę",
    subHeadingPointOneDesc:
      "Nie pobieramy żadnych opłat ani od wpłat, ani od wypłat",
    subHeadingPointTwo: "Bezpieczeństwo transakcji",
    subHeadingPointTwoDesc:
      "Fundusze są przechowywane w bankach Tier-1 i są oddzielone od funduszy własnych firmy",
    subHeadingPointThree: "Szybkie przetwarzanie",
    subHeadingPointThreeDesc:
      "Wpłaty i wypłaty z AAAFx są przetwarzane natychmiastowo",
    subHeadingPointFour: "$100",
    subHeadingPointFourDesc: "Minimalna kwota depozytu",
    subHeadingPointFive: "10+",
    subHeadingPointFiveDesc: "Akceptowane waluty globalne",
    subHeadingPointSix: "Zwiększona kontrola",
    subHeadingPointSixDesc: "Obowiązkowy KYC zapewnia większe bezpieczeństwo",
    WithdrawalUpperCase: "WYCOFANIA",
    WithdrawalDesc:
      "Bezproblemowe wypłaty uszczęśliwiają każdego tradera, prawda? Do tego właśnie dążymy dla naszych klientów. Oto kilka szybkich i łatwych opcji wypłaty Państwa ciężko zarobionych pieniędzy w ciągu 24 godzin.",
    StepsToWithdrawal: "Kroki, aby wypłacić środki z Państwa Konta Live AAAFx",
    StepsToWithdrawalPointOne: "Proszę zalogować się do Portalu Klienta.",
    StepsToWithdrawalPointTwo:
      'Proszę skonfigurować konto bankowe w sekcji "Konfiguracja banku".',
    StepsToWithdrawalPointThree:
      'Proszę kliknąć "Środki", a następnie "Wypłać".',
    Deposit: "Depozyt",
    Withdrawals: "Wypłaty",
    BankCards: "Karty bankowe",
    Region: "Region",
    Currencies: "Waluty",
    MinDeposit: "Min. Depozyt",
    ServiceFee: "Opłata za usługę",
    ProcessingTime: "Czas przetwarzania",
    WorldWide: "Na całym świecie",
    EUR: "EUR",
    USD: "USD",
    CHF: "CHF",
    GBP: "GBP",
    JPY: "JPY",
    AUD: "AUD",
    BGN: "BGN",
    zero: "0",
    ten: "10",
    instantCaps: "NATYCHMIAST",
    fundCaps: "FUNDUSZ",
    BankWire: "Przelew bankowy",
    twoToThreeBusinessDays: "2-3 DNI ROBOCZE",
    MY: "MY",
    TH: "TH",
    ID: "ID",
    PH: "PH",
    VN: "VN",
    BTC: "BTC",
    AdditionalInformation: "Dodatkowe informacje",
    AdditionalInformationPointOne:
      "Wszystkie wypłaty będą przetwarzane za pomocą metody, która została użyta do dokonania wpłaty na rachunek handlowy.",
    AdditionalInformationPointTwo:
      "AAAFx nie pobiera żadnych opłat transakcyjnych ani od wpłat, ani od wypłat.",
    AdditionalInformationPointThree:
      "Zwracamy poniesione przez Państwa koszty transakcji do wysokości 5% kwoty depozytu na Państwa rachunek handlowy.",
    CapsOpenLiveAccount: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    CapsOpenDemoAccount: "OTWARTE KONTO DEMO",
    DepositUpperCase: "DEPOZYTY",
    DepositDesc:
      "Co jest ważniejsze niż bezpieczne dodanie środków do Państwa rachunku handlowego? Proszę rozpocząć swoją podróż handlową z minimalnym depozytem w wysokości zaledwie 10 USD. Oferujemy szeroką gamę opcji, które mogą Państwo wykorzystać do zasilenia swojego rachunku handlowego.",
    Steps_to_make_a_deposit:
      "Kroki, aby dokonać wpłaty na Państwa rachunek rzeczywisty AAAFx",
    Steps_to_make_a_deposit_pointOne:
      "Proszę zalogować się do Portalu Klienta.",
    Steps_to_make_a_deposit_pointTwo:
      'Proszę kliknąć "Środki", a następnie "Wpłata".',
    Bitcoin: "Bitcoin",
    uptoThirtyMin: "Do 30 min",
    e_wallets: "E-portfele",
    depositNoteOne:
      "W przypadku przeciążenia sieci transakcje Bitcoin mogą trwać kilka godzin.",
    depositNoteTwo:
      "W przypadku przelewów bankowych AAAFx pokryje tylko opłaty stosowane przez nasz bank odbiorcy, tj. Eurobank, do kwoty 25 USD. AAAFx nie jest świadomy żadnych innych opłat, które mogą być stosowane przez nadawcę lub jakikolwiek inny bank pośredniczący, a zatem opłaty te nie będą pokrywane.",
    EuroBankCaps: "EUROBANK",
    Currency: "Waluta",
    SwiftCode: "Kod Swift",
    BeneficiaryName: "Imię i nazwisko beneficjenta",
    ProvidedBeneficiaryName: "POTRÓJNI EKSPERCI",
    ProvidedBeneficiaryNameTwo: "TRIPLE A EXPERTS INVESTMENT SERVICES SA",
    IBAN: "IBAN",
    Address: "Adres",
    ProvidedAddress: "Akti Kondili 26-28, 18545 Pireus, GRECJA",
    ProvidedAddressTwo: "Chemin de la Crétaux 33, 1196 Gland, Szwajcaria",
    ProvidedSwiftCode: "ERBKGRAA",
    ProvidedSwiftCodeTwo: "SWQBCHZZXXX",
    IBANCodeOne: "GR9502600590000421200023114",
    IBANCodeTwo: "GR3202600590000410200460346",
    IBANCodeThree: "GR9702600590000441200009691",
    IBANCodeFour: "GR4202600590000451200009759",
    IBANCodeFive: "GR0602600590000411200012446",
    IBANCodeSix: "GR6202600590000441200012358",
    IBANCodeSeven: "GR5402600590000471200017496",
    IBANCodeEight: "CH0708781000097621100",
    Warning: "Ostrzeżenie",
    WarningMessage:
      "Proszę zawsze podawać swój adres e-mail, imię i nazwisko oraz numer rachunku handlowego (tylko adres e-mail i imię i nazwisko dla nowych rachunków) w szczegółach przelewu wychodzącego w celu natychmiastowego przetworzenia. W przeciwnym razie AAAFx może opóźnić Państwa wpłatę.",
    swissubebankSA: "SWISSYUBE BANK SA",
  },
  stocksPage: {
    Forex: "Forex",
    Indices: "Wskaźniki",
    Commodities: "Towary",
    Stocks: "Akcje",
    Cryptocurrencies: "Kryptowaluty",
    heading: "GIEŁDY",
    headingDescription:
      "Proszę zainwestować swoje udziały w akcje największych światowych blue chipów",
    min: "min",
    zeroPointZeroSeventyFive: "0.075",
    zeroPointZero: "0.0",
    five: "5",
    one: "1",
    Commission: "Komisja",
    minExecution: "min. wykonanie",
    tenMiliSeconds: "10ms",
    Spread: "Rozprzestrzenianie się",
    hundredPlus: "100+",
    UpTo: "Do",
    Leverage: "Dźwignia finansowa",
    StocksContract: "Kontrakt na akcje",
    Specifications: "Specyfikacje",
    StocksContractSpecifications:
      "Bardziej elastyczne warunki handlowe (zwiększona dźwignia) mogą mieć zastosowanie w przypadku klientów sklasyfikowanych jako Profesjonalni. Proszę zalogować się na swoje konto i sprawdzić, czy kwalifikujesz się do klasyfikacji Klienta Profesjonalnego lub napisać do nas na adres",
    supportMail: "support{'@'}aaafx.com",
    Instrument: "Instrument",
    Bid: "Bid",
    Ask: "Proszę pytać",
    ContractSize: "Wielkość kontraktu",
    MinTradeSize: "Min. Rozmiar handlowy",
    TickValue: "Wartość ticka",
    TradingHours: "Godziny handlu",
    sevenAM: "7:00",
    twelvePM: "12:00",
    Treasury_products_description:
      "Produkty skarbowe wygasają co kwartał (proszę zapoznać się z poniższą tabelą). Klienci, którzy posiadają otwartą pozycję w dniu wygaśnięcia, zostaną zamknięci po naszej ofercie kupna/sprzedaży o godzinie 21:00 GMT dla BUND, jedyną konsekwencją tego jest to, że klient zrealizuje wszelkie zmienne zyski/ straty w momencie zamknięcia. Nie ma możliwości rolowania dla wszystkich oferowanych kontraktów skarbowych.",
    ExpirationDateCaps: "DATY WYGAŚNIĘCIA",
    Bund: "Bund",
    CORNF: "CORNF",
    WHEATF: "WHEATF",
    SOYF: "SOYF",
    seventhDecemberTwentyTwentyOne: "7-Dec-21",
    twentysixNovemberTwentyOne: "26-Nov-21",
    twentysevenNovemberTwentyOne: "27-Nov-21",
    twentyFourFebruaryTwentyTwo: "24-Feb-22",
    twentyNineDecemberTwentyOne: "29-Dec-21",
    WhatisStocksCFD: "Czym jest handel kontraktami CFD na akcje?",
    WhatisStocksCFDDesc:
      "Kontrakty CFD na akcje to tani sposób na czerpanie korzyści ze zmian cen akcji największych spółek. Główną zaletą handlu kontraktami CFD na akcje jest niski wymóg kapitałowy. Handlując akcjami, muszą Państwo zapłacić pełną cenę akcji. Jednak w przypadku kontraktów CFD na akcje, nie otrzymują Państwo faktycznej własności akcji, a zatem płacą Państwo tylko niewielki procent ceny, tylko po to, aby czerpać korzyści ze zmian cen. Mogą Państwo również skorzystać z dźwigni finansowej, aby zmaksymalizować swój potencjał zarobkowy.",
    How_does_it_work: "Jak to działa?",
    How_does_it_work_desc:
      "Handlując kontraktami CFD na akcje, nie są Państwo właścicielami akcji, w które inwestują. Po prostu wpłacają Państwo niewielki depozyt zabezpieczający, znacznie niższy niż rzeczywisty koszt akcji i korzystają z zalet handlu lewarowanego. Zyski lub straty są obliczane poprzez odjęcie ceny kupna i ceny sprzedaży, a następnie pomnożenie wyniku przez wielkość pozycji. Na przykład, aby kupić u nas równowartość 100 kontraktów CFD na akcje Facebooka, może być potrzebny tylko depozyt w wysokości 20% całkowitej wartości pozycji w porównaniu do tego, co zapłaciłby Pan za zakup fizycznych akcji. Powiedzmy, że cena akcji wynosi 320 USD. Teraz musieliby Państwo zdeponować u nas jedynie 6400 USD depozytu zabezpieczającego (20% z 32 000 USD = 6400 USD), z wyłączeniem prowizji. Z drugiej strony, gdyby musieli Państwo kupić taką samą liczbę akcji bezpośrednio od brokera akcji, musieliby Państwo zapłacić całe 32 000 USD plus prowizje i podatki.",
    Account: "Konto",
    Types: "Rodzaje",
    ECN: "ECN",
    plus: "plus",
    zulu: "zulu",
    DepositMin: "Depozyt (min.)",
    hundred: "100",
    tenThousand: "10,000",
    CommissionPerLakh: "Prowizja (za 100 tys. USD)",
    zeroPointZeroNinetyThree: "0.093",
    SpreadMin: "Rozrzut (min.)",
    CompareAccountTypes: "Proszę porównać rodzaje kont",
    OurOnline: "Nasze Online",
    Trading: "Handel",
    Platforms: "Platformy",
    Desktop: "Pulpit",
    WebTrader: "Web Trader",
    Android: "Android",
    iOS: "iOS",
    LeranMore: "DOWIEDZ SIĘ WIĘCEJ",
    NegativeBalance: "Ujemne saldo",
    Protection: "Ochrona",
    ReliableProtectionHeading:
      "Niezawodna ochrona Państwa środków na rachunkach AAAFx",
    ReliableProtectionDescription:
      "Zawsze staramy się działać w najlepszym interesie naszych klientów. Podczas handlu w niestabilnych czasach, jeśli Państwa rachunek osiągnie wartość ujemną, jesteśmy do Państwa dyspozycji! Zresetujemy ujemne saldo do zera, aby nie ponosili Państwo żadnych dodatkowych strat. Mogą Państwo dokonać wpłaty i ponownie rozpocząć handel. W związku z tym nie mogą Państwo stracić więcej niż wpłacona kwota.",
    OpenLiveAccount: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    OpenDemoAccount: "OTWARTE KONTO DEMO",
  },
  referAndEarnPage: {
    heading: "Poleć i zarabiaj",
    headingDescription: "Im więcej Państwo udostępniają, tym więcej otrzymują",
    startsWithSharing: "Wszystko zaczyna się od udostępniania!",
    startsWithSharingDescOne:
      "Znają Państwo kogoś, kogo chcieliby wprowadzić w świat tradingu? Cóż, ta osoba może zarobić dla Państwa pieniądze. Proszę zaprosić swoich znajomych do AAAFx poprzez swój unikalny link polecający. Zarówno Państwo, jak i osoba polecona otrzymają po 25 USD.",
    startsWithSharingDescTwo:
      "Nie ponosząc żadnych dodatkowych kosztów, mogą Państwo po prostu zwiększyć swoje dochody. Im więcej znajomych Państwo polecą, tym więcej Państwo zarobią!",
    startsWithSharingDescThree:
      "Dzięki naszym narzędziom do raportowania w czasie rzeczywistym mogą Państwo być zawsze na bieżąco ze swoim kontem i monitorować status swoich poleconych, aby zmaksymalizować swoje zarobki:",
    startsWithSharingDescThreePointOne:
      "Otrzymają Państwo swój unikalny link polecający w razie potrzeby.",
    startsWithSharingDescThreePointTwo:
      "Proszę sprawdzić, ile do tej pory Państwo zarobili.",
    startsWithSharingDescThreePointThree: "Proszę sprawdzić historię skierowań",
    startsWithSharingDescThreePointFour: "Dostęp do statystyk przez cały czas",
    How_to_get_started: "Jak zacząć?",
    How_to_get_started_pointOne:
      "Proszę zalogować się do Bezpiecznej Strefy Klienta",
    How_to_get_started_pointTwo:
      "Proszę pobrać link polecający i udostępnić go znajomym.",
    How_to_get_started_pointThree:
      "Zarabiaj $25, gdy Państwa poleceni zarejestrują się i zakwalifikują.",
    WhatDoYourReferrals: "Co muszą zrobić Pana poleceni?",
    WhatDoYourReferralsDescOne:
      "Państwa poleceni muszą po prostu użyć Państwa linku polecającego, aby się u nas zarejestrować. Jeśli tego nie zrobią, nie ma problemu! Mogą",
    WhatDoYourReferralsDescTwo:
      "Proszę po prostu wejść na czat na żywo i poinformować nas, że trafili do nas za Państwa pośrednictwem. Dodamy ich do Państwa listy poleconych.",
    Benefits_to_you: "Korzyści dla Państwa",
    Benefits_to_you_pointOne: "Nieograniczone zarobki z poleceń.",
    Benefits_to_you_pointTwo:
      "Po poleceniu 10 klientów można kontynuować plan Polecaj i zarabiaj lub przejść do programu IB.",
    Benefits_to_you_pointThree: "Śledzenie Państwa zarobków na żywo.",
    Benefits_to_you_pointFour:
      "Proszę przyciągnąć klientów naszymi lukratywnymi ofertami promocyjnymi, w tym bonusami.",
    Benefits_to_you_pointFive:
      "Obsługa klienta 24/5 i osobisty menedżer konta.",
    Benefits_to_your_referrals: "Korzyści dla Państwa poleconych",
    Benefits_to_your_referrals_pointOne:
      "Proszę cieszyć się naszymi nienagannymi warunkami handlowymi.",
    Benefits_to_your_referrals_pointTwo:
      "Zdobyć nagrodę za polecenie, tak jak osoba polecająca.",
    Benefits_to_your_referrals_pointThree:
      "Proszę skorzystać z naszych w pełni zintegrowanych rachunków z ZuluTrading.",
    Benefits_to_your_referrals_pointFour:
      "Proszę skorzystać z naszych promocji, w tym premii i programu lojalnościowego.",
    Benefits_to_your_referrals_pointFive:
      "Proszę użyć własnego linku polecającego i przyprowadzić własnych klientów.",
    How_is_AAAFx_Refer_and: "W jaki sposób AAAFx poleca i",
    Earn_Plan_different_from_the_IB_Program:
      "Czy Earn Plan różni się od programu IB?",
    How_is_AAAFx_Refer_desc:
      "Choć oba programy brzmią podobnie, to jednak znacznie się od siebie różnią. Oto kluczowe różnice",
    Feature: "FEATURE",
    referandEarnPlan: "PLAN POLECANIA I ZARABIANIA",
    IBProgram: "PROGRAM IB",
    Earnings: "Zarobki",
    EarningsPointOneP1: "25 USD dla Państwa i osoby poleconej; do",
    EarningsPointOneP2: "10 klientów (zmienia się na 20 USD po",
    EarningsPointOneP3: "10 wykwalifikowanych klientów)",
    EarningsPointTwop1: "20% udziału w prowizjach w Standard IB",
    EarningsPointTwop2: "Program i niestandardowy udział w",
    EarningsPointTwop3: "Zaawansowany program IB",
    Earning_frequency: "Częstotliwość zarabiania",
    Earning_frequency_p1: "Jednorazowa nagroda",
    Earning_frequency_p2: "Zlecenia na całe życie",
    Live_tracking: "Śledzenie na żywo",
    Yes: "Tak",
    No: "Nie",
    View_of_referrals_activities: "Przegląd działań osób poleconych",
    Limited: "Ograniczony",
    Full_fledged: "Pełnoprawny",
    SeparatePortal: "Oddzielny portal",
    Pay_out_frequency: "Częstotliwość wypłat",
    Weekly: "Co tydzień",
    you_can_read_terms_and_condition:
      "Mogą Państwo zapoznać się ze wszystkimi warunkami Planu Poleć i Zarabiaj",
    here: "tutaj",
    capsStartRefering: "PROSZĘ ZACZĄĆ POLECAĆ",
    readyToGoBeyondEarnPlan:
      "Czy są Państwo gotowi wyjść poza Plan Poleć i Zarabiaj?",
    signUpAsIBWithUs:
      "Proszę zarejestrować się u nas jako IB. Proszę przeczytać wszystkie korzyści",
  },
  commoditiesPage: {
    Forex: "Forex",
    Indices: "Wskaźniki",
    Commodities: "Towary",
    Stocks: "Akcje",
    Cryptocurrencies: "Kryptowaluty",
    heading: "HANDEL",
    headingDescription:
      "Budowanie zróżnicowanego portfela poprzez handel głównymi towarami",
    min: "min",
    hundred: "100",
    tenThousand: "10,000",
    CommissionPerLakh: "Prowizja (za 100 tys. USD)",
    zeroPointNinentyNine: "0.99",
    zeroPointSeventyFour: "0.74",
    Commission: "Komisja",
    zeroPintZero: "0.0",
    Spread: "Rozprzestrzenianie się",
    execution: "wykonanie",
    tenMiliSec: "10ms",
    ten: "10",
    Up_to: "Do",
    twenty: "20",
    Leverage: "Dźwignia finansowa",
    CommoditiesContract: "Kontrakt towarowy",
    Specifications: "Specyfikacje",
    CommoditiesContractDesc:
      "Bardziej elastyczne warunki handlowe (zwiększona dźwignia finansowa) mogą mieć zastosowanie w przypadku klientów sklasyfikowanych jako profesjonalni. Proszę zalogować się na swoje konto i sprawdzić, czy kwalifikujesz się do klasyfikacji Klienta Profesjonalnego lub napisać do nas na adres",
    supportmail: "support{'@'}aaafx.com",
    Instrument: "Instrument",
    Bid: "Bid",
    Ask: "Proszę pytać",
    ContractSize: "Wielkość kontraktu",
    MinTradeSize: "Min. Rozmiar handlowy",
    TickValue: "Wartość ticka",
    TradingHours: "Godziny handlu",
    sevenAM: "7:00",
    twelvePM: "12:00",
    TreasuryProductsDescription:
      "Produkty skarbowe wygasają co kwartał (proszę zapoznać się z poniższą tabelą). Klienci, którzy posiadają otwartą pozycję w dniu wygaśnięcia, zostaną zamknięci po naszej ofercie kupna/sprzedaży o godzinie 21:00 GMT dla BUND, jedyną konsekwencją tego jest to, że klient zrealizuje wszelkie zmienne zyski/ straty w momencie zamknięcia. Nie ma możliwości rolowania dla wszystkich oferowanych kontraktów skarbowych.",
    capsExpirationDates: "DATY WYGAŚNIĘCIA",
    Bund: "Bund",
    cornf: "CORNF",
    wheatf: "WHEATF",
    soyf: "SOYF",
    seventhDecemberTwentyTwentyOne: "7-Dec-21",
    twentysixNovemberTwentyOne: "26-Nov-21",
    twentysevenNovemberTwentyOne: "27-Nov-21",
    twentyFourFebruaryTwentyTwo: "24-Feb-22",
    twentyNineDecemberTwentyOne: "29-Dec-21",
    What_is_Commodities_Trading: "Czym jest handel towarami?",
    What_is_Commodities_Trading_desc:
      'Towary obejmują metale szlachetne, ropę naftową i gaz ziemny. Instrumenty te mają niższą korelację ze wszystkimi innymi aktywami dostępnymi na rynku i mogą być świetną opcją dywersyfikacji. Biorąc pod uwagę fundamentalną zmienność krajów na całym świecie, towary są uważane za "bezpieczną przystań" chroniącą je przed gwałtownymi wahaniami cen.',
    How_does_it_work: "Jak to działa?",
    How_does_it_work_desc:
      "Handel towarami nie wiąże się z fizyczną dostawą jakichkolwiek aktywów. Potencjał zysków tkwi w ruchach cen. Ponieważ podaż tych aktywów na Ziemi jest ograniczona i są one wykorzystywane w produkcji przemysłowej, są one czasami narażone na zmienność, w zależności od różnych czynników gospodarczych i politycznych. Bez faktycznego posiadania aktywów, inwestor może po prostu spekulować na ich cenie. Mnogość dostępnych informacji związanych z ekonomią różnych krajów, sytuacją polityczną, informacjami o inwestycjach, czynnikami podaży i popytu itp. sprawia, że inwestorzy mogą wygodniej niż kiedykolwiek przewidywać główne ruchy cen i spekulować na nich. Ceny towarów są kwotowane głównie w USD. Na przykład XAUUSD odnosi się do ceny złota w USD. Do faktycznego inwestowania w złoto potrzebny jest znaczny kapitał. Jednak dzięki dźwigni finansowej mogą Państwo inwestować we wszystkie metale szlachetne, ropę naftową itp. przy minimalnych nakładach kapitałowych.",
    Account: "Konto",
    Types: "Rodzaje",
    ECN: "ECN",
    plus: "plus",
    zulu: "zulu",
    DepositMin: "Depozyt (min.)",
    spreadMin: "Rozrzut (min.)",
    CompareAccountTypes: "Proszę porównać rodzaje kont",
    OurOnline: "Nasze Online",
    Trading: "Handel",
    Platforms: "Platformy",
    Desktop: "Pulpit",
    WebTrader: "Web Trader",
    Android: "Android",
    iOS: "iOS",
    capsLearnMore: "DOWIEDZ SIĘ WIĘCEJ",
    NegativeBalance: "Ujemne saldo",
    Protection: "Ochrona",
    NegativeBalanceDesc1:
      "Niezawodna ochrona Państwa środków na rachunkach AAAFx",
    NegativeBalanceDesc2:
      "Zawsze staramy się działać w najlepszym interesie naszych klientów. Podczas handlu w niestabilnych czasach, jeśli Państwa rachunek osiągnie wartość ujemną, jesteśmy do Państwa dyspozycji! Zresetujemy ujemne saldo do zera, aby nie ponosili Państwo żadnych dodatkowych strat. Mogą Państwo dokonać wpłaty i ponownie rozpocząć handel. W związku z tym nie mogą Państwo stracić więcej niż wpłacona kwota.",
    CapsOpenLiveAccount: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    CapsOpenDemoAccount: "OTWARTE KONTO DEMO",
  },
  careerPage: {
    heading: "Kariera",
    headingDescription:
      "Kochamy to, co robimy i myślimy, że Państwo też to pokochają! Integracja, różnorodność, innowacyjność i lojalność to powody, dla których nasi pracownicy kochają swoją pracę i lubią przychodzić do niej każdego dnia.",
    Join_us_and_help_us:
      "Proszę do nas dołączyć i pomóc nam tworzyć wartość dodaną we wszystkim, co robimy!",
    OurCulture: "Nasza kultura",
    OurCulturePointOne:
      "Nikt nie potrafi zagwizdać symfonii. Potrzeba do tego całej orkiestry. - (H.E. Luccock)",
    OurCulturePointTwo:
      "W AAAFx zachęcamy Państwa do bycia lepszą wersją siebie. Proszę wyrazić, kim naprawdę jesteś; uczyć się i odnosić sukcesy! Obecnie zatrudniamy ponad 80 osób i dążymy do dalszego powiększania naszego zespołu. Naszym celem jest stworzenie sprzyjającego środowiska pracy, które da Państwu poczucie spełnienia.",
    When_our_clients: "Kiedy nasi klienci",
    succeed_we_succeed: "odniosą Państwo sukces, my odniesiemy sukces!",
    succeed_we_succeed_pointOneP1:
      "Jesteśmy mniejsi, gdy nie uwzględniamy wszystkich.",
    succeed_we_succeed_pointOneP2: "- (Stuart Milk)",
    succeed_we_succeed_pointOnedesc1:
      "Zbudowaliśmy spójną i integracyjną kulturę, która obejmuje szeroką gamę pracowników, którzy mają solidne listy osobistych osiągnięć i ogromnego ducha zespołowego. Integracja sprzyja poczuciu przynależności i szacunku do organizacji. Dzięki temu nasi pracownicy czują się ważni i doceniani.  Dążymy do stworzenia środowiska, w którym wszyscy czują, że wspólnie pracują na rzecz tej samej sprawy.",
    succeed_we_succeed_pointOnedesc2: '"Doskonałe wyniki dla lepszego jutra".',
    succeed_we_succeed_pointTwoP1:
      "Siła tkwi w różnicach, a nie w podobieństwach.",
    succeed_we_succeed_pointTwoP2: "- (Stephen R. Covey)",
    succeed_we_succeed_pointTwodesc1:
      "Posiadanie zróżnicowanego zespołu pod względem płci i kultury jest niezbędne, abyśmy mogli wywierać szerszy i globalny wpływ. Naszą zasadą jest posiadanie równych proporcji członków zespołu płci męskiej i żeńskiej z szacunkiem i akceptacją. Co więcej, odkładając na bok zdolności fizyczne, rasizm i przekonania religijne, współistniejemy i rozwijamy się w przyjaznym środowisku. Każda pracująca tu osoba ma równe szanse, równe wynagrodzenie i pomaga przezwyciężyć społeczne stereotypy.",
    succeed_we_succeed_pointThreeP1:
      "Lojalność pracowników zaczyna się od lojalności pracodawcy.",
    succeed_we_succeed_pointThreeP2: " - (Harvey Mackay)",
    succeed_we_succeed_pointThreedesc:
      "Bez wsparcia naszego zespołu nie moglibyśmy osiągnąć tego, co osiągnęliśmy. Nasza marka rozwija się dzięki lojalności ludzi, czy to klientów, czy naszych pracowników. Lojalność to nie tylko zwykła cecha; to siła, która napędza członków zespołu do dawania z siebie wszystkiego i osiągania najwyższych możliwych standardów. Co więcej, często mówi się, że lojalność pracowników jest zaraźliwa. Zaczyna się od góry i obejmuje wszystkie sekcje naszego zespołu. Nasz zespół jest dumny z tego, co robi i zobowiązuje się dawać z siebie 100%.",
    succeed_we_succeed_pointFourP1: "Innowacja to jedyny sposób na wygraną.",
    succeed_we_succeed_pointFourP2: "- (Steve Jobs)",
    succeed_we_succeed_pointFourdesc:
      "Promujemy nieszablonowe myślenie na wszystkich poziomach, aby wydobyć z naszych pracowników to, co najlepsze. Kreatywność jest niezbędna do tworzenia nowych rzeczy przy użyciu wyobraźni, a następnie unikalny zestaw umiejętności naszych pracowników jeszcze bardziej je szlifuje. Dzięki temu udało nam się poprawić relacje z klientami, zwiększyć produktywność, zapewnić lepszą obsługę, obniżyć koszty i wspólnie zbudować silną markę.",
    Rewards_and_Benefits: "Nagrody i korzyści",
    Rewards_and_Benefits_PointOne:
      "Nagrodą za dobrze wykonaną pracę jest możliwość zrobienia czegoś więcej. - (Jonas Salk)",
    Rewards_and_Benefits_PointTwo:
      "Chcą Państwo spędzać więcej czasu z rodziną lub dbać o zdrowie i kondycję? Chcą Państwo rozwijać się zawodowo, ale jednocześnie zachować równowagę? Zapewniamy naszym pracownikom nie tylko wynagrodzenie współmierne do standardów branżowych, ale także elastyczne środowisko pracy, lukratywne nagrody oraz różne sposoby doceniania i uznawania.",
    CurrentVacancies: "Aktualne oferty pracy",
    CurrentVacanciesDescOne:
      "Dołącz do nas, aby stać się częścią wyjątkowej siły roboczej, którą napędza tylko i wyłącznie doskonałość i zaangażowanie w zgranym środowisku zespołowym. Każdy, kto pracuje w AAAFx, czuje się doceniany w pracy!",
    CurrentVacanciesDescTwo:
      "Proszę dowiedzieć się, co trzeba zrobić, aby zostać jednym z nas i jak najlepiej się przygotować. Z niecierpliwością czekamy na Państwa zgłoszenie i wiadomość od Państwa.",
    ReadyForChallengesReadyForYou:
      "Jeśli są Państwo gotowi na wyzwania, jesteśmy na nie gotowi",
    CustomerSupportGreece: "Kierownik ds. obsługi klienta, Grecja",
    What_the_job_looks_like: "Jak wygląda ta praca?",
    What_the_job_looks_like_pointOne:
      "Zapewnienie klientom wsparcia na czacie, przez e-mail i telefon.",
    What_the_job_looks_like_pointTwo:
      "Odpowiedzialne i proaktywne rozpatrywanie zapytań klientów.",
    What_the_job_looks_like_pointThree:
      "Badanie transakcji klientów, gdy jest to wymagane.",
    What_the_job_looks_like_pointFour:
      "Komunikowanie się z klientami w sposób miękki, przyjazny i wysoce profesjonalny.",
    What_the_job_looks_like_pointFive:
      "Ścisła współpraca z kierownictwem w zakresie krótko- i długoterminowych celów i zadań.",
    What_the_job_looks_like_pointSix:
      "Sporządzanie notatek dotyczących żądań klientów i proaktywne przekazywanie ich odpowiednim zespołom.",
    What_the_job_looks_like_pointSeven:
      "Współpraca z innymi zespołami w celu zapewnienia klientom doskonałej obsługi.",
    What_the_job_looks_like_pointEight:
      "Zapewnienie najwyższego poziomu obsługi klienta.",
    What_do_we_look_for: "Czego szukamy?",
    What_do_we_look_for_pointOne:
      "Zdolność do rozwiązywania problemów dzięki silnej przytomności umysłu.",
    What_do_we_look_for_pointTwo: "Doskonałe umiejętności komunikacyjne.",
    What_do_we_look_for_pointThree: "Silny duch zespołu",
    What_do_we_look_for_pointFour:
      "Pozytywne nastawienie oraz spokojne i opanowane zachowanie.",
    What_do_we_look_for_pointFive:
      "Wcześniejsze doświadczenie w finansach inwestycyjnych lub obsłudze klienta.",
    What_do_we_look_for_pointSix: "Profesjonalizm, uczciwość i rzetelność.",
    applyForTheJob: "PROSZĘ UBIEGAĆ SIĘ O PRACĘ",
    FinanceExecutiveGreece: "Kierownik ds. finansów, Grecja",
    What_the_job_looks_like_point1:
      "Pomoc w sporządzaniu budżetów kwartalnych i rocznych",
    What_the_job_looks_like_point2: "Zarządzanie dokumentacją i paragonami",
    What_the_job_looks_like_point3:
      "Przygotowywanie analiz i raportów budżetowych i rzeczywistych",
    What_the_job_looks_like_point4:
      "Uzgadnianie transakcji dziennych, miesięcznych, kwartalnych i rocznych",
    What_the_job_looks_like_point5: "Sporządzanie bilansów kwartalnych",
    What_the_job_looks_like_point6: "Przetwarzanie faktur",
    What_the_job_looks_like_point7:
      "Sporządzanie rachunków przepływów pieniężnych dla działu",
    What_the_job_looks_like_point8:
      "Bycie punktem kontaktowym dla innych działów w sprawach związanych z finansami.",
    What_the_job_looks_like_point9: "Rozliczanie zwrotów dla pracowników.",
    What_the_job_looks_like_point10:
      "Obliczanie i publikowanie wskaźników finansowych",
    What_the_job_looks_like_point11:
      "Zapewnienie pomocy w audytach, w razie potrzeby.",
    What_the_job_looks_like_point12:
      "Wnoszenie pomysłów i sugestii dotyczących efektywnego zarządzania funduszami",
    What_do_we_look_for_point1: "Pasja do finansów i księgowości",
    What_do_we_look_for_point2: "Pełna znajomość ERP i MS Office",
    What_do_we_look_for_point3:
      "Magister księgowości i minimum 3 lata doświadczenia w pracy z globalnym brokerem.",
    What_do_we_look_for_point4: "Silne umiejętności analityczne",
    What_do_we_look_for_point5: "Doskonały gracz zespołowy",
    What_do_we_look_for_point6: "Pozytywne nastawienie",
    DataAdministratorGreece: "Administrator danych, Grecja",
    What_the_job_looks_like_p1: "Kontrola uprawnień i przywilejów dostępu.",
    What_the_job_looks_like_p2: "Zapewnienie wsparcia i pomocy programistom.",
    What_the_job_looks_like_p3:
      "Monitorowanie i utrzymywanie kondycji i bezpieczeństwa systemu.",
    What_the_job_looks_like_p4:
      "Projektowanie procesów tworzenia kopii zapasowych serwera i powiązanych danych.",
    What_the_job_looks_like_p5:
      "Tworzenie kont dla wszystkich użytkowników i przypisywanie poziomów zabezpieczeń.",
    What_the_job_looks_like_p6:
      "Zapewnienie kompleksowego wsparcia technicznego i rozwiązywanie problemów.",
    What_the_job_looks_like_p7:
      "Planowanie i przeprowadzanie regularnej konserwacji serwera.",
    What_the_job_looks_like_p8: "Tworzenie procedur zarządzania bazą danych.",
    What_the_job_looks_like_p9:
      "Przygotowywanie informacji statystycznych do użytku wewnętrznego i zewnętrznego.",
    What_the_job_looks_like_p10: "Ocena modeli i procedur analizy danych.",
    What_the_job_looks_like_p11:
      "Uczestniczyć w firmowym programie szkoleń przekrojowych.",
    What_do_we_look_for_p1: "Tytuł licencjata w dziedzinie komputerów.",
    What_do_we_look_for_p2: "Ponad 1 rok doświadczenia na podobnym stanowisku.",
    What_do_we_look_for_p3:
      "Zaawansowana znajomość struktury i teorii baz danych.",
    What_do_we_look_for_p4: "Doświadczenie z MySQL i MSSQL.",
    What_do_we_look_for_p5:
      "Zrozumienie procedur tworzenia kopii zapasowych bazy danych.",
    What_do_we_look_for_p6: "Preferowany certyfikat PostgreSQL.",
    What_do_we_look_for_p7:
      "Zdolność do samodzielnej pracy przy minimalnym nadzorze i pomocy.",
    How_to_Apply: "Jak złożyć wniosek?",
    How_to_Apply_p1:
      'Jeśli uważają Państwo, że dobrze pasują do którejkolwiek z powyższych ról, proszę kliknąć przycisk "Aplikuj" i przesłać nam swoją aplikację.',
    How_to_Apply_p2: "CV. Nasz pracownik działu HR skontaktuje się z Państwem.",
  },
  autoChartistPage: {
    heading: "Autochartist",
    headingDesc: "Pozwala rozsądnie inwestować czas handlowy",
    subHeadingOne:
      "Uzyskaj bezpłatny dostęp do jednego z najpopularniejszych narzędzi handlowych w AAAFx",
    subHeadingOneP1:
      "Podejmuj świadome decyzje, ponieważ Autochartist analizuje dla Ciebie wszystkie wykresy i formacje.",
    subHeadingOneP2:
      "Jeśli są Państwo traderami, znają Państwo wartość czasu jak nikt inny. Przedstawiamy Państwu doskonałe narzędzie, które może zaoszczędzić cały Państwa czas i energię oraz wykonać dla Państwa wiele rodzajów analiz.",
    subHeadingTwo: "Jak działa Autochartist?",
    subHeadingTwoP1: "Nigdy nie przegap okazji!",
    subHeadingTwoP2: "Autochartist działa na trzech rodzajach wzorców:",
    ChartPatterns: "Wzorce wykresów",
    FibonacciPatterns: "Wzory Fibonacciego",
    KeyLevels: "Kluczowe poziomy",
    subHeadingTwoDesc:
      "Monitoruje ona rynek i wysyła powiadomienia o okazjach handlowych. Niech technologia pracuje dla Państwa 24 godziny na dobę, bez przerwy.",
    One_stop_solution: "Kompleksowe rozwiązanie do analizy rynku",
    One_stop_solution_p1: "Identyfikacja poziomów wsparcia i oporu",
    One_stop_solution_p2: "Alerty w czasie rzeczywistym o nadmiernych ruchach",
    One_stop_solution_p3: "Szczegółowa analiza wiadomości makroekonomicznych",
    One_stop_solution_p4: "Identyfikacja poziomów wsparcia i oporu",
    Single_Screen_access_to_everythinig:
      "Dostęp do wszystkiego z jednego ekranu",
    Get_simply_plugged_in_to_MT4_and_MT5: "Łatwe podłączenie do MT4 i MT5",
    API_Driven_Technology_free_from_manual_errors:
      "Technologia oparta na API, wolna od błędów ręcznych",
    All_rounder_for_all_types_of_Traders:
      "Wszechstronne rozwiązanie dla wszystkich typów traderów",
    Autochartist_Volatility_Analysis: "Analiza zmienności Autochartist",
    Autochartist_Volatility_Analysis_p1:
      "Proszę budować swoją strategię handlową w oparciu o fakty.",
    Autochartist_Volatility_Analysis_p2:
      "Proszę poznać najlepszy czas na handel danym instrumentem, zdobywając wiedzę na temat jego najbardziej i najmniej zmiennych momentów w ciągu dnia.",
    Autochartist_Volatility_Analysis_p3:
      "Dzięki temu narzędziu mogą Państwo zobaczyć następujące informacje",
    Autochartist_Volatility_Analysis_sub_p1:
      "Oczekiwane przedziały cenowe w różnych ramach czasowych",
    Autochartist_Volatility_Analysis_sub_p2:
      "Oczekiwany ruch cen według godziny w ciągu dnia",
    Autochartist_Volatility_Analysis_sub_p3:
      "Oczekiwany ruch cen według dnia tygodnia",
    Know_more_here: "Więcej informacji znajdą Państwo tutaj",
    AutochartistRiskCalculator: "Kalkulator ryzyka autochartist",
    AutochartistRiskCalculatorP1:
      "Proszę zmierzyć ryzyko przed rozpoczęciem handlu.",
    AutochartistRiskCalculatorP2:
      "Teraz mogą być Państwo zawsze świadomi idealnego dla siebie wolumenu obrotu, mając na uwadze swój apetyt na ryzyko.",
    AutochartistRiskCalculatorP3:
      "Narzędzie to pokazuje oczekiwane zakresy zmian cen",
    AutochartistRiskCalculatorSubP1:
      "Proszę ustawić żądany poziom wejścia i poziom stop loss",
    AutochartistRiskCalculatorSubP2:
      "Proszę wprowadzić kwotę pieniędzy, którą są Państwo skłonni zaryzykować w związku z transakcją.",
    AutochartistRiskCalculatorSubP3:
      "Kalkulator wskaże Państwu wielkość pozycji, jaką należy zająć",
    CapsOpenLiveAccount: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    CapsOpenDemoAccount: "OTWARTE KONTO DEMO",
  },
  cryptoCurrency: {
    innerPages: {
      forex: "Forex",
      indices: "Wskaźniki",
      commodities: "Towary",
      stocks: "Akcje",
      crypto: "Kryptowaluty",
    },
    title: "KRYPTOWALUTY",
    heading:
      "Handel najpotężniejszymi kryptowalutami na naszych platformach transakcyjnych",
    min: "min .",
    tradeSize: "Wielkość handlu",
    execution: "wykonanie",
    paris: "Pary",
    leverage: "Dźwignia finansowa",
    upTo: "Do",
    contract: "Umowa dotycząca kryptowalut",
    specification: "Specyfikacje",
    pTag: "Bardziej elastyczne warunki handlowe (zwiększona dźwignia) mogą mieć zastosowanie w przypadku klientów sklasyfikowanych jako Profesjonalni. Proszę zalogować się na swoje konto i sprawdzić, czy kwalifikujesz się do klasyfikacji Klienta Profesjonalnego lub napisać do nas na adres",
    email: "support{'@'}aaafx.com",
    table: {
      heading: {
        instrument: "Instrument",
        bid: "Bid",
        ask: "Proszę pytać",
        spread: "Rozprzestrzenianie się",
        contractSize: "Wielkość kontraktu",
        tradeSize: "Min. Rozmiar handlowy",
        tickValue: "Wartość ticka",
        tradingHours: "Godziny handlu",
      },
    },
    trading: "Czym jest handel kryptowalutami?",
    pTag1:
      "Kryptowaluty to zasadniczo aktywa cyfrowe zabezpieczone kryptografią, które poruszają się w zdecentralizowanej sieci elektronicznej. Aktywa te nie są zabezpieczone ani wymienialne na żaden towar. Działają one za pośrednictwem księgi publicznej opartej na technologii Blockchain. Bitcoin, wydany w 2009 roku, jest pierwszą zdecentralizowaną kryptowalutą. Od tego czasu powstało wiele innych kryptowalut. Monety te naprawdę zmieniły zasady gry na rynkach finansowych.",
    howItWork: "Jak to działa?",
    pTag2:
      "Tradycyjne waluty fiducjarne są zazwyczaj pod wpływem wydarzeń gospodarczych i politycznych na całym świecie. Ponieważ jednak kryptowaluty nie są powiązane z żadnym konkretnym krajem i są ogólnie zdecentralizowane, ich ceny mają tendencję do poruszania się niezależnie. Jest to klasa aktywów o wysokiej zmienności, co sprawia, że inwestorzy muszą rozważyć ryzyko przed rozpoczęciem handlu nimi. Oferujemy kontrakty CFD na kryptowaluty, co oznacza, że mogą Państwo po prostu handlować kryptowalutami bez konieczności ich posiadania. Zyski i straty wynikające z różnicy cen są po prostu korygowane na Państwa koncie. Instrumenty te występują jako para kwotowana w stosunku do USD. Na przykład BTCUSD. Cena tej pary będzie oznaczać, ile USD jest potrzebnych na 1 BTC.",
    account: "Konto",
    types: "Rodzaje",
    ecn: "ECN",
    plus: "plus",
    zulu: "zulu",
    deposit: "Depozyt",
    commission: "Komisja",
    compare: "Proszę porównać rodzaje kont",
    ourOnline: "Nasze Online",
    tradingText: "Handel",
    platform: "Platformy",
    desktop: "Pulpit",
    webTrade: "Web Trader",
    android: "Android",
    ios: "iOS",
    learn: "DOWIEDZ SIĘ WIĘCEJ",
    negative: "Ujemne saldo",
    protection: "Ochrona",
    pSubTag: "Niezawodna ochrona Państwa środków na rachunkach AAAFx",
    pTag3:
      "Zawsze staramy się działać w najlepszym interesie naszych klientów. Podczas handlu w niestabilnych czasach, jeśli Państwa rachunek osiągnie wartość ujemną, jesteśmy do Państwa dyspozycji! Zresetujemy ujemne saldo do zera, aby nie ponosili Państwo żadnych dodatkowych strat. Mogą Państwo dokonać wpłaty i ponownie rozpocząć handel. W związku z tym nie mogą Państwo stracić więcej niż wpłacona kwota.",
    live: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    demo: "OTWARTE KONTO DEMO",
  },
  ib: {
    whiteLabel: "White Label",
    pamm: "PAMM/MAM",
    title: "Broker wprowadzający",
    heading: "Stworzenie stałego źródła dochodu dla siebie",
    h3Tag:
      "Sukces w dzisiejszych czasach polega na budowaniu silnej sieci, niech Państwa sieć pracuje nad zarabianiem pieniędzy dla Państwa, nawet gdy Państwo śpią!",
    pTag: "Chcą Państwo wykorzystać swoje umiejętności marketingowe? AAAFx przygotował wzbogacający program dla naszych klientów, dzięki któremu mogą Państwo rozpowszechniać informacje o naszej fantastycznej platformie i uzyskiwać nieograniczone dochody. Wystarczy zaprosić do nas traderów i zarabiać prowizję od ich transakcji!",
    h3Tag1:
      "Rozpowszechnianie informacji - Wywieranie wpływu na społeczność handlową",
    pTag1:
      "Oferujemy wyjątkowe warunki handlowe i narzędzia dla traderów oraz pomagamy naszym partnerom IB rozwijać się wraz z ich klientami:",
    ul: {
      li: "Wysoka płynność obrotu",
      liTag: "Zero prowizji na rynku Forex",
      liTag1: "Surowe pasty do smarowania",
      liTag2: "Wysoka dźwignia finansowa do 500X",
      liTag3: "Zaufany i niezawodny broker",
      liTag4: "Dostęp do narzędzi handlowych, takich jak Auto chartist",
      liTag5: "Bezpośredni dostęp do Zulu Trade",
      liTag6: "Najnowocześniejsza technologia",
    },
    question: {
      ques: "Dlaczego powinni Państwo dołączyć do AAAFx IB?",
      point:
        "Nagroda za Państwa mądrą pracę i konsekwencję może być ogromna, jeśli będą Państwo nadal rozwijać naszą społeczność handlową, pomagając im korzystać z różnorodnych funkcji naszych platform transakcyjnych. W AAAFx oferujemy najbardziej spersonalizowany i najprostszy program IB. Nie wszyscy IB są tacy sami. Ale mamy coś do zaoferowania dla każdego.",
      point1: "Dlatego też stworzyliśmy dwie kategorie programów IB:",
      point2:
        "Standardowy program IB - od razu otrzymują Państwo 20% prowizji od swoich klientów. Jest to przydatne dla początkujących IB, którzy chcą zacząć od nowa lub mogą zacząć przyciągać do nas ograniczoną liczbę klientów.",
      point3:
        "Zaawansowany program IB - jest to wysoce satysfakcjonujący i spersonalizowany program IB dla naszych większych IB. Jest to przydatne dla kogoś z dużą bazą klientów, którzy mogą przynieść większy wolumen.",
      point4:
        "Mogą Państwo przejść ze Standardowego Programu IB do Zaawansowanego Programu IB, gdy tylko Państwa sieć będzie wystarczająco duża.",
    },
    signUp: "Proszę zarejestrować się jako IB",
    referralLink: "Proszę udostępnić link polecający",
    clients: "Proszę pozyskać klientów",
    earn: "Zarabiają, gdy handlują",
    benefits: "Inne korzyści płynące z naszego programu IB",
    zero: "Zarabianie bez inwestycji lub doświadczenia",
    ibCommission: "Cotygodniowe wypłaty prowizji IB",
    earning: "Nieograniczony potencjał zarobkowy",
    customized:
      "Wysoce spersonalizowany i satysfakcjonujący program Advanced IB",
    ultraFast: "Ultraszybkie wypłaty prowizji IB",
    easyUser: "Prosty interfejs użytkownika portalu IB",
    accountManager: "Dedykowany opiekun klienta",
    helpful: "Pomocne i bezpłatne materiały marketingowe",
    h6Tag:
      "Nasz zaawansowany program IB jest wysoce konfigurowalny i ma duży potencjał zarobkowy. Jeśli uważasz, że masz taki potencjał, skontaktuj się z nami, aby dowiedzieć się więcej. Proszę skontaktować się z nami teraz",
    click: "tutaj",
    orWrite: "lub proszę do nas napisać na adres",
    email: "support{'@'}aaafx.com.",
  },
  mt4PageData: {
    MT4: "MT4",
    MetaTrade4: "MetaTrader 4",
    MT5: "MT5",
    ActTrader: "ActTrader",
    ZuluTrade: "ZuluTrade",
    MetaTrade4DescOne:
      "Platforma MetaTrader 4 została stworzona w 2002 roku przez MetaQuotes. Platforma MT4 jest uważana za oprogramowanie o złotym standardzie wśród szerokiej gamy platform transakcyjnych; wykorzystywana do handlu na rynku Forex, kontraktami CFD, akcjami i różnymi popularnymi kryptowalutami.",
    MetaTrade4DescTwo:
      "Platforma AAAFx MT4 zapewnia przyjazny dla użytkownika interfejs, umożliwiający użytkownikom zrozumienie funkcji platformy z absolutną łatwością. Asymiluje wymagania użytkownika i oferuje najlepsze możliwe rozwiązanie, zapewniając możliwość zastosowania różnych narzędzi analitycznych, uruchamiania robotów handlowych (doradców ekspertów) i kopiowania transakcji od innych.",
    MetaTrade4DescThree:
      "Zwiększ swoje doświadczenie handlowe na większym ekranie z większą funkcjonalnością i większym skupieniem, pobierając platformę MT4 na komputer stacjonarny lub po prostu uzyskując dostęp do naszej platformy internetowej.",
    Steps_to_download_MT4_Desktop: "Kroki pobierania MT4 Desktop",
    Steps_to_download_MT4_Desktop_point1:
      "1. Proszę pobrać platformę z powyższego linku.",
    Steps_to_download_MT4_Desktop_point2: "2. Proszę uruchomić plik .exe",
    Steps_to_download_MT4_Desktop_point3:
      '3. Proszę przejść do Plik> Otwórz konto"',
    Steps_to_download_MT4_Desktop_point4:
      "4. Proszę kliknąć na Dodaj nowego brokera i wpisać AAAFX. Proszę wybrać AAAFX-FX-DEMO dla rachunku demo i AAAFX-FX-REAL dla rachunku rzeczywistego.",
    Steps_to_download_MT4_Desktop_point5:
      "5. Proszę kliknąć przycisk Scan (Skanuj). Serwer został dodany.",
    Steps_to_download_MT4_Desktop_point6:
      '6. Proszę kliknąć Dalej> zaznaczyć pole wyboru "Istniejący rachunek handlowy" i wprowadzić identyfikator logowania i hasło. Proszę kliknąć Zakończ.',
    Steps_to_uninstall_MT4_Desktop: "Kroki, aby odinstalować MT4 Desktop",
    Steps_to_uninstall_MT4_Desktop_point1:
      "1. Proszę kliknąć przycisk Start w systemie Windows",
    Steps_to_uninstall_MT4_Desktop_point2:
      "2. Aplikacja MT4 zostanie umieszczona na liście programów.",
    Steps_to_uninstall_MT4_Desktop_point3:
      '3. Proszę kliknąć prawym przyciskiem myszy na nazwę aplikacji i wybrać "Odinstaluj".',
    Steps_to_log_into_Webbased_MT4:
      "Kroki logowania do internetowej platformy MT4",
    Steps_to_log_into_Webbased_MT4_point1:
      '1. W Web-Trader proszę przejść do opcji "Plik" na pasku menu i wybrać "Zaloguj się do rachunku handlowego".',
    Steps_to_log_into_Webbased_MT4_point2:
      "2. Proszę wprowadzić identyfikator rachunku handlowego i hasło.",
    Steps_to_log_into_Webbased_MT4_point3:
      '3. Proszę wybrać serwer "AAAFX-FX-REAL" dla rachunku rzeczywistego i "AAAFX-FX-DEMO" dla rachunku demonstracyjnego.',
    Steps_to_log_into_Webbased_MT4_point4:
      '4. Następnie proszę wybrać platformę MT4 i kliknąć "OK".',
    AAAFx_mobile_trading_application_description:
      "Zabierz swoją euforię handlową gdziekolwiek jesteś dzięki wszystkim narzędziom handlowym i wskaźnikom dostępnym w mobilnej aplikacji handlowej AAAFx.",
    Steps_to_download_MT4_Android: "Kroki pobierania MT4 Android",
    Steps_to_download_MT4_Android_point1:
      "1. Proszę pobrać aplikację z powyższego linku.",
    Steps_to_download_MT4_Android_point2:
      '2. Proszę kliknąć na trzy poziome linie w Menu i przejść do "Zarządzaj kontami"/"Rozpocznij".',
    Steps_to_download_MT4_Android_point3:
      '3. Proszę kliknąć znak "+" w prawym górnym rogu.',
    Steps_to_download_MT4_Android_point4:
      '4. Proszę wybrać "Zaloguj się do istniejącego konta"',
    Steps_to_download_MT4_Android_point5:
      '5. W sekcji "Znajdź swojego brokera" proszę wybrać AAAFX-FX-DEMO dla rachunku demo i AAAFX-FX-REAL dla rachunku rzeczywistego. Teraz proszę wprowadzić identyfikator logowania i hasło, a następnie kliknąć przycisk logowania.',
    Steps_to_uninstall_MT4_Android: "Kroki, aby odinstalować MT4 Android",
    Steps_to_uninstall_MT4_Android_point1:
      "1. W menu proszę wybrać Ustawienia > Aplikacje > Zarządzaj aplikacjami",
    Steps_to_uninstall_MT4_Android_point2:
      "2. Proszę znaleźć na liście MT4 i dotknąć jego nazwy.",
    Steps_to_uninstall_MT4_Android_point3: '3. Proszę wybrać "Odinstaluj".',
    Steps_to_download_MT4_iOS: "Kroki pobierania MT4 iOS",
    Steps_to_download_MT4_iOS_point1:
      "1. Proszę pobrać aplikację z powyższego linku.",
    Steps_to_download_MT4_iOS_point2:
      '2. Proszę kliknąć "Ustawienia" i przejść do opcji "Nowe konto",',
    Steps_to_download_MT4_iOS_point3:
      '3. Następnie proszę kliknąć "Zaloguj się do istniejącego konta"',
    Steps_to_download_MT4_iOS_point4:
      '4. Proszę wpisać "AAAFX" w polu "Znajdź brokera".',
    Steps_to_download_MT4_iOS_point5:
      "5. Proszę wybrać AAAFX-FX-DEMO dla rachunku demo i AAAFX-FX-REAL dla rachunku rzeczywistego.",
    Steps_to_download_MT4_iOS_point6:
      '6. Proszę wprowadzić identyfikator logowania i hasło, a następnie kliknąć "Zaloguj się".',
    Steps_to_uninstall_MT4_iOS: "Kroki, aby odinstalować MT4 iOS",
    Steps_to_uninstall_MT4_iOS_point1:
      "1. Proszę długo nacisnąć ikonę aplikacji MT4, aż wszystkie ikony na ekranie zaczną się trząść.",
    Steps_to_uninstall_MT4_iOS_point2:
      '2. Proszę kliknąć "x" w lewym górnym rogu ikony aplikacji MT4.',
    take_trading_experience_to_next_level:
      "Przenieś swoje doświadczenie handlowe na platformie MT4 z AAAFx na wyższy poziom dzięki następującym funkcjom",
    Why_AAAFxs_MT4: "Dlaczego AAAFx MT4?",
    Why_AAAFxs_MT4_point1: "Związany z największą społecznością handlową MQL",
    Why_AAAFxs_MT4_point2: "Ponad 20 obiektów graficznych do dogłębnej analizy",
    Why_AAAFxs_MT4_point3: "Cena rynkowa w czasie rzeczywistym",
    Why_AAAFxs_MT4_point4: "Prosty do zrozumienia interfejs",
    Why_AAAFxs_MT4_point5:
      "Kompatybilny z Windows, iPhone, Android lub po prostu handlować bezpośrednio z sieci",
    Why_AAAFxs_MT4_point6:
      "Gotowe do użycia skrypty umożliwiające zautomatyzowany handel",
    Why_AAAFxs_MT4_point7:
      "Ponad 1000 darmowych i możliwych do pobrania wskaźników/EA oferowanych przez MQL4",
    Why_AAAFxs_MT4_point8:
      "Najszybsza prędkość wykonywania z wieloma serwerami na całym świecie",
    Why_AAAFxs_MT4_point9:
      "Ponad 70 par walutowych forex, globalnych indeksów i towarów dostępnych do handlu",
    Why_AAAFxs_MT4_point10:
      "Dostępna jest realizacja rynkowa i 4 rodzaje zleceń oczekujących",
    capsOpenLiveAccount: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    capsOpenDemoAccount: "OTWARTE KONTO DEMO",
  },
  mt5PageData: {
    MT4: "MT4",
    MetaTrade5: "MetaTrader 5",
    MT5: "MT5",
    ActTrader: "ActTrader",
    ZuluTrade: "ZuluTrade",
    MetaTrade5DescOne:
      "Platforma MT5 została wydana w 2010 roku, wspierając szybszą niż kiedykolwiek technologię przetwarzania i dodatkowe układy.",
    MetaTrade5DescTwo:
      "Platforma AAAFx MT5 oferuje obszerną listę instrumentów handlowych, w tym kontrakty CFD na kryptowaluty, pomagając zaawansowanej platformie w realizacji jej futurystycznych perspektyw.",
    download_mt5_preferred_device:
      "Na większym ekranie zawsze jest lepiej. Proszę pobrać naszą platformę MT5 na preferowane urządzenie.",
    Steps_to_download_MT5_Desktop: "Kroki pobierania MT5 Desktop",
    Steps_to_download_MT5_Desktop_point1:
      "1. Proszę pobrać platformę z powyższego linku.",
    Steps_to_download_MT5_Desktop_point2: "2. Proszę uruchomić plik .exe",
    Steps_to_download_MT5_Desktop_point3:
      '3. Proszę przejść do Plik> Otwórz konto"',
    Steps_to_download_MT5_Desktop_point4:
      '4. Proszę wpisać AAAFX w polu "Dodaj nowego brokera" i kliknąć na "Znajdź swojego brokera".',
    Steps_to_download_MT5_Desktop_point5:
      '5. Proszę wybrać "AAAFX" i kliknąć "Dalej"',
    Steps_to_download_MT5_Desktop_point6:
      '6. Proszę kliknąć na "Połącz z istniejącym rachunkiem handlowym" i wprowadzić swoje dane logowania.',
    Steps_to_download_MT5_Desktop_point7:
      '7. Aby zalogować się na konto Live, proszę wybrać nazwę serwera "AAAFX-FX-REAL" i "AAAFX-FX-DEMO" dla konta Demo z rozwijanego menu i kliknąć "Zakończ".',
    Steps_to_uninstall_MT5_Desktop: "Kroki, aby odinstalować MT5 Desktop",
    Steps_to_uninstall_MT5_Desktop_point1:
      "1. Proszę kliknąć przycisk Start w systemie Windows",
    Steps_to_uninstall_MT5_Desktop_point2:
      "2. Aplikacja MT5 zostanie umieszczona na liście programów.",
    Steps_to_uninstall_MT5_Desktop_point3:
      '3. Proszę kliknąć prawym przyciskiem myszy na nazwę aplikacji i wybrać "Odinstaluj".',
    Steps_to_log_into_Webbased_MT5:
      "Kroki logowania do internetowej platformy MT5",
    Steps_to_log_into_Webbased_MT5_point1:
      '1. W Web-Trader proszę przejść do opcji "Plik" na pasku menu i wybrać "Zaloguj się do rachunku handlowego".',
    Steps_to_log_into_Webbased_MT5_point2:
      "2. Proszę wprowadzić identyfikator rachunku handlowego i hasło.",
    Steps_to_log_into_Webbased_MT5_point3:
      '3. Proszę wybrać serwer "AAAFX-FX-REAL" dla rachunku rzeczywistego i "AAAFX-FX-DEMO" dla rachunku demonstracyjnego.',
    Steps_to_log_into_Webbased_MT5_point4:
      '4. Następnie proszę wybrać platformę MT5 ORAZ kliknąć "OK".',
    AAAFx_mobile_trading_application:
      "Zabierz swoją euforię handlową gdziekolwiek jesteś dzięki wszystkim narzędziom handlowym i wskaźnikom dostępnym w mobilnej aplikacji handlowej AAAFx.",
    Steps_to_download_MT5_Android: "Kroki pobierania MT5 Android",
    Steps_to_download_MT5_Android_point1:
      "1. Proszę pobrać aplikację z powyższego linku.",
    Steps_to_download_MT5_Android_point2:
      '2. Proszę kliknąć na trzy poziome linie w Menu i przejść do "Zarządzaj kontami"/"Rozpocznij".',
    Steps_to_download_MT5_Android_point3:
      '3. Proszę kliknąć znak "+" w prawym górnym rogu.',
    Steps_to_download_MT5_Android_point4:
      '4. W sekcji "Znajdź swojego brokera" proszę wybrać AAAFX-FX-DEMO dla rachunku demo i AAAFX-FX-REAL dla rachunku rzeczywistego. Teraz proszę wprowadzić identyfikator logowania i hasło, a następnie kliknąć przycisk logowania.',
    Steps_to_uninstall_MT5_Android: "Kroki, aby odinstalować MT5 Android",
    Steps_to_uninstall_MT5_Android_point1:
      "1. W menu proszę wybrać Ustawienia > Aplikacje > Zarządzaj aplikacjami",
    Steps_to_uninstall_MT5_Android_point2:
      "2. Proszę znaleźć na liście MT4 i dotknąć jego nazwy.",
    Steps_to_uninstall_MT5_Android_point3: '3. Proszę wybrać "Odinstaluj".',
    Steps_to_download_MT5_iOS: "Kroki pobierania MT5 iOS",
    Steps_to_download_MT5_iOS_point1:
      "1. Proszę pobrać aplikację z powyższego linku.",
    Steps_to_download_MT5_iOS_point2:
      '2. Proszę kliknąć "Ustawienia" i przejść do opcji "Nowe konto",',
    Steps_to_download_MT5_iOS_point3:
      '3. Następnie proszę kliknąć "Zaloguj się do istniejącego konta"',
    Steps_to_download_MT5_iOS_point4:
      '4. Proszę wpisać "AAAFX" w polu "Znajdź brokera". br 5. Proszę wybrać AAAFX-FX-DEMO dla rachunku demo i AAAFX-FX-REAL dla rachunku rzeczywistego.',
    Steps_to_download_MT5_iOS_point5:
      '5. Proszę wprowadzić identyfikator logowania i hasło, a następnie kliknąć "Zaloguj się".',
    Steps_to_uninstall_MT5_iOS: "Kroki, aby odinstalować MT5 iOS",
    Steps_to_uninstall_MT5_iOS_point1:
      "1. Proszę długo nacisnąć ikonę aplikacji MT5, aż wszystkie ikony na ekranie zaczną się trząść.",
    Steps_to_uninstall_MT5_iOS_point2:
      '2. Proszę kliknąć "x" w lewym górnym rogu ikony aplikacji MT5.',
    trading_experience_the_next_level:
      "Przenieś swoje doświadczenie handlowe na platformie MT5 z AAAFx na wyższy poziom dzięki następującym funkcjom:",
    Why_AAAFxs_MT5: "Dlaczego AAAFx MT5?",
    TechnicalAnalysisTools: "Narzędzia analizy technicznej",
    TechnicalAnalysisToolsPoint1:
      "21 różnych przedziałów czasowych, dzięki czemu nigdy nie stracą Państwo nawet sekundy okazji",
    TechnicalAnalysisToolsPoint2:
      "Ponad 30 wbudowanych wskaźników i ponad 40 obiektów technicznych",
    TechnicalAnalysisToolsPoint3:
      "Dostępność danych historycznych wykresów z okresu do 30 lat",
    TechnicalAnalysisToolsPoint4:
      "6 typów zleceń oczekujących dostępnych wraz z realizacją rynkową",
    TechnicalAnalysisToolsPoint5: "Wbudowana i modyfikująca opcja dla skryptów",
    FundamentalAnalysisTools: "Narzędzia analizy fundamentalnej",
    FundamentalAnalysisToolsPoint1:
      "Wbudowany kalendarz ekonomiczny; informujący Państwa na bieżąco o wszystkich zmiennych wydarzeniach",
    FundamentalAnalysisToolsPoint2:
      "Możliwość pobrania szczegółowego wyciągu z konta dla konfigurowalnego okresu czasu",
    FundamentalAnalysisToolsPoint3:
      "Narzędzie głębokości rynku zapewniające przewagę w strategiach handlowych",
    capsOpenLiveAccount: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    capsOpenDemoAccount: "OTWARTE KONTO DEMO",
  },
  ourServicesPage: {
    heading: "Nasze serwery",
    headingDescription: "Solidna konfiguracja dla bezbłędnego doświadczenia",
    EquinixDataCenters: "Centra danych Equinix",
    EquinixDataCentersDescription:
      "Dążąc do zapewnienia naszym klientom światowej klasy doświadczenia handlowego, polegamy wyłącznie na najlepszej technologii i infrastrukturze na świecie. Naszym celem jest zapewnienie najbardziej niezawodnej i najszybszej łączności, jeśli chodzi o realizację transakcji, dlatego korzystamy z najbardziej zaawansowanej globalnej sieci i klastrów serwerów na świecie.",
    What_are_the_advantages_of_Equinix: "Jakie są zalety Equinix?",
    FastestExecution: "Najszybsze wykonanie",
    FastestExecutionDescription:
      "Centrum danych jest kolokowane z naszymi głównymi LP, zapewniając w ten sposób najszybszą możliwą łączność.",
    Low_latency_connection: "Połączenie o niskim opóźnieniu",
    Low_latency_connection_description:
      "Szybkie połączenie między naszymi serwerami handlowymi a LP za pośrednictwem dedykowanego kanału zapewnia możliwie najmniejsze opóźnienia.",
    Uninterrupted_trading: "Nieprzerwany handel",
    Uninterrupted_trading_description:
      "Natychmiastowa i płynna łączność, maksymalny czas pracy, dzięki czemu Państwa doświadczenie handlowe jest bezbłędne.",
    Low_slippage: "Niski poślizg",
    Low_slippage_description:
      "Ultraszybkie połączenie oznacza, że otrzymują Państwo żądaną cenę z minimalnym ryzykiem poślizgu.",
    Easy_connectivity: "Łatwa łączność",
    Easy_connectivity_description:
      "Nie muszą Państwo zmagać się z łącznością, gdy łączą się Państwo z gęstą siecią, która działa w oparciu o najnowocześniejszą technologię",
    What_is_Equinix: "Czym jest Equinix?",
    What_is_Equinix_desone:
      "Equinix, Inc. (NASDAQ: EQIX) to amerykańska międzynarodowa firma z siedzibą w Redwood City w Kalifornii, która specjalizuje się w łączności internetowej i zarządzaniu centrami danych.",
    What_is_Equinix_destwo:
      "Firma jest liderem w globalnej kolokacji z 229 centrami danych w 27 krajach na pięciu kontynentach. Ponadto zdobyła wiele nagród za niezawodność i zrównoważony rozwój. Ich centra danych są uważane za złoty standard oraz najbardziej niezawodną i bezpieczną infrastrukturę cyfrową.",
    What_is_the_LD4_Data_Center: "Czym jest centrum danych LD4?",
    What_is_the_LD4_Data_Center_descOne:
      "Centrum danych Equinix LD4, w którym znajduje się większość serwerów AAAFx, jest najlepszą lokalizacją dla umieszczania serwerów w branży Forex, ponieważ umożliwia bezpośrednią łączność ze wszystkimi głównymi globalnymi dostawcami płynności. Ma powierzchnię ponad 14 000 stóp kwadratowych i posiada różne globalne certyfikaty, takie jak SOC 1 Typ 1, SOC 2 Typ 2, ISO 27001, PCI DSS, OHSAS 18001, ISO 9001:2015, ISO 22301, ISO 14001:1015 i ISO 50001.",
    What_is_the_LD4_Data_Center_descTwo:
      "Przyspieszone połączenie z naszymi dostawcami płynności za pośrednictwem gęstej sieci umożliwia ultraszybką realizację transakcji przy najmniejszych opóźnieniach.",
  },
  LoyaltyBonusPageData: {
    heading: "Program lojalnościowy",
    headingDescription:
      "Im więcej handlują Państwo, tym więcej nagród otrzymują Państwo automatycznie!",
    LoyaltyBonusDescription:
      "Mówi się, że lojalność działa w obie strony. Zdobywamy lojalność naszych klientów poprzez naszą ciężką pracę <br />i przejrzystość, i wierzymy w jej zwrot poprzez nasz bezpłatny program nagród.0",
    What_is_AAAFx_loyalty_program: "Czym jest program lojalnościowy AAAFx?",
    What_is_AAAFx_loyalty_program_descOne:
      "Każda transakcja liczy się w podróży tradera. Każda transakcja, którą Państwo u nas zawrą, przyczynia się do uzyskania ekscytujących zwrotów dzięki naszemu wspaniałemu Programowi Lojalnościowemu.",
    What_is_AAAFx_loyalty_program_descTwo:
      "Nie ma potrzeby rejestrowania się. Wszystkie Państwa transakcje będą automatycznie gromadzić punkty premiowe (RP). Po zebraniu określonej liczby punktów premiowych (RP) można je wymienić na kilka różnych sposobów, w tym na gotówkę!",
    Deposit: "Depozyt",
    Trade: "Handel",
    Earn_RPs: "Zdobywanie RP",
    Redeem_RPs: "Wykup RP",
    loyalty_program_descOne:
      "Nasz program lojalnościowy jest odpowiedni dla wszystkich rodzajów",
    loyalty_program_descTwo: "handlowców. Istnieją dwa sposoby postępu",
    loyalty_program_descThree: "poprzez Poziomy Tier:",
    ExpressRoute: "Trasa ekspresowa",
    ExpressRouteDesc:
      "Odpowiedni dla tych traderów, którzy lubią handlować więcej za jednym razem",
    SteadyRoute: "Stała trasa",
    SteadyRouteDesc:
      "Dla tych, którzy lubią handlować konsekwentnie przez dłuższy czas.",
    OurFabulousFourLoyaltyTiers: "Nasze wspaniałe cztery poziomy lojalności",
    OurFabulousFourLoyaltyTiersDescOne: "Handluj więcej, zarabiaj więcej",
    OurFabulousFourLoyaltyTiersDescTwo:
      "Z każdym kolejnym poziomem staje się on coraz większy i lepszy.",
    OurFabulousFourLoyaltyTiersDescThree:
      "Mamy dwa bardzo proste i elastyczne sposoby zakwalifikowania się do poziomów lojalnościowych. Niezależnie od tego, którą drogę Państwo wybiorą, upewnimy się, że",
    OurFabulousFourLoyaltyTiersDescFour:
      "zdobędą Państwo te same poziomy lojalnościowe i te same punkty premiowe. Jeśli te dwie trasy pokrywają się, otrzymają Państwo",
    OurFabulousFourLoyaltyTiersDescFive:
      "przydzielono wyższy obowiązujący poziom z dwóch tras.",
    Redeem_your_Reward_Points: "Wymiana punktów premiowych",
    EarnMoreRedeemMore: "Zarabiaj więcej, wykorzystuj więcej",
    EarnMoreRedeemMoreDesc:
      "Elastyczne i atrakcyjne opcje zamiany Państwa punktów Reward na liczne korzyści",
    Redeem_your_Reward_Points_point1:
      "Gotówka (min. 500 RP można wymienić na gotówkę)",
    Redeem_your_Reward_Points_point2: "Darmowy podstawowy VPS przez 3 miesiące",
    Redeem_your_Reward_Points_point3: "Darmowy VPS Premium przez 3 miesiące",
    Redeem_your_Reward_Points_point4: "Subskrypcja SeatsonAX na 3 miesiące",
    Redeem_your_Reward_Points_point5:
      "Jeszcze szybsze wypłaty przez następne 20 dni",
    Redeem_your_Reward_Points_point6: "Przejście do następnego poziomu nagrody",
    Redeem_your_Reward_Points_point7:
      "Iphone/Ipad lub podobne urządzenie inteligentne o wartości do 1200 USD",
    Redeem_your_Reward_Points_point8:
      "1 pips płaski spread przez 10 dni handlowych",
    Redeem_your_Reward_Points_point9:
      "10% dodatkowej prowizji IB za ostatni miesiąc",
    Redeem_your_Reward_Points_point10:
      "Dodatkowe $100 za każde polecenie w ostatnim miesiącu",
    Redeem_your_Reward_Points_point11: "Zwrot prowizji za 1 miesiąc",
    Redeem_your_Reward_Points_point12:
      "Zaliczka na poczet depozytu w tranzycie",
    Redeem_your_Reward_Points_point13: "Dodatkowy bonus na koncie",
    Redeem_your_Reward_Points_point14: "Zwrot 1-miesięcznej opłaty swapowej",
    Redeem_your_Reward_Points_point15:
      "10% dodatkowego (wypłacalnego) depozytu od ostatnich 5 depozytów",
    Redeem_your_Reward_Points_point16:
      "Zwrot straty z dowolnej transakcji w ciągu ostatnich 20 dni handlowych",
    Redeem_your_Reward_Points_point17:
      "Zwrot spreadu w 10 stratnych transakcjach (w ciągu ostatnich 20 dni)",
    AdditionalCommAmount: "Dodatkowa prowizja. Kwota",
    AdvanceDepositAmount: "Kwota zaliczki",
    Reimbursement_amount: "Kwota zwrotu",
    readTermsAndConditionHere:
      "Proszę zapoznać się z warunkami naszego programu lojalnościowego.",
    BonusAmount: "Kwota premii",
    here: "tutaj",
    two: "2",
    six: "6",
    seven: "7",
    ten: "10",
    sixHundred: "600",
    sevenHundred: "700",
    oneThousand: "1000",
    twoThousand: "2000",
    twoThousandFivehundred: "2500",
    threeThousand: "3000",
    tenThousand: "10,000",
    twentyFiveThousand: "25,000",
    rps: "RP",
    rpsPerReferral: "RP na skierowanie",
    oneusd: "1USD",
  },
  legalDocument: {
    title: "Dokumenty prawne",
    heading: "W AAAFx z dumą stawiamy na uczciwość i przejrzystość",
    recommend:
      "Zalecamy Państwu przeczytanie i zrozumienie wszystkich niezbędnych informacji.",
    tradingJourney:
      "dokumenty prawne przed rozpoczęciem z nami Państwa podróży handlowej.",
    policy: "Polityka prywatności",
    view: "widok",
    risk: "Zastrzeżenie dotyczące ryzyka",
    clientAgreement: "Umowa z klientem detalicznym",
    refundPolicy: "Polityka zwrotów",
    executionPolicy: "Polityka wykonania",
    conflicts: "Polityka dotycząca konfliktu interesów",
    clientAsset: "Aktywa klienta",
    investor: "System rekompensat dla inwestorów",
    h3Tag: "DOKUMENT ZAWIERAJĄCY KLUCZOWE INFORMACJE - CFDS DOTYCZĄCY TOWARÓW",
    h3Tag1: "DOKUMENT ZAWIERAJĄCY KLUCZOWE INFORMACJE DOTYCZĄCE INDEKSÓW",
    h3Tag2: "Kluczowy dokument informacyjny - CFD na akcje",
    h3Tag3: "DOKUMENT ZAWIERAJĄCY KLUCZOWE INFORMACJE DOTYCZĄCE PAR WALUTOWYCH",
    h3Tag4: "Podstawy dyrektywy MiFID II",
  },
  pamm: {
    whiteLabel: "White Label",
    title: "PAMM/MAM",
    programm: "Program PAMM/MAM",
    heading:
      "Doskonała okazja do zarobienia na wieloletnim doświadczeniu jako odnoszący sukcesy trader",
    pTag: "W AAAFx dajemy inwestorom doskonałą okazję do zaprezentowania światu swojej wiedzy handlowej i zarabiania dzięki swoim obserwatorom. Daje to również szansę inwestorom na wybór najlepszych traderów, którzy będą dla nich handlować.",
    account: "Co to jest konto PAMM lub MAM?",
    pTag1:
      "Jest to forma połączonego funduszu inwestycyjnego, w którym Money Manager handluje funduszami zebranymi przez swoich klientów-inwestorów. Mając dostęp do jednego konta, Money Manager może umieszczać transakcje na wszystkich kontach swoich inwestorów. Na koncie PAMM transakcje są przydzielane automatycznie i natychmiastowo w stosunku do względnego kapitału własnego na rachunkach inwestorów.  Na koncie MAM inwestor może wybrać poziom ryzyka, który chce podjąć i odpowiednio zdecydować o alokacji transakcji.",
    combined: "Dlaczego połączyliśmy nasz PAMM i MAM z ZuluTrade?",
    pTag2:
      "ZuluTrade jest synonimem przejrzystości. Gdy gromadzą Państwo środki jako inwestor i zezwalają jakiemuś inwestorowi na handel Państwa pieniędzmi, muszą Państwo mieć jasny wgląd w historyczne wyniki inwestora, pełną elastyczność w wyborze alokacji transakcji, możliwość interakcji z różnymi ekspertami, zadawania im pytań, uczenia się od nich itp. Zapewniamy Państwu to wszystko we współpracy z ZuluTrade.",
    advantage: "Korzyść dla PAMM/MAM Manager",
    pTag3:
      "Menedżer PAMM/MAM może wykorzystać swoją wiedzę, aby uzyskać wyższy dochód dzięki opłacie za wyniki pobieranej od swoich klientów. Nasi menedżerowie PAMM/MAM mają również pełną elastyczność w ustalaniu warunków związanych z działalnością handlową i alokacją zysków.  Co więcej, menedżerowie PAMM/MAM otrzymują również bardzo atrakcyjne wypłaty IB, oprócz opłat za wyniki od swoich klientów.",
    investor: "Korzyści dla inwestorów",
    pTag4:
      "Inwestorzy mogą wybierać spośród szerokiej gamy traderów wymienionych na ZuluTrade z AAAFx. Mogą przeglądać ich wyniki handlowe, wchodzić z nimi w interakcje przed uczestnictwem w programie PAMM lub MAM. Następnie mogą po prostu zrelaksować się i pozwolić Menedżerowi wykonywać jego pracę. Po zasileniu konta i wyrażeniu zgody na w pełni przejrzysty Regulamin, mogą Państwo stale monitorować wyniki swojego konta. Mają również pełną kontrolę nad swoim kontem w zakresie wpłat, wypłat i odłączania się od konta menedżera.",
    aaafxProgramm: "Dlaczego program AAAFx PAMM/MAM?",
    ul: {
      liTag: "Współpraca z największą siecią handlu społecznościowego",
      liTag1: "Dedykowani opiekunowie klienta dla inwestorów i menedżerów",
      liTag2: "Elastyczność w ustalaniu parametrów i warunków konta",
      liTag3: "Bardzo niskie prowizje z surowymi spreadami",
      liTag4: "Bezpieczeństwo środków u zaufanego brokera",
      liTag5: "Niewielka inwestycja wymagana do rozpoczęcia",
      liTag6: "Przejrzystość dla inwestorów - brak ukrytych klauzul",
      liTag7: "Pełna kontrola dla inwestorów związana z wpłatami i wypłatami",
    },
    minimum: "Minimalne wymagania",
    liTag: "Całkowity depozyt musi wynosić co najmniej 5 000 USD.",
    subAccount: "Wymagane minimum 4 subkonta.",
    eachInvestor:
      "Każdy inwestor powinien podpisać umowę POA i zgodzić się na wszystkie warunki.",
    howTo: "Jak się zarejestrować?",
    portal: "Proszę zarejestrować się na portalu AAAFx.",
    build: "Proszę zbudować zespół inwestorów.",
    sign: "Proszę poprosić inwestorów o podpisanie umowy POA.",
    earning: "Proszę zacząć zarabiać.",
    titleHeading:
      "Nasz program PAMM/MAM jest wysoce konfigurowalny, dlatego prosimy skontaktować się z nami, aby dowiedzieć się więcej i rozpocząć współpracę.",
    contact:
      "Konto PAMM/MAM. Proszę skontaktować się z nami tutaj lub napisać do nas na adres",
    email: "support{'@'}aaafx.com.",
  },
  indicesPages: {
    innerPages: {
      forex: "Forex",
      indices: "Wskaźniki",
      commodities: "Towary",
      stocks: "Akcje",
      crypto: "Kryptowaluty",
    },
    title: "INDEKSY",
    heading:
      "Rozwijaj swój rachunek handlowy poprzez handel globalnymi indeksami",
    min: "min .",
    commission: "Komisja",
    execution: "wykonanie",
    spread: "Rozprzestrzenianie się",
    upTo: "Do",
    leverage: "Dźwignia finansowa",
    contract: "Kontrakt indeksowy",
    specification: "Specyfikacje",
    pTag: "Bardziej elastyczne warunki handlowe (zwiększona dźwignia) mogą mieć zastosowanie w przypadku klientów sklasyfikowanych jako Profesjonalni. Proszę zalogować się na swoje konto i sprawdzić, czy kwalifikujesz się do klasyfikacji Klienta Profesjonalnego lub napisać do nas na adres",
    email: "support{'@'}aaafx.com",
    instument: "Instrument",
    bid: "Bid",
    ask: "Proszę pytać",
    size: "Wielkość kontraktu",
    minTrade: "Min. Rozmiar handlowy",
    tickValue: "Wartość ticka",
    hours: "Godziny handlu",
    trading: "Czym jest handel kontraktami CFD na indeksy?",
    pTag1:
      "Indeks reprezentuje oddzielny portfel z połączeniem profili różnych spółek, co pomaga w ograniczeniu profilu ryzyka klienta. Handel indeksami zwalnia inwestora z konieczności poświęcania dużej ilości czasu na analizę pojedynczych akcji. Indeksy mogą być różnego rodzaju, oparte na geografii (np. indeks hiszpański, indeks niemiecki, indeks Hongkongu) i oparte na sektorach (np. NASDAQ).",
    how: "Jak to działa?",
    content:
      "Zmienność indeksów giełdowych wynika z czynników politycznych i gospodarczych, a nie tylko z wyników poszczególnych akcji. Inwestorzy mogą osiągać zyski spekulując na ruchach indeksów giełdowych w górę lub w dół. Inwestor nie musi na przykład kupować wszystkich poszczególnych akcji notowanych na Dow Jones. Może po prostu handlować kontraktami CFD na Dow Jones. Handel indeksami to świetny sposób na dywersyfikację portfela przy niewielkim nakładzie kapitału. Inwestorzy zazwyczaj polegają na wynikach gospodarczych w regionach (w przypadku indeksów opartych na krajach) lub na ogólnych wynikach sektora (w przypadku indeksów opartych na sektorach), aby ocenić, czy powinni zająć pozycję długą czy krótką na indeksie. Sam indeks to tylko liczba, ale piękno tego produktu polega na możliwości ogólnego inwestowania we wszystkie poszczególne akcje indeksu, przy znacznie mniejszym kapitale.",
    account: "Konto",
    type: "Rodzaje",
    ecn: "ECN",
    plus: "plus",
    zulu: "zulu",
    deposit: "Depozyt",
    compare: "Proszę porównać rodzaje kont",
    online: "Nasze Online",
    tradingText: "Handel",
    platform: "Platformy",
    desktop: "Pulpit",
    webTrade: "Web Trader",
    android: "Android",
    ios: "iOS",
    learn: "DOWIEDZ SIĘ WIĘCEJ",
    negative: "Ujemne saldo",
    protection: "Ochrona",
    pSubTag: "Niezawodna ochrona Państwa środków na rachunkach AAAFx",
    workTowards:
      "Zawsze staramy się działać w najlepszym interesie naszych klientów. Podczas handlu w niestabilnych czasach, jeśli Państwa rachunek osiągnie wartość ujemną, jesteśmy do Państwa dyspozycji! Zresetujemy ujemne saldo do zera, aby nie ponosili Państwo żadnych dodatkowych strat. Mogą Państwo dokonać wpłaty i ponownie rozpocząć handel. W związku z tym nie mogą Państwo stracić więcej niż wpłacona kwota.",
    live: "PROSZĘ OTWORZYĆ RACHUNEK RZECZYWISTY",
    demo: "OTWARTE KONTO DEMO",
  },
  economicCalander: {
    title: "Kalendarz ekonomiczny",
    heading: "Globalne wydarzenia na wyciągnięcie ręki",
    h5Tag:
      "Nasz kalendarz ekonomiczny pozwoli Państwu zapoznać się ze wszystkimi ważnymi wydarzeniami finansowymi mającymi wpływ na światowe rynki",
    news: "Kalendarz ekonomiczny, Wiadomości Forex",
    pTag: "Jest to niezbędne narzędzie do fundamentalnej analizy rynków finansowych w oparciu o wiadomości gospodarcze. Ponad 500 indeksów największych gospodarek świata opiera się na danych zbieranych w czasie rzeczywistym ze źródeł publicznych.",
    upNext: "Do następnego",
    country: "Kraj",
    selectAll: "Proszę wybrać wszystkie",
    clear: "Wyczyść",
    myFilter: "Mój filtr",
    default: "Domyślny",
    text: "Wpływ",
    type: {
      all: "Wszystkie",
      medium: "Średni",
      high: "Wysoki",
    },
    saveSetting: "Proszę zapisać ustawienia w moim filtrze",
    apply: "Proszę zastosować filtr",
    calander: {
      time: "Czas",
      country: "Kraj",
      event: "Wydarzenie",
      actual: "Rzeczywisty",
      forecast: "Prognoza",
      previous: "Poprzedni",
    },
    head: "Tytuł:",
    category: "Kategoria:",
    desc: "Opis:",
    defi: "Definicja:",
  },
  faqs: {
    "Pierwsze kroki": {
      0: {
        label: "Jak zarejestrować się w AAAFx i zweryfikować swoje konto?",
        content:
          '\n\t\t\t<div class="content">\n\t\t\t<p>W celu pomyślnej weryfikacji należy postępować zgodnie z poniższym procesem:</p>\n\t\t\t<ul>\n\t\t\t<li>Krok 1: Proszę podać swoje dane osobowe, w tym imię i nazwisko, numer telefonu, adres e-mail itp.\n\t\t\t<li>Krok 2: Po podaniu wszystkich danych osobowych, proszę przesłać dowód tożsamości ze zdjęciem (licencja, paszport itp.)</li>.\n\t\t\t<li>Krok 3: Dla celów bezpieczeństwa, proszę kliknąć selfie na miejscu i przesłać je na wymaganą stronę.</li>\n\t\t\t<li>Krok 4: W następnym kroku prosimy przesłać aktualny "Dowód zamieszkania" (wydany w ciągu 3 miesięcy od bieżącej daty), zawierający pełne imię i nazwisko oraz adres (rachunek za media, wyciąg bankowy itp.)</li>.\n\t\t\t<li>Krok 5: Proszę wypełnić dane i kliknąć Wyślij.</li>\n\t\t\t</ul>\n\t\t\t</div>\n\t\t  ',
      },
      1: {
        label: "Z jakiego kraju przyjmują Państwo klientów?",
        content:
          '<div class="content"><p>Przyjmujemy klientów z 27 krajów Europejskiego Obszaru Gospodarczego (UE oraz Islandii, Szwajcarii i Liechtensteinu). Klienci z Belgii i Wielkiej Brytanii nie są akceptowani.</p></div>',
      },
      2: {
        label: "Czy AAAFx podlega regulacjom?",
        content:
          '<div class="content"><p>AAFx jest regulowanym dostawcą usług finansowych z licencjami HCMC w Grecji i FSCA w RPA.</p></div>',
      },
      3: {
        label:
          "Czy mogę zarejestrować się bez adresu e-mail/numeru telefonu, którego nie posiadam?",
        content:
          '<div class="content"><p>Proszę pamiętać, że do zarejestrowania się u nas potrzebny jest adres e-mail/numer telefonu, ponieważ wysyłamy potwierdzenia e-mail na zarejestrowany adres e-mail w celu weryfikacji żądania złożonego z konta internetowego. Prosimy również o podanie numeru telefonu, abyśmy mogli skontaktować się z Państwem w nagłych przypadkach.</p></div>',
      },
      4: {
        label: "Jakie dokumenty są wymagane do weryfikacji konta?",
        content:
          "<div class=\"content\">\n\t\t  <p>Następujące dokumenty będą wymagane do otwarcia u nas konta:</p>\n\t\t  <ul>\n\t\t  <li>1. Ważny dowód tożsamości ze zdjęciem (np. paszport, prawo jazdy lub dowolny dowód tożsamości ze zdjęciem wydany przez urząd państwowy)</li>.\n\t\t  <li>2. aktualny dowód zamieszkania (wydany w ciągu 3 miesięcy), zawierający pełne imię i nazwisko oraz adres (może to być rachunek za media, wyciąg bankowy itp.). Mogą Państwo przesłać wyżej wymienione niezbędne dokumenty na konto internetowe lub wysłać je e-mailem na adres support{'@'}aaafx.com.</li>.\n\t\t  </ul>\n\t\t  </div>",
      },
      5: {
        label:
          "Co jeśli będę musiał później zmienić swoje dane? Jak mogę zaktualizować informacje na moim profilu?",
        content:
          "<div class=\"content\">\n\t\t  <p>Mogą Państwo zmienić następujące dane osobowe, logując się na swoje konto internetowe:</p>\n\t\t  <ul>\n\t\t  <li>Telefon podstawowy</li>\n\t\t  <li>Telefon komórkowy</li>\n\t\t  <li>Płeć</li>\n\t\t  <li>Stan cywilny</li>\n\t\t  </ul>\n\t\t  <p>Mogą Państwo również zmienić swoje dane bankowe, logując się na swoje konto internetowe. Aby zaktualizować inne dane, proszę skontaktować się z nami na czacie na żywo lub wysłać e-mail na adres support{'@'}aaafx.com.</p>\n\t\t  </div>",
      },
      6: {
        label: "Ile kont Live mogę otworzyć?",
        content:
          '<div class="content"><p>Mogą Państwo otworzyć dowolną liczbę rachunków. Nie ma żadnych ograniczeń.</p></div>',
      },
      7: {
        label: "W ilu walutach bazowych mogę otworzyć konto?",
        content:
          '<div class="content"><p>Mogą Państwo otworzyć rachunek z walutą bazową, taką jak USD, EUR i CHF.</p></div>',
      },
      8: {
        label: "Ile wynosi minimalny depozyt, aby otworzyć konto?",
        content:
          '<div class="content"><p>Minimalny depozyt wynosi tylko 100$.</p></div>',
      },
      9: {
        label: "Czy oferują Państwo konta islamskie (swap free)?",
        content:
          '<div class="content"><p>Tak, mogą Państwo wybrać islamski typ konta podczas tworzenia żądania.</p></div>',
      },
      10: {
        label: "Czy zezwalają Państwo na Hedging?",
        content: '<div class="content"><p>Tak, zezwalamy na Hedging.</p></div>',
      },
      11: {
        label: "Czy zezwalają Państwo na Scalping?",
        content:
          '<div class="content"><p>Tak, zezwalamy na Scalping.</p></div>',
      },
    },
    "Wpłaty i wypłaty": {
      0: {
        label: "Jak mogę dokonać wpłaty na moje konto?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li>1. Proszę zalogować się na swoje konto internetowe</li>\n\t\t  <li>2. Proszę przejść do zakładki Fundusze w lewym panelu</li>.\n\t\t  <li>3. Proszę wybrać rachunek handlowy, który chcesz zasilić.</li>\n\t\t  <li>4. Proszę wybrać preferowaną metodę płatności, której chcesz użyć.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      1: {
        label: "Jak mogę przelewać środki między moimi kontami?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li>1. Proszę zalogować się na swoje konto internetowe</li>\n\t\t  <li>2. Proszę przejść do Zarządzaj kontami w lewym panelu</li>.\n\t\t  <li>3. Proszę kliknąć na przycisk "Transfer wewnętrzny".</li>\n\t\t  <li>4. Proszę wybrać rachunki i wprowadzić kwotę, którą chcą Państwo przelać.</li>\n\t\t  <li>5. Proszę kliknąć Kontynuuj. Środki zostaną natychmiast przelane.</li>\n\t\t  </ul>\n\t\t  <p>W przypadku przelewu wewnętrznego między rachunkami z różnymi walutami bazowymi, kwota przelewu będzie zgodna z obowiązującymi cenami rynkowymi.\n\t\t  </div>',
      },
      2: {
        label: "Jak mogę wypłacić środki z mojego konta?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li>1. Proszę zalogować się na swoje konto internetowe.</li>\n\t\t  <li>2. Proszę przejść do zakładki Fundusze w lewym panelu.</li>\n\t\t  <li>3. proszę kliknąć na zakładkę Wypłaty.</li>\n\t\t  <li>4. Proszę wybrać identyfikator transakcji, z którego chcesz dokonać wypłaty.</li>\n\t\t  <li>5. Proszę wprowadzić kwotę do wypłaty i wybrać tryb wypłaty.</li>\n\t\t  <li>6. proszę kliknąć na Utwórz transakcję.</li>\n\t\t  </ul>.\n\t\t  </div>',
      },
      3: {
        label: "Jak długo trwa przetwarzanie wypłaty?",
        content:
          '<div class="content"><p>Wszystkie wypłaty podlegają 24-godzinnemu czasowi przetwarzania, w tym w weekendy.</p></div>',
      },
      4: {
        label: "Czy są jakieś opłaty za wpłatę/wypłatę?",
        content:
          '<div class="content"><p>Nie, wszystkie wpłaty i wypłaty są bezpłatne z naszej strony.</p></div>',
      },
      5: {
        label:
          "Jak długo trwa odzwierciedlenie depozytu na moim rachunku handlowym?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li><b>Karty bankowe: </b>Płatności są przetwarzane natychmiastowo.</li>\n\t\t  <li><b>Przelew bankowy: </b> Transakcje przelewem bankowym zwykle trwają 2-3 dni robocze, aby do nas dotrzeć.</li>\n\t\t  <li><b>Portfele elektroniczne: </b>Płatności są przetwarzane natychmiastowo. Zwykle zajmuje to do 1 dnia roboczego, aby odzwierciedlić kwotę na Państwa koncie handlowym, jeśli depozyt jest inicjowany przez Skrill.</li>\n\t\t  <li><b>Kryptowaluty: </b>Depozyty kryptowalutowe są księgowane w ciągu 30-40 minut.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      6: {
        label: "Czy zwracają Państwo opłaty transakcyjne?",
        content:
          '<div class="content"><p>AAFx zwraca koszty transakcji poniesione przez Państwa podczas dokonywania wpłaty u nas maksymalnie do 5% wartości transakcji wpłaty.</p></div>',
      },
      7: {
        label:
          "Co się stanie, jeśli nie dokonam transakcji w walucie bazowej mojego konta?",
        content:
          '<div class="content"><p>Kiedy dokonują Państwo wpłaty za pomocą dowolnej waluty, środki pojawią się w walucie bazowej Państwa konta. Przeliczenie zostanie dokonane zgodnie z najlepszą dostępną ceną rynkową w danym momencie.</p></div>',
      },
      8: {
        label: "Kiedy mogę anulować żądanie wpłaty?",
        content:
          "<div class=\"content\"><p>Mogą Państwo anulować każde żądanie wpłaty, wysyłając do nas wiadomość e-mail na adres support{'@'}aaafx.com lub mogą Państwo skontaktować się z naszym działem obsługi klienta na czacie na żywo, a my anulujemy żądanie za Państwa.</p></div>",
      },
      9: {
        label:
          "Czy istnieje sposób na zainicjowanie przelewu środków na mój rachunek handlowy od innego brokera?",
        content:
          '<div class="content"><p>AAFx nie obsługuje transferów środków między brokerami. W celu zainicjowania transferu środków należy postępować zgodnie z określonymi metodami.</p></div>',
      },
      10: {
        label:
          "Czy są jakieś ograniczenia dotyczące minimalnej lub maksymalnej kwoty wypłaty?",
        content:
          '<div class="content"><p>Minimalna kwota wypłaty wynosi 10 USD. Nie ma górnego limitu wypłat.</p></div>',
      },
      11: {
        label:
          "Jaka jest procedura wypłaty środków za pośrednictwem dostępnych metod finansowania?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li>Proszę zalogować się na swoje konto internetowe</li>.\n\t\t  <li>Przejść do zakładki Fundusze w lewym panelu</li>.\n\t\t  <li>Kliknij zakładkę Wypłaty.</li>\n\t\t  <li>Proszę wybrać identyfikator transakcji, z którego chcą Państwo dokonać wypłaty.</li>\n\t\t  <li>Proszę wprowadzić kwotę do wypłaty i wybrać tryb wypłaty.</li>\n\t\t  <li>Kliknij na Utwórz transakcję.</li>\n\t\t  </ul>.\n\t\t  </div>',
      },
      12: {
        label: "Jaki jest standardowy czas przetwarzania wypłaty?",
        content:
          '<div class="content"><p>Wypłaty są zazwyczaj potwierdzane w ciągu 1 dnia roboczego. Od momentu zwolnienia środków z Państwa konta do momentu ich udostępnienia na wskazanym przez Państwa koncie bankowym mija kilka dni roboczych, w zależności od czynników takich jak kraj docelowy, korzystanie z usług banku pośredniczącego itp.</p></div>',
      },
      13: {
        label:
          "Czy mogę zainicjować żądanie wypłaty za pomocą metody innej niż ta, której pierwotnie użyłem do dokonania wpłaty?",
        content:
          "<div class=\"content\"><p>Jeśli źródło depozytu jest nieważne z jakiegoś powodu, mogą Państwo skontaktować się z nami w celu podjęcia odpowiednich działań za pośrednictwem czatu na żywo lub wysyłając wiadomość e-mail na adres <a href=\"mailto:contactus{'@'}aaafx.com\">contactus{'@'}aaafx.com.</a></p></div>",
      },
      14: {
        label: "Czy przetwarzają Państwo wypłaty w weekendy?",
        content:
          '<div class="content"><p>Tak, przetwarzamy wypłaty w weekend.</p></div>',
      },
      15: {
        label:
          "Czy są jakieś okoliczności, w których wypłata może zostać odrzucona?",
        content:
          '<div class="content">\n\t\t  <p>Tak, wniosek o wycofanie może zostać odrzucony. Możliwe powody mogą obejmować:</p>\n\t\t  <ul>\n\t\t  <li>Niewystarczający wolny margines</li>\n\t\t  <li> Nieprawidłowe szczegóły wypłaty</li>\n\t\t  </ul>\n\t\t  <p>Mogą istnieć inne powody, które zostaną określone w przypadku odmowy wypłaty.</p>\n\t\t  </div>',
      },
      16: {
        label: "Kiedy mogę anulować żądanie wypłaty?",
        content:
          "<div class=\"content\"><p>Prośbę o wypłatę można anulować samodzielnie, wysyłając do nas wiadomość e-mail na adres <a href=\"mailto:support{'@'}aaafx.com\">support{'@'}aaafx.com</a> lub kontaktując się z nami za pośrednictwem naszego czatu na żywo, a my anulujemy prośbę za Państwa</p></div>",
      },
      17: {
        label: "Czy są jakieś warunki wycofania?",
        content:
          '<div class="content"><p>Żądanie wypłaty powinno zostać zgłoszone w tej samej metodzie finansowania i w tej samej kwocie, w jakiej dokonano wpłaty.</p><p>Na przykład; jeśli wpłata w wysokości 50 USD została dokonana za pomocą karty bankowej i 100 USD za pomocą przelewu bankowego. W takim przypadku można wypłacić 50 USD za pomocą karty bankowej i 100 USD za pomocą przelewu bankowego. Nie mogą Państwo zainicjować wypłaty na kwotę wyższą niż $50 przy użyciu karty bankowej lub wyższą niż $100 przy użyciu przelewu bankowego.</p><p>Ponadto, gdy wypłacona kwota przekracza kwotę wpłaconą kanałem innym niż przelew bankowy (na przykład wpłata natychmiastowa przy użyciu karty kredytowej lub Moneybookers), pozostała kwota wypłaty zostanie wysłana przelewem bankowym.</p></div>',
      },
      18: {
        label: "Czy mogę wypłacić pieniądze podczas otwartych transakcji?",
        content:
          '<div class="content"><p>Mogą Państwo wypłacić tylko kwoty do wysokości wolnego depozytu zabezpieczającego dostępnego na Państwa rachunkach handlowych. Zazwyczaj zaleca się złożenie wniosku o wypłatę, gdy nie mają Państwo żadnych otwartych transakcji.</p><p>Jednak w przypadku, gdy mają Państwo jakiekolwiek otwarte transakcje, należy sprawdzić największą ilość, którą naprawdę chcieliby Państwo wypłacić. W przypadku, gdy nie mają Państwo wystarczającego dostępnego depozytu zabezpieczającego na rachunku handlowym, wniosek może zostać odrzucony.</p></div>',
      },
      19: {
        label: "Czy akceptują Państwo płatności od osób trzecich?",
        content:
          '<div class="content"><p>Nie, nie akceptujemy żadnych płatności zewnętrznych.</p></div>',
      },
      20: {
        label: "Jak mogę dodawać i zmniejszać środki na i z mojego konta demo?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li>1. Proszę zalogować się na swoje konto internetowe.</li>\n\t\t  <li>2. Proszę przejść do zakładki Fundusze w lewym panelu.</li>\n\t\t  <li>3. Proszę wybrać Depozyty, aby dodać środki do rachunku Demo.</li>\n\t\t  <li>4. Proszę wybrać Wypłaty, aby zmniejszyć środki z rachunku demonstracyjnego.</li>\n\t\t  <li>5. Proszę wybrać numer rachunku, a następnie wprowadzić kwotę, którą chcą Państwo wpłacić/wypłacić.</li>\n\t\t  </ul>.\n\t\t  </div>',
      },
    },
    "Handel na rynku Forex": {
      0: {
        label: "Jak obliczyć zysk/stratę?",
        content:
          '<div class="content">\n\t\t  <p>Kiedy wartość zakupionej waluty rośnie, powstaje zysk; można zabezpieczyć zysk z tej transakcji, sprzedając walutę z powrotem, a tym samym zamykając pozycję. Zobaczmy to na przykładzie, w którym kupujemy dolary amerykańskie i sprzedajemy franki szwajcarskie.\n\t\t  <p>Podany przez Państwa kurs wynosi 1,2755 / 1,2760. Ponieważ kupują Państwo dolary amerykańskie, będą Państwo pracować nad ceną "ask" wynoszącą 1,2760 lub kursem, po którym inwestorzy są gotowi sprzedawać.</p> <p>Załóżmy, że kupują Państwo franki szwajcarskie po kursie 1,2755 / 1,2760.\n\t\t  <p>Załóżmy, że kupują Państwo 1 standardowy lot (100 000 jednostek) po cenie 1,2760.</p> <p>.\n\t\t  <p>Kilka godzin później cena przesuwa się do 1,2780 i decydują się Państwo zamknąć transakcję.</p>\n\t\t  <p>Nowa wycena dla USD/CHF wynosi 1,2780 / 1,2785. Ponieważ zamykają Państwo swoją transakcję, a początkowo kupowali Państwo, aby wejść w transakcję, teraz sprzedają Państwo, aby zamknąć transakcję, więc muszą Państwo przyjąć cenę "bid" 1,2780 lub kurs, po którym inwestorzy są gotowi kupić.</p> <p>Różnica między ceną 1,2780 a ceną 1,2780 wynosi 1,2780.\n\t\t  <p>Różnica między 1,2760 a 1,2780 wynosi .0020 lub 20 pipsów.</p>\n\t\t  <p>Korzystając ze wzoru na obliczanie pipsów, mamy teraz (.0001/1.2780) x 100,000 = $7.82 za pips x 20 pipsów = $156.49 Proszę pamiętać, że wchodząc lub wychodząc z transakcji, podlegają Państwo spreadowi kwotowania kupna/sprzedaży.</p>>\n\t\t  <p>Kupując walutę, będą Państwo korzystać z ceny kupna lub sprzedaży, a sprzedając, będą Państwo korzystać z ceny kupna.</p>\n\t\t  </div>',
      },
      1: {
        label: "Jakie są godziny handlu AAAFx?",
        content:
          '<div class="content"><p>Rynek otwiera się w niedzielę o 22:00 UTC i zamyka w piątek o 22:00 UTC.\n\t\tGdy czas wschodni jest czasem letnim, rynek otwiera się w niedzielę o 21:00 UTC i zamyka w piątek o 21:00 UTC.</p></div>',
      },
      2: {
        label:
          "Dlaczego widzę aktualizację cen przed otwarciem rynku, ale nie mogę handlować?",
        content:
          '<div class="content"><p>Choć rynek otwiera się w niedzielę o godzinie 00:00, mogą Państwo zauważyć niewielkie wahania kursów przed otwarciem. Trading Desk inicjuje odpowiednie usługi i rozpoczyna aktualizację kursów, aby były one przygotowane i dostępne po wznowieniu handlu. Jednak kursy wyświetlane przed oficjalnym otwarciem rynku nie mogą być stosowane do nowych zleceń rynkowych, a handel nie może być wykonywany.</p></div>',
      },
      3: {
        label:
          "Jak wpłynie to na moją otwartą pozycję, jeśli ceny zmienią się od piątkowego zamknięcia do niedzielnego otwarcia?",
        content:
          '<div class="content"><p>W normalnych warunkach rynkowych po otwarciu rynku można zauważyć, że cena otwarcia pary walutowej jest bardzo zbliżona do ceny zarejestrowanej w piątek przed zamknięciem rynku. Zdarzają się jednak sytuacje, w których kursy mogą znacznie wzrosnąć lub spaść, co może mieć pozytywny lub negatywny wpływ na Państwa działalność handlową. Jeśli pojawi się ważne ogłoszenie informacyjne lub ważne wydarzenia gospodarcze, które będą miały wpływ na wartość waluty, istnieje większe prawdopodobieństwo wystąpienia luk na rynku.</p><p>Prosimy pamiętać, że ponieważ cena może zmienić się w stosunku do bieżącej pozycji, może się okazać, że pozycja traci, mimo że była zyskowna w momencie zamknięcia rynku. Z tego powodu inwestorzy posiadający pozycje lub zlecenia w weekend powinni być świadomi takich niekorzystnych luk i być gotowi na potencjalne straty.</p></div>',
      },
      4: {
        label:
          "Dlaczego otrzymałem powiadomienie o wezwaniu do uzupełnienia depozytu zabezpieczającego, gdy rynek był zamknięty?",
        content:
          '<div class="content"><p>Proces otwarcia rynku nie jest natychmiastowy - jest to proces stopniowy, który rozpoczyna się przed godziną 22:00 UTC.</p><p>W rezultacie zaczynamy również otrzymywać stawki przed godziną 22:00, więc generujemy powiadomienia Margin Call lub Stop Out przed tą godziną - jednak transakcje nie są zamykane przed oficjalnym otwarciem rynku o godzinie 22:00.</p><p>Jeśli po otwarciu rynku dostępne stawki nadal znajdują się poniżej poziomu Stop Out, wówczas uruchamiany jest mechanizm Stop Out, a transakcje są zamykane.</p></div>',
      },
      5: {
        label:
          "Cena po otwarciu rynku przekroczyła mój wcześniej ustalony Stop/Limit transakcji. Co stanie się z transakcją?",
        content:
          '<div class="content"><p>Jeśli ustalona wartość Stop zostanie przekroczona w momencie otwarcia rynku, transakcja zostanie zamknięta po kursie obowiązującym w danym momencie. Kurs będzie zależał od płynności dostępnej w danym momencie. Realizacja zlecenia Stop po jakimkolwiek przekroczonym kursie oznacza większe straty niż oczekiwano.</p><p>Jednak, gdy rynek otwiera się po kursie, który przekracza ustawioną przez Państwa wartość Limit, transakcja zostanie zamknięta z wyższym zyskiem niż oczekiwano.</p><p>Zobaczmy to na przykładzie:</p><p>Posiadają Państwo pozycję KUPNA EUR/USD otwartą po cenie 1,1150 z Limitem ustawionym na 1.1350.</p><p>W piątek, gdy rynek został zamknięty, cena pary osiągnęła 1,1250, a w niedzielę, gdy rynek został otwarty z ceną 1,1450.</p><p>Jak widać, cena przekroczyła limit 1,1350, więc transakcja zostanie zamknięta po tej nowej aktualnej cenie, przynosząc zysk w wysokości 300 pipsów zamiast ustawionych 200 pipsów.</p></div>',
      },
      6: {
        label: "Jak mogę chronić moje transakcje zawarte w weekend?",
        content:
          '<div class="content"><p>Jeśli uważają Państwo, że w weekend rynek może być zmienny, a kursy będą poruszać się wbrew Państwa otwartym pozycjom, powinni Państwo przewidzieć ryzyko. Jeśli ta strategia handlowa Państwu nie odpowiada, zaleca się wyjście z transakcji poprzez realizację bieżącego zysku lub straty przed zamknięciem rynku.</p></div>',
      },
      7: {
        label: "Co to jest rollover/swap?",
        content:
          '<div class="content"><p>AAFx automatycznie roluje wszystkie otwarte pozycje o godzinie 21:00 UTC. Handel jest zazwyczaj zawieszany na maksymalnie 1 minutę podczas procesu rolowania. Kwota zapłacona lub zarobiona zależy od kierunku otwartej pozycji i różnicy stóp procentowych między dwiema zaangażowanymi walutami. Na przykład, zakładając, że stopy procentowe w Wielkiej Brytanii są znacznie wyższe niż w Japonii, inwestor zajmujący pozycję długą GBP/JPY (tj. posiadający funta szterlinga) otrzymuje odsetki po rolowaniu. I odwrotnie, jeśli inwestor ma krótką pozycję GBP/JPY (tj. posiada jena), odsetki zostaną pobrane po rolowaniu.</p><p>Dzienny kurs rolowania AAAFx i szczegółowe raporty dotyczące aktywności rolowania są dostępne w kolumnie Swap w Historii rachunku na platformie MT4. Aby uzyskać orientacyjne opłaty za rolowanie, proszę sprawdzić naszą stronę internetową.</p></div>',
      },
      8: {
        label:
          "Jakie są Państwa wymagania dotyczące depozytu zabezpieczającego dla Stop-Out (Margin Call)?",
        content:
          '<div class="content"><p>Poziom, przy którym Stop-Out zostanie uruchomiony na Państwa rachunku, wynosi 70 % wymaganego depozytu zabezpieczającego, np. jeśli wymagany depozyt zabezpieczający wynosi 1 000 USD, a kapitał na rachunku osiągnie 700 USD, wszystkie otwarte pozycje zostaną automatycznie zamknięte.</p><p>Proszę pamiętać, że AAAFx wystawi wezwanie do uzupełnienia depozytu zabezpieczającego, gdy kapitał osiągnie 100 % wymaganego depozytu zabezpieczającego i powiadomi Państwa e-mailem, aby mogli Państwo podjąć natychmiastowe działania w celu uniknięcia Stop-Out.</p></div>',
      },
      9: {
        label: "Jak uniknąć Stop Out (Margin Call)?",
        content:
          '<div class="content">\n\t\t  <p><b>Wystarczający depozyt zabezpieczający</b></p>\n\t\t  <p>Ogólnie rzecz biorąc, aby uniknąć Stop-Out, należy upewnić się, że zawsze mają Państwo wystarczający depozyt zabezpieczający, aby utrzymać otwarte pozycje i wytrzymać ich potencjalne wypłaty. Tak długo, jak Państwa kapitał własny wynosi ponad 70% depozytu zabezpieczającego wykorzystanego dla aktualnie otwartych pozycji, Stop-Out nie wystąpi na Państwa rachunku. Proszę pamiętać, że możesz monitorować swój poziom depozytu zabezpieczającego z poziomu MT4 w dowolnym momencie; im wyższy procent poziomu depozytu zabezpieczającego, tym mniejsze prawdopodobieństwo wystąpienia Stop-Out.</p>\n\t\t  <p>Proszę pamiętać, że AAAFx wystawi wezwanie do uzupełnienia depozytu zabezpieczającego, gdy Państwa kapitał osiągnie 100% wymaganego depozytu zabezpieczającego i powiadomi Państwa o tym e-mailem, aby mogli Państwo podjąć natychmiastowe działania w celu uniknięcia Stop-Out. Co więcej, przy 100% poziomie depozytu zabezpieczającego linia informacyjna na terminalu Państwa rachunku MT4 zostanie podświetlona z szarej na czerwoną.</p>\n\t\t  <p><b>Zamykanie otwartych pozycji</b></p>\n\t\t  <p>Szybkim sposobem na zwiększenie poziomu depozytu zabezpieczającego i zmniejszenie szans na Stop-Out jest zamknięcie niektórych pozycji, tak aby depozyt zabezpieczający, który został użyty do ich otwarcia, został uwolniony z powrotem do Państwa kapitału.</p>\n\t\t  <p><b>Zwiększenie środków</b></p>\n\t\t  <p>Innym sposobem na uniknięcie nadmiernej ekspozycji, zwiększenie poziomu depozytu zabezpieczającego, a tym samym zmniejszenie szansy na Stop-Out, jest zdeponowanie większej ilości środków. Mogą Państwo skorzystać z metody natychmiastowej wpłaty, aby dokonać natychmiastowej instalacji kapitału na swoim rachunku. Aby to zrobić, wystarczy odwiedzić zakładkę Fundusze w sekcji Logowanie klienta.</p>\n\t\t  <p><b>Unikanie nadmiernej dźwigni finansowej</b></p>\n\t\t  <p>Kolejnym czynnikiem, który może narazić Państwa rachunek na ryzyko Stop-Out, jest nadmierna dźwignia finansowa. Korzystanie z większej dźwigni finansowej może potencjalnie zwiększyć zyski, ale może również zwiększyć straty, które szybko wyczerpią użyteczny depozyt zabezpieczający. Im większa dźwignia finansowa, tym szybciej straty mogą się kumulować.\n\t\t  <p>Kiedy korzystają Państwo z nadmiernej dźwigni finansowej, fakt, że Państwa rachunek ma większy potencjał handlowy, może łatwo doprowadzić do jego przeeksponowania, a tym samym spowodować straty. Aby wyraźnie zobaczyć, jak może się to stać, proszę rozważyć następujący przykład:</p>\n\t\t  <p>Trader A posiada rachunek z kapitałem 500 USD i korzysta z dźwigni 200:1, podczas gdy Trader B posiada rachunek z kapitałem 500 USD i dźwignią 100:1.</p>\n\t\t  <p>Trader A może handlować do 100 000 jednostek walutowych i decyduje się na handel 60% swojego kapitału, więc otwiera 6 transakcji po 0,1 standardowego lota każda (łącznie 60 000 USD), a tym samym wykorzystuje 300 USD depozytu zabezpieczającego (50 USD x 0,6 lota), zachowując 200 USD więcej jako wolny depozyt zabezpieczający. Każdy pips poruszający się w tej wielkości transakcji jest równy 1 USD, więc jeśli wszystkie otwarte transakcje osiągną najniższy poziom 290 pipsów (strata około 48 pipsów w każdej transakcji), jego kapitał własny wyniesie 210 USD. Kiedy tak się stanie, jego poziom depozytu zabezpieczającego wyniesie 70% (210/300), a zatem nastąpi Stop Out i zamknięcie wszystkich otwartych transakcji na jego koncie.\n\t\t  <p>Trader B z drugiej strony może handlować do 50 000 jednostek walutowych i decyduje się na handel 60% swojego kapitału. Ponieważ w tym przypadku 0,1 standardowego lota wymaga 100 USD depozytu zabezpieczającego, połowa kapitału jest odpowiednia dla 3 transakcji po 0,1 standardowego lota każda (łącznie 30 000 USD). Ponownie, każdy pips poruszający się w tej wielkości transakcji jest równy 1 USD, więc jeśli wszystkie otwarte transakcje osiągną minimum 48 pipsów, całkowite minimum wyniesie 144, a zatem jego Equity wyniesie 356. Kiedy to nastąpi, jego poziom depozytu zabezpieczającego wyniesie 118% (356/300), więc nie będzie zagrożony Stop Out.</p> <p>.\n\t\t  <p> Podsumowując, dźwignia finansowa jest narzędziem, które może zwiększyć Państwa zyski lub straty o tę samą wielkość; im większa kwota dźwigni finansowej na kapitale, który Państwo stosują, tym większe ryzyko, które Państwo podejmują.\n\t\t  </div>',
      },
      10: {
        label:
          "Dlaczego moja transakcja została naruszona, mimo że na wykresie MT4 widzę, że stopa krytyczna nie została osiągnięta?",
        content:
          '<div class="content">\n\t\t  <p>Proszę pamiętać, że wykresy MT4 pokazują tylko ceny Bid, a nie ceny Ask (różnica między nimi to spread).\n\t\t  <p>Proszę również pamiętać, że kiedy otwierasz transakcję Sell, otwiera się ona po cenie Bid (Buy) i zamyka po cenie Ask (Sell), podczas gdy kiedy otwierasz transakcję Buy, otwiera się ona po cenie Ask (Sell) i zamyka po cenie Bid (Buy).</p>\n\t\t  <p>Można jednak zawsze zobaczyć dokładne kursy, po których handluje się na rachunku, w oknie Market Watch w MT4.\n\t\t  </div>',
      },
      11: {
        label: "Czy w przypadku zleceń klientów AAAFx występuje poślizg?",
        content:
          '<div class="content">\n\t\t  <p>Poślizg odnosi się do różnicy między żądaną ceną zlecenia a ceną, po której zlecenie jest faktycznie realizowane. Istnieją wydarzenia/warunki rynkowe, które powodują dużą zmienność, a tym samym zwiększają prawdopodobieństwo wystąpienia poślizgu, takie jak wiadomości lub ogłoszenia rynkowe.\n\t\t  <p>W takich przypadkach AAAFx wypełnia zlecenia po najlepszej dostępnej cenie, w oparciu o żądaną cenę i w zależności od kwoty oraz rodzaju zleceń. Może to spowodować, że zlecenie przyniesie wyniki, które są bardziej korzystne, równe lub mniej korzystne niż pierwotne oczekiwania, przy czym wyniki te są określane odpowiednio jako dodatni poślizg, brak poślizgu i ujemny poślizg.\n\t\t  </div>',
      },
      12: {
        label: "Czy AAAFx zapewnia ochronę przed ujemnym saldem?",
        content:
          '<div class="content"><p>AAFx działa na zasadzie "ochrony przed ujemnym saldem", co oznacza, że klient nie może stracić więcej niż jego całkowity zainwestowany kapitał (depozyt). AAAFx ustala według własnego uznania i w dobrej wierze, że wystąpienie takiego ujemnego salda nie jest spowodowane złośliwym lub niewłaściwym zachowaniem Klienta i nie zostało celowo spowodowane przez Klienta.</p></div>',
      },
    },
    "Metale i kontrakty CFD": {
      0: {
        label:
          "Jaka jest minimalna wielkość lota dla handlu metalami i kontraktami CFD?",
        content:
          '<div class="content"><p>Minimalna wielkość lota dla metali i kontraktów CFD wynosi 1 standardowy lot.</p></div>',
      },
      1: {
        label:
          "Ile wynosi jedna standardowa partia złota (XAU/USD) i srebra (XAG/USD)?",
        content:
          '<div class="content"><p>1 standardowa partia złota (XAU/USD) jest równa 1 uncji (oz) złota i 1 standardowa partia srebra (XAG/USD) jest równa 50 uncjom (oz) srebra.</p></div>',
      },
      2: {
        label:
          "Jaki depozyt zabezpieczający jest wymagany do handlu kontraktami CFD i jakie są godziny handlu?",
        content:
          '<div class="content"><p>Proszę znaleźć wszystkie informacje na temat CFD w sekcji Glosariusz, CFD.</p></div>',
      },
      3: {
        label:
          "Jaki depozyt zabezpieczający jest wymagany do handlu złotem (XAU/USD) i srebrem (XAG/USD) na moim rachunku AAAFx?",
        content:
          '<div class="content"><p>Wymagany depozyt zabezpieczający dla złota (XAU/USD) wynosi 100% bieżącej ceny, a wartość pipsa wynosi 0,01 USD. Wymagany depozyt zabezpieczający dla srebra (XAG/USD) wynosi 200% bieżącej ceny pomnożonej przez wielkość kontraktu (mnożnik), a wartość pipsa wynosi 0,5 USD.</p></div>',
      },
      4: {
        label:
          "Dlaczego moja transakcja USOilSpot/UKOil/NGAS/BUND/Copper została zamknięta? Stop lub limit nie zostały osiągnięte i nie otrzymałem również wezwania do uzupełnienia depozytu zabezpieczającego.",
        content:
          '<div class="content"><p>Obligacje niemieckie mają daty wygaśnięcia, zgodnie z tabelą w sekcji Towary i akcje, Daty wygaśnięcia. W rezultacie klienci zrealizują wszelkie zmienne zyski/straty w momencie zamknięcia pozycji z powodu wygaśnięcia.</p></div>',
      },
      5: {
        label:
          "Jaki depozyt zabezpieczający jest wymagany do handlu BTC/USD na moim rachunku AAAFx?",
        content:
          '<div class="content"><p>Wymagany depozyt zabezpieczający dla Bitcoina (BTC/USD) wynosi 1000% aktualnej ceny, a wartość pipsa to 0,01 USD.</p></div>',
      },
      6: {
        label: "Jaka jest prowizja pobierana za kontrakt BTC/USD?",
        content:
          '<div class="content"><p>Prowizja wynosi 0,0008*Cena na rachunku ECN Plus.</p></div>',
      },
      7: {
        label: "Jaka jest minimalna wielkość kontraktu dla handlu BTC/USD?",
        content:
          '<div class="content"><p>Minimalna wielkość kontraktu wynosi 1 kontrakt = 1 BTC. Oznacza to, że przy kursie BTC/USD wynoszącym około 35 000 USD potrzebują Państwo 7 000 USD depozytu zabezpieczającego, aby otworzyć (kupić lub sprzedać) minimalne zlecenie.</p></div>',
      },
      8: {
        label:
          "Jaki depozyt zabezpieczający jest wymagany do handlu ETH/USD na moim rachunku AAAFx?",
        content:
          '<div class="content"><p>Wymagany depozyt zabezpieczający dla Ethereum (ETH/USD) wynosi 1000% aktualnej ceny.</p></div>',
      },
      9: {
        label: "Jaka jest maksymalna liczba kontraktów ETH/USD na klienta?",
        content:
          '<div class="content"><p>Istnieje limit 1000 kontraktów całkowitej ekspozycji (np. 500 kupna i 500 sprzedaży = 1K) na klienta.</p></div>',
      },
      10: {
        label:
          "Jaki depozyt zabezpieczający jest wymagany do handlu LTC/USD na moim rachunku AAAFx?",
        content:
          '<div class="content"><p>Wymagany depozyt zabezpieczający dla Litecoin (LTC/USD) wynosi 1000% aktualnej ceny.</p></div>',
      },
      11: {
        label: "Jaka jest maksymalna liczba kontraktów LTC/USD na klienta?",
        content:
          '<div class="content"><p>Istnieje limit 1000 Kontraktów całkowitej ekspozycji (np. 500 kupna i 500 sprzedaży = 1K) na klienta.</p></div>',
      },
    },
    "Podstawowe informacje o rynku Forex": {
      0: {
        label: "Czym jest Forex?",
        content:
          '<div class="content"><p>Rynek walutowy (Forex, FX lub rynek walutowy) jest formą wymiany dla globalnego zdecentralizowanego handlu walutami. Centra finansowe na całym świecie funkcjonują jako kotwice handlu między szeroką gamą różnych typów kupujących i sprzedających przez całą dobę, z wyjątkiem weekendów. Rynek walutowy określa względne wartości różnych walut</p></div>',
      },
      1: {
        label: "Jak duży jest rynek walutowy?",
        content:
          '<div class="content"><p>Rynek walutowy jest najbardziej płynnym rynkiem finansowym na świecie. Średnie dzienne obroty na globalnym rynku walutowym i rynkach powiązanych stale rosną. Według Triennial Central Bank Survey z 2010 r., koordynowanego przez Bank Rozrachunków, średnie dzienne obroty wyniosły 3,98 bln USD w kwietniu 2010 r. (w porównaniu do 1,7 bln USD w 1998 r.). Z tych 3,98 bln USD, 1,5 bln USD stanowiły transakcje kasowe, a 2,5 bln USD obrót bezpośrednimi transakcjami terminowymi, swapami i innymi instrumentami pochodnymi.</p></div>',
      },
      2: {
        label: "Gdzie znajduje się rynek walutowy?",
        content:
          '<div class="content"><p>Nie istnieje ujednolicony lub centralnie rozliczany rynek dla większości transakcji i istnieje bardzo niewiele regulacji transgranicznych. Ze względu na pozagiełdowy (OTC) charakter rynków walutowych, istnieje raczej szereg wzajemnie połączonych rynków, na których handluje się różnymi instrumentami walutowymi. Oznacza to, że nie ma jednego kursu wymiany, ale raczej wiele różnych kursów (cen), w zależności od tego, jaki bank lub animator rynku handluje i gdzie się znajduje.</p></div>',
      },
      3: {
        label: "Kto uczestniczy w rynku?",
        content:
          '<div class="content"><p>W przeciwieństwie do rynku akcji, rynek walutowy jest podzielony na poziomy dostępu. Na szczycie znajduje się rynek międzybankowy, który składa się z największych banków komercyjnych i dealerów papierów wartościowych. Rynek międzybankowy najwyższego szczebla odpowiada za 53% wszystkich transakcji. Następnie transakcje zawierane są przez mniejsze banki, a następnie duże międzynarodowe korporacje, duże fundusze hedgingowe, a nawet niektórych animatorów rynku detalicznego. Jednak udział innych uczestników rynku, takich jak brokerzy, międzynarodowe korporacje, zarejestrowani dealerzy, a także prywatni inwestorzy szybko rośnie.</p></div>',
      },
      4: {
        label: "Co to jest Lot?",
        content:
          '<div class="content"><p>Lot to standardowa wielkość jednostki transakcji. Zazwyczaj w przypadku walut Forex jeden standardowy lot jest równy 100 000 jednostek waluty bazowej, 10 000 jednostek, jeśli jest to mini lot, lub 1 000 jednostek, jeśli jest to mikro lot.</p></div>',
      },
      5: {
        label: "Jaki jest spread?",
        content:
          '<div class="content"><p>Różnica pomiędzy cenami Bid i Ask jest określana jako Spread. AAAFx oferuje jedne z najniższych spreadów na rynku Forex.</p></div>',
      },
      6: {
        label: "Co to jest Pip/Tick?",
        content:
          '<div class="content"><p>Pips (lub tick) to najmniejszy przyrost ceny, jaki może osiągnąć waluta. Jest to czwarta cyfra we wszystkich parach walutowych, z wyjątkiem jena japońskiego (JPY), gdzie jest to druga cyfra (na przykład 1 pips = 0,0001 dla EUR/USD lub 0,01 dla USD/JPY.)</p></div>',
      },
      7: {
        label: "Jak obliczyć wartość 1 pipsa?",
        content:
          '<div class="content">\n\t\t  <p>Aby wyrazić wartość w walucie, proszę pomnożyć 1 pips przez wielkość lota.</p>\n\t\t  <ul>\n\t\t  <li>EUR/USD pip = 0.0001 X 100,000 = $10.00 (dla standardowych lotów)</li>\n\t\t  <li>EUR/USD pip = 0.0001 X 10,000 = $1.00 (dla mini lotów)</li>\n\t\t  <li>EUR/USD pip = 0,0001 X 1,000 = 0,1 USD (dla mikro lotów)</li>\n\t\t  <li>GBP/JPY pip = 0.01 X 100,000 = 1000 ¥ (dla standardowych lotów)</li>\n\t\t  </ul>\n\t\t  <p>Aby przeliczyć na walutę bazową, proszę podzielić przez kurs wymiany:</p>\n\t\t  <p>Na przykład kurs wymiany EUR/USD = 1,4750, a następnie 10,00 USD / 1,4750 = 6,78 EUR</p>\n\t\t  <p>Aby przeliczyć na walutę konta (np. USD) proszę podzielić przez kurs wymiany $/¥:</p>\n\t\t  <p>Jeśli $/¥ = 82,12 to 1000 ¥ / 82,12 = 12,17$</p>\n\t\t  </div>',
      },
      8: {
        label: "Jakie jest siedem głównych par walutowych?",
        content:
          '<div class="content">\n\t\t  <p>Siedem najbardziej płynnych par jest przedmiotem obrotu w stosunku do dolara amerykańskiego, przy czym pierwsze cztery pary to pary główne, a następnie trzy pary towarowe. Inne pary walutowe są lepiej znane jako crossy walutowe, z których najpopularniejsze to te, które zawierają euro: EUR/JPY, EUR/GBP i EUR/CHF.</p> <p>.\n\t\t  <p>Główne pary walutowe to:</p>\n\t\t  <ul>\n\t\t  <li>EUR/USD</li>\n\t\t  <li>USD/JPY</li>\n\t\t  <li>USD/CHF</li>\n\t\t  <li>GBP/USD</li>\n\t\t  </ul>\n\t\t  <p>Towarowe pary walutowe to:</p>\n\t\t  <ul>\n\t\t  <li>AUD/USD</li>\n\t\t  <li>NZD/USD</li>\n\t\t  <li>USD/CAD</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      9: {
        label: "Czym jest dźwignia finansowa?",
        content:
          '<div class="content"><p>Dźwignia Forex lub dźwignia finansowa oznacza po prostu procentową kwotę pieniędzy, którą mogą Państwo pożyczyć od brokera podczas otwierania pozycji. Dźwignia określa procent wartości nominalnej transakcji, który jest wymagany jako depozyt zabezpieczający. Mówiąc prościej, można traktować dźwignię finansową jako pożyczkę, która pozwala na zakup walut.</p></div>',
      },
      10: {
        label: "Co to jest marża?",
        content:
          '<div class="content"><p>Typowo, w celu uwolnienia dźwigni finansowej, brokerzy zażądają alokacji określonej kwoty rzeczywistych środków rachunku na każdą pozycję (lot) będącą przedmiotem obrotu. Tak więc depozyt zabezpieczający to minimalna kwota, która jest przechowywana w celu otwarcia pozycji. Depozyt zabezpieczający zależy od dźwigni finansowej konta; na przykład, jeśli dźwignia wynosi 1:30, wówczas mogą Państwo handlować pozycją trzydzieści razy większą niż kwota depozytu zabezpieczającego. Mówiąc prościej, można myśleć o depozycie zabezpieczającym jako o depozycie w dobrej wierze wymaganym do uwolnienia pożyczki (dźwigni).</p><p>Na przykład, posiadanie dźwigni 100:1 (lub 1% wymaganej pozycji) pozwala na handel pozycją o wartości 100 000 USD przy kapitale własnym wynoszącym zaledwie 5000 USD. Byłoby to możliwe, ponieważ broker odłożyłby 1000 USD jako zaliczkę lub "depozyt zabezpieczający", a resztę pozwoliłby Państwu "pożyczyć". Oczywiście wszelkie straty lub zyski zostaną odjęte lub dodane do pozostałego salda gotówkowego na Państwa rachunku.</p></div>',
      },
    },
    "CFD na akcje": {
      0: {
        label: "Jak działają kontrakty CFD na akcje?",
        content:
          '<div class="content"><p>Zapasy (lub akcje) spółek giełdowych mogą być przedmiotem spekulacji. Brokerzy internetowi mogą oferować kontrakty na różnice kursowe (CFD) z akcjami różnych spółek jako aktywami bazowymi dla tych kontraktów CFD. Kiedy kupowany jest kontrakt CFD na akcje, kupujący nie jest w rzeczywistości właścicielem samych akcji, a jedynie spekuluje na ruchach cen tych akcji za pomocą kontraktu CFD.</p><p>W przypadku kontraktów CFD na akcje (kontraktów na różnice kursowe) inwestorzy mogą zająć pozycję długą (kupno) lub krótką (sprzedaż). W przypadku długiej pozycji, wzrost ceny przyniesie zysk. Z drugiej strony, krótka pozycja przynosi zyski, gdy cena akcji spada.</p></div>',
      },
      1: {
        label: "Co wpływa na rynek akcji?",
        content:
          '<div class="content"><p>Cena akcji zależy od popytu i podaży. Siły, które wpływają na podaż i popyt są wielorakie - czynniki fundamentalne (np. zysk na akcję), nastroje inwestorów, czynniki techniczne, wiadomości o danej spółce lub jej sektorze przemysłu itp.</p></div>',
      },
      2: {
        label:
          "Jaka jest różnica między handlem akcjami i kontraktami CFD na akcje?",
        content:
          '<div class="content"><p>Transakcje CFD przypominają transakcje na akcjach, z tą różnicą, że w przypadku kontraktów na różnice kursowe nie są Państwo właścicielami instrumentu bazowego, w przeciwieństwie do akcji spółki, w przypadku których są Państwo właścicielami instrumentu bazowego. To, co zasadniczo robisz z handlem CFD, to kupowanie kontraktu między Tobą a dostawcą CFD, który, w zależności od Twojej pozycji ("Krótka sprzedaż" lub "Kupno"), będzie miał cenę wejścia przy wejściu w transakcję i cenę wyjścia przy rozliczeniu transakcji z równą przeciwną pozycją.</p><p>Jedną z kluczowych różnic między długim handlem CFD a kupnem papieru wartościowego jest to, że możesz cieszyć się większą dźwignią finansową. Kontrakty na różnice kursowe są przedmiotem obrotu z depozytem zabezpieczającym, co oznacza, że nie ma potrzeby wiązania pełnej wartości rynkowej zakupu równoważnej pozycji giełdowej.</p><p>Istnieje również szereg kluczowych różnic między handlem aktywami bazowymi a kontraktami CFD:</p>\n\t\t  <ul>\n\t\t  <li>Zapasy CFD mogą być przedmiotem obrotu długiego lub krótkiego i nie są Państwo zobowiązani do dostarczenia aktywów bazowych w przypadku krótkiej sprzedaży.</li>\n\t\t  <li>Inwestor nie jest właścicielem instrumentu bazowego, na którym oparty jest kontrakt CFD, ale zamiast tego zawiera umowę z brokerem CFD w celu wymiany różnicy w cenie między ceną otwarcia i zamknięcia kontraktu.</li>\n\t\t  <li>W przeciwieństwie do posiadania aktywów bazowych, kontrakt CFD jest przedmiotem obrotu z depozytem zabezpieczającym, co oznacza, że początkowy depozyt jest składany u brokera CFD, co pozwala inwestorowi kupować lub sprzedawać pewną liczbę kontraktów CFD zgodnie z obliczeniami depozytu zabezpieczającego, co generalnie pozwala na dodatkową dźwignię finansową w stosunku do samego zakupu akcji.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      3: {
        label: "Jaka jest dźwignia finansowa dla kontraktów CFD na akcje?",
        content:
          '<div class="content"><p>Podobnie jak w przypadku wszystkich innych kontraktów CFD na akcje, poziom dźwigni wynosi 1:5. Przykład: Załóżmy, że kupują Państwo 5 kontraktów CFD na Facebook po cenie 400 USD. Wymagany depozyt zabezpieczający wynosi 20%, a zatem będą Państwo musieli wydać tylko 100 USD, co pozostawi Państwu więcej pieniędzy do wykorzystania w innych transakcjach.</p></div>',
      },
      4: {
        label: "Jakie kontrakty CFD na akcje Państwo oferują?",
        content:
          '<div class="content"><p>W chwili obecnej oferujemy najpopularniejsze akcje z DOW30 i Nasdaq, proszę zobaczyć pełną listę <a href="/stocks">tutaj</a></p></div>',
      },
      5: {
        label: "Jakie są godziny handlu kontraktami CFD na akcje?",
        content:
          '<div class="content"><p>W przeciwieństwie do rynku Forex, na którym można handlować 24 godziny na dobę, 5 dni w tygodniu, globalne rynki akcji są otwarte tylko przez około 6,5 do 8,5 godzin dziennie, 5 dni w tygodniu, w zależności od giełdy. Godziny, w których można handlować akcjami różnych krajów, również różnią się w zależności od strefy czasowej danego kraju.</p><p>Wspieramy kontrakty CFD na amerykańskie akcje, dlatego przestrzegamy regularnych godzin sesji giełdowych na amerykańskim rynku akcji (NASDAQ, Dow 30): Dni robocze 09:30-16:00 (wschodni czas standardowy - EST).</p><p>Dla greckich kontraktów CFD na akcje godziny handlu to: Dni robocze 08:35-15:00 (UTC)</p></div>',
      },
      6: {
        label: "Czym są działania korporacyjne?",
        content:
          '<div class="content"><p>Działania korporacyjne to zdarzenia inicjowane przez spółkę notowaną na giełdzie, które zazwyczaj mają bezpośredni lub pośredni wpływ na akcjonariuszy i skutkują istotnymi zmianami jej akcji poprzez wpływ na cenę, liczbę akcji w obrocie lub inne cechy (np. nazwę giełdową). Działania korporacyjne obejmują podziały akcji, dywidendy, fuzje, przejęcia, emisje praw poboru i wydzielenia. Wszystkie te działania są ważnymi decyzjami, które zazwyczaj muszą zostać zatwierdzone przez zarząd spółki i autoryzowane przez jej akcjonariuszy. Działania korporacyjne są informacjami publicznymi, a daty odpowiednich działań są dostępne w różnych źródłach internetowych.</p></div>',
      },
      7: {
        label: "Czym jest dywidenda z akcji?",
        content:
          '<div class="content"><p>Dywidenda to nagroda, którą spółki przekazują swoim akcjonariuszom i która pochodzi z zysku netto spółki. Takie nagrody mogą mieć formę gotówki, ekwiwalentu gotówki, akcji itp. i są najczęściej wypłacane z pozostałej części zysku po pokryciu niezbędnych wydatków. Najprościej rzecz ujmując, dywidenda to udział inwestora w zyskach spółki.</p></div>',
      },
      8: {
        label: "Kto jest uprawniony do otrzymania dywidendy?",
        content:
          '<div class="content"><p>Kupując kontrakty CFD na akcje spółki, zazwyczaj korzystają Państwo z wszelkich dywidend wypłacanych przez spółkę z tytułu tych akcji. Inwestorzy CFD na akcje są uprawnieni do dywidendy, jeśli utrzymają akcje do dnia wypłaty dywidendy. W zależności od rodzaju pozycji (długa/krótka), otrzymają oni dywidendę lub zostaną nią obciążeni w dniu wypłaty.</p><p>Jeśli kupią Państwo kontrakt CFD na akcje w dniu wypłaty dywidendy lub później, nie otrzymają Państwo nadchodzącej wypłaty dywidendy. Zamiast tego, sprzedawca w tej sytuacji otrzyma dywidendę.</p><p>Prosimy pamiętać, że dywidendy z akcji zostaną wypłacone na Państwa konto po potrąceniu wszelkich należnych podatków u źródła. Płatność faktycznie pojawi się na Państwa koncie jako dodatkowa gotówka.</p></div>',
      },
      9: {
        label: "Co to jest podział akcji?",
        content:
          '<div class="content"><p>Kiedy spółka ogłasza podział akcji, liczba akcji tej spółki wzrasta, ale kapitalizacja rynkowa pozostaje taka sama. Działanie to, które wymaga wcześniejszego zatwierdzenia przez zarząd spółki, zwykle wiąże się z emisją dodatkowych akcji na rzecz obecnych posiadaczy akcji.</p><p>Na przykład spółka ABC ma 4 miliony wyemitowanych akcji, a każda akcja ma wartość 10 USD. W tym przypadku całkowita wartość rynkowa spółki wynosi 40 mln USD (4 mln x 10 USD/akcję). Po przeprowadzeniu splitu akcji w stosunku dwa do jednego, liczba akcji spółki podwoi się do 8 milionów, podczas gdy wartość tych akcji zmniejszy się o połowę do 5 USD. Jednak całkowita kapitalizacja rynkowa spółki pozostanie taka sama i wyniesie zaledwie 40 milionów USD (8 milionów * 5 USD/akcję).</p></div>',
      },
      10: {
        label: "Czy otrzymam dywidendę z kontraktów CFD na akcje?",
        content:
          '<div class="content"><p>Inwestorzy CFD na akcje, w zależności od rodzaju pozycji (długa/krótka), są uprawnieni do otrzymania lub pobrania dywidendy, jeśli utrzymują pozycję na akcjach po zakończeniu dnia dywidendy. Dywidendy są informacjami publicznymi, a ich daty można łatwo znaleźć w Internecie.</p></div>',
      },
      11: {
        label: "Jaka jest minimalna wielkość transakcji?",
        content:
          '<div class="content"><p>Minimalna wielkość transakcji to 1 lot na zlecenie, który reprezentuje jedną akcję.</p></div>',
      },
      12: {
        label: "Jaki jest oficjalny harmonogram świąt dla amerykańskich akcji?",
        content:
          '<div class="content"><p>Proszę sprawdzić poniżej dni, w których US Market jest oficjalnie zamknięty:</p>\n\t\t  <ul>\n\t\t  <li>Piątek</li>\n\t\t  <li>Dzień Pamięci</li>\n\t\t  <li>Dzień Niepodległości</li>\n\t\t  <li>Dzień Pracy</li>\n\t\t  <li>Dzień Dziękczynienia</li>\n\t\t  <li>Święto Bożego Narodzenia</li>\n\t\t  </ul>\n\t\t  </div>',
      },
    },
    "Platformy handlowe – Informacje ogólne": {
      0: {
        label: "Jakie ceny pokazuje wykres na platformie transakcyjnej?",
        content:
          '<div class="content"><p>Wykresy na platformie transakcyjnej domyślnie pokazują ceny bid. Można jednak wyświetlić linię ask, wykonując poniższe czynności:</p>\n\t\t  <ul>\n\t\t  <li>Kliknąć prawym przyciskiem myszy w dowolnym miejscu na wykresie i wybrać Właściwości.</li>\n\t\t  <li>Kliknij na zakładkę Wspólne i zaznacz pole Pokaż linię Ask.</li>\n\t\t  <li>Kliknij przycisk OK, a na wykresie MT4 pojawi się linia Ask.</li>.\n\t\t  </ul>\n\t\t  </div>',
      },
      1: {
        label:
          "Jak mogę wygenerować wyciąg z mojego rachunku handlowego na platformie transakcyjnej?",
        content:
          '<div class="content"><p>Proszę wykonać poniższe kroki, aby pobrać wyciąg z rachunku handlowego z platformy handlowej:</p>\n\t\t  <ul>\n\t\t  <li>Zaloguj się na swój rachunek handlowy</li>\n\t\t  <li>Kliknij na zakładkę "Historia rachunku"</li>\n\t\t  <li>Kliknąć prawym przyciskiem myszy na puste pole, a następnie kliknąć na "cała historia"</li>.\n\t\t  <li>Po wyświetleniu pełnej historii proszę kliknąć prawym przyciskiem myszy i wybrać "Zapisz jako szczegółowy raport"</li>.\n\t\t  </ul>\n\t\t  <p>Wyciąg zostanie pobrany na Państwa urządzenie.</p>\n\t\t  </div>',
      },
      2: {
        label:
          "Jak ukryć lub wyświetlić więcej par/instrumentów w oknie obserwacji rynku?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li>Kliknąć prawym przyciskiem myszy na dowolnym instrumencie</li>\n\t\t  <li>Proszę wybrać opcję "symbole"</li>.\n\t\t  </ul>\n\t\t  <p>Spośród listy forex, indeksów i towarów proszę wybrać parę, którą chcesz ukryć lub pokazać.(Skrót: Ctrl U)</p>\n\t\t  </div>',
      },
      3: {
        label: "Jak mogę zobaczyć szczegóły dotyczące instrumentu handlowego?",
        content:
          '<div class="content"><p>Aby zobaczyć szczegóły dotyczące instrumentu handlowego :</p>\n\t\t  <ul>\n\t\t  <li>Kliknąć prawym przyciskiem myszy na instrument handlowy</li>\n\t\t  <li>Proszę wybrać "Specyfikacja".</li>\n\t\t  </ul>\n\t\t  <p>Można sprawdzić w oknie dialogowym specyfikacji kontraktu istotne informacje, takie jak spread, wielkość kontraktu, punkty swapowe itp.\n\t\t  </div>',
      },
      4: {
        label: "Jak mogę aktywować handel jednym kliknięciem na platformie?",
        content:
          '<div class="content"><p>Skrót: Alt T lub kliknięcie prawym przyciskiem myszy na wykresie i włączenie funkcji One-Click Trading</p></div>',
      },
      5: {
        label: "Co to jest hasło inwestora? Dlaczego go potrzebuję?",
        content:
          "<div class=\"content\"><p>Hasło inwestora to inna nazwa \"hasła tylko do odczytu\". Hasło inwestora wchodzi w grę, gdy chcą Państwo, aby osoba trzecia mogła przeglądać transakcje na Państwa rachunku bez wykonywania jakichkolwiek innych czynności. Aby wygenerować hasło inwestora, proszę zalogować się na swoje konto handlowe. Proszę kliknąć na Narzędzia>Opcje>Serwer, a następnie wybrać Zmień.</p><p>Mogą Państwo również zmienić/generować hasło inwestora bezpośrednio ze swojego konta internetowego. Proszę postępować zgodnie z poniższymi krokami:</p><ol><li>Zaloguj się do swojego konta internetowego</li><li>Wybierz 'Zarządzaj kontami' z lewego panelu</li><li>Kliknij na 'Resetuj hasło handlowe' > 'Hasło inwestora'</li></ol></div>",
      },
      6: {
        label: "Czy jest jakiś sposób na zmianę czasu na moich wykresach?",
        content:
          '<div class="content"><p>Czasy na wykresach na platformach transakcyjnych są zgodne z czasem serwera. W AAAFx czas serwera jest ustawiony na UTC LUB UTC+1 w zależności od czasu letniego.</p></div>',
      },
      7: {
        label:
          "Czy mogę dostosować wykresy na platformie transakcyjnej? Jeśli tak, to w jaki sposób?",
        content:
          '<div class="content"><p>Tak, wykresy można dostosować, wykonując poniższe czynności:</p>\n\t\t  <ul>\n\t\t  <li>Proszę kliknąć prawym przyciskiem myszy na okno wykresu.</li>\n\t\t  <li>Proszę wybrać opcję "Właściwości"</li>.\n\t\t  <li>Można zmienić kolory wykresu według własnego uznania.</li>\n\t\t  </ul>\n\t\t  <p>Dla innych modyfikacji, proszę wybrać zakładkę "Wspólne".</p>\n\t\t  </div>',
      },
      8: {
        label:
          "Czy mogę zalogować się na więcej niż jeden rachunek handlowy w tym samym czasie?",
        content:
          '<div class="content"><p>Tak, mogą Państwo zalogować się do wielu rachunków handlowych na jednej platformie transakcyjnej. Jednakże, handel może być prowadzony tylko na jednym rachunku handlowym w tym samym czasie.</p></div>',
      },
    },
    "Platformy handlowe - MT4": {
      0: {
        label: "Jak zalogować się do mojego rachunku handlowego MT4?",
        content:
          '<div class="content"><p>Aby zalogować się do platformy MT4 proszę wykonać następujące kroki</p>\n\t\t  <ul>\n\t\t  <li>Proszę kliknąć na opcję "Plik" na pasku menu</li>.\n\t\t  <li>Proszę wybrać opcję logowania do rachunku handlowego</li>.\n\t\t  <li>Proszę wpisać swój identyfikator handlowy i hasło</li>\n\t\t  <li>Proszę wybrać nazwę serwera: AAAFx-FX-Demo (dla rachunku demonstracyjnego) / AAAFx-FX-Real (dla rachunku rzeczywistego)</li>.\n\t\t  <li>Proszę kliknąć na login</li>.\n\t\t  </ul>\n\t\t  <p>Zostaną Państwo zalogowani do swojego rachunku transakcyjnego</p>\n\t\t  </div>',
      },
      1: {
        label: "Jak zalogować się na rachunek rzeczywisty w MT4?",
        content:
          '<div class="content"><p>Aby zalogować się na rachunek rzeczywisty na platformie MT4, proszę wykonać następujące kroki:</p>\n\t\t  <p>Najpierw proszę utworzyć rachunek rzeczywisty na portalu. Aby utworzyć rachunek rzeczywisty, proszę wykonać następujące kroki:</p>\n\t\t  <ul>\n\t\t  <li>Zarejestruj się: Proszę kliknąć na opcję "Dołącz teraz" na portalu</li>.\n\t\t  <li>Proszę wprowadzić swoje dane: Imię i nazwisko, identyfikator e-mail, numer telefonu</li>\n\t\t  <li>Wprowadź kod weryfikacyjny, który otrzymałeś w wiadomości e-mail</li>\n\t\t  <li>Proszę wybrać platformę, typ konta, walutę bazową konta, dźwignię finansową i ustawić hasło do konta.\n\t\t  <li>Następnie należy przesłać dokumenty</li>.\n\t\t  <li>Teraz proszę wpłacić środki</li>.\n\t\t  </ul>\n\t\t  <p>Następnie proszę wykonać następujące kroki, aby zalogować się na platformie:</p>\n\t\t  <ul>\n\t\t  <li>Kliknąć na opcję "Plik" na pasku menu</li>\n\t\t  <li>Proszę wybrać opcję "Zaloguj się do rachunku handlowego"</li>.\n\t\t  <li>Wprowadź swój identyfikator handlowy i hasło</li>\n\t\t  <li>Proszę wybrać Serwer: AAA Fx-FX-Real</li>\n\t\t  <li>Proszę kliknąć na "Zaloguj się"</li>.\n\t\t  </ul>\n\t\t  </div>',
      },
      2: {
        label: "Jak utworzyć/zalogować się na rachunek demo?",
        content:
          '<div class="content"><p>Aby utworzyć konto demo, proszę wykonać następujące kroki:</p>\n\t\t  <ol>\n\t\t  <li>Proszę zalogować się na swoje konto internetowe.</li>\n\t\t  <li>Proszę przejść do "Zarządzaj kontami"</li>.\n\t\t  <li>Proszę kliknąć na "Utwórz rachunek demo"</li>.\n\t\t  <li>Proszę wybrać platformę transakcyjną, dźwignię konta, walutę bazową konta i ustawić hasło.</li>\n\t\t  </ol>\n\t\t  <p>Teraz rachunek demonstracyjny został dla Państwa utworzony.</p>\n\t\t  </div>',
      },
      3: {
        label: "Gdzie mogę zobaczyć moje prowizje?",
        content:
          '<div class="content"><p>Aby zobaczyć prowizję, proszę wykonać następujące kroki:</p>\n\t\t  <ul>\n\t\t  <li>Proszę kliknąć na opcję "Widok" na pasku menu</li>.\n\t\t  <li>Proszę wybrać "Terminal"</li>.\n\t\t  <li>Proszę wybrać "Sekcja handlowa"</li>.\n\t\t  <li>Kliknąć prawym przyciskiem myszy na zawartą transakcję</li>\n\t\t  <li>Włącz prowizje </li>.\n\t\t  </ul>\n\t\t  <p>Teraz mogą Państwo zobaczyć prowizje jako oddzielną kolumnę</p>\n\t\t  </div>',
      },
      4: {
        label:
          "Jak mogę zmienić hasło do mojego rachunku handlowego z poziomu platformy?",
        content:
          '<div class="content"><p>Proszę postępować zgodnie z poniższymi krokami, aby zmienić hasło do konta MT4:</p>\n\t\t  <ul>\n\t\t  <li>Kliknij na "Narzędzia" na pasku menu</li>\n\t\t  <li>Proszę wybrać "Opcje" > Pojawi się okno dialogowe</li>.\n\t\t  <li>Proszę wpisać nowe hasło > OK</li>.\n\t\t  </ul>.\n\t\t  <LUB</p>\n\t\t  <ul>\n\t\t  <li>W oknie nawigacji, w sekcji Konta > Proszę kliknąć prawym przyciskiem myszy na konto, dla którego ma zostać zmienione hasło</li>.\n\t\t  <li>Wprowadzić aktualne hasło i nowe hasło > Kliknąć na Okay</li>.\n\t\t  </ul>\n\t\t  </div>',
      },
      5: {
        label: "Jak mogę usunąć swój rachunek z platformy MT4?",
        content:
          '<div class="content"><p>Aby usunąć swój rachunek z platformy MT4, proszę kliknąć prawym przyciskiem myszy na rachunek, który ma zostać usunięty i wybrać opcję "Usuń".</p></div>',
      },
      6: {
        label: "Skąd mogę pobrać platformę MT4?",
        content:
          '<div class="content"><p>Aby pobrać platformę proszę wykonać następujące kroki:</p>\n\t\t  <ul>\n\t\t  <li>Proszę kliknąć na zakładkę "Platforma" na portalu</li>.\n\t\t  <li>Proszę kliknąć na "Pobierz tutaj"</li>.\n\t\t  </ul>\n\t\t  </div>',
      },
      7: {
        label: "Czy mogę korzystać z EA / BOT / robota handlowego?",
        content:
          '<div class="content"><p>Z pewnością mogą Państwo korzystać z Expert Advisor w MT4. Proszę sprawdzić te, które są swobodnie dostępne w oknie nawigacji. Jeśli chcą Państwo, można również zakupić EA na stronie MQL 5.</p></div>',
      },
      8: {
        label: "Jak mogę dołączyć EA w MT4?",
        content:
          '<div class="content"><p>Aby dołączyć EA, proszę wykonać następujące kroki:</p>\n\t\t  <ul>\n\t\t  <li>Proszę otworzyć okno nawigatora (Ctrl N)</li>.\n\t\t  <li>Expert Advisor</li>\n\t\t  <li>Kliknij prawym przyciskiem myszy na EA, którego chcesz użyć</li>\n\t\t  <li>Przyłącz do wykresu </li>.\n\t\t  </ul>\n\t\t  <p>A w przypadku chęci zastosowania zakupionego EA ze strony MQL, proszę wykonać następujące kroki:</p>\n\t\t  <ul>\n\t\t  <li>Proszę przejść do zakładki "Plik" na pasku menu</li>\n\t\t  <li>Proszę kliknąć na Otwórz folder danych </li>.\n\t\t  <li>Proszę otworzyć folder "Eksperci" w pliku "MQL".</li>\n\t\t  <li>Otworzyć folder "Eksperci" w pliku "MQL".</li>\n\t\t  <li>Proszę ponownie otworzyć platformę MT4.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      9: {
        label: "Jak skonfigurować domyślne wykresy ze wskaźnikami na MT4?",
        content:
          '<div class="content"><p>Proszę wykonać poniższe kroki:</p>\n\t\t  <p><b>Aby zapisać profil:</b></p>\n\t\t  <p>Po ustawieniu wszystkiego tak, jak chcesz, proszę przejść do Plik - Profile i kliknąć "Zapisz jako" Wprowadź nazwę profilu, a następnie naciśnij "Ok"</p>\n\t\t  <p>Aby załadować zapisany profil, proszę przejść do Plik - Profile, a następnie wybrać profil z listy profili, która się pojawi. Profil powinien się załadować.</p>\n\t\t  <p><b>Aby zapisać szablon:</b></p>\n\t\t  <p>Po skonfigurowaniu wszystkiego na wykresie, proszę przejść do Wykresy - Szablon - Zapisz szablon, aby zapisać szablon. Proszę wprowadzić nazwę szablonu i nacisnąć przycisk Zapisz.\n\t\t  </p>\n\t\t  </div>',
      },
      10: {
        label: "Czy mogę korzystać z wielu rachunków handlowych w MT4?",
        content:
          '<div class="content"><p>Tak, mogą Państwo korzystać z wielu kont handlowych w MT4, aby dodać konto proszę wykonać następujące kroki:</p>\n\t\t  <ul>\n\t\t  <li>Kliknąć prawym przyciskiem myszy na rachunki w oknie nawigatora</li>\n\t\t  <li>Proszę wybrać "Zaloguj się do rachunku handlowego"</li>.\n\t\t  <li>Proszę wpisać swój identyfikator handlowy i hasło</li>.\n\t\t  </ul>\n\t\t  <p>Państwa rachunek transakcyjny zostanie dodany do MT4.</p>\n\t\t  </div>',
      },
      11: {
        label:
          "Gdzie mogę sprawdzić status połączenia z moim rachunkiem handlowym?",
        content:
          '<div class="content"><p>Stan połączenia można sprawdzić w prawym dolnym rogu pod oknem terminala.</p><p>Aby status połączenia był widoczny, proszę kliknąć na "view" > enable status bar</p></div>',
      },
    },
    "Platformy handlowe - MT5": {
      0: {
        label: "Jak zalogować się do mojego rachunku handlowego MT5?",
        content:
          '<div class="content"><p>Aby zalogować się do platformy MT5 proszę wykonać następujące kroki</p>\n\t\t  <ul>\n\t\t  <li>Proszę kliknąć na opcję "Plik" na pasku menu</li>.\n\t\t  <li>Proszę wybrać opcję logowania do rachunku handlowego</li>.\n\t\t  <li>Proszę wpisać swój identyfikator handlowy i hasło</li>\n\t\t  <li>Proszę wybrać nazwę serwera: AAAFx-FX-Demo (dla rachunku demonstracyjnego) / AAAFx-FX-Real (dla rachunku rzeczywistego)</li>.\n\t\t  <li>Proszę kliknąć na login</li>.\n\t\t  <p>Zostaną Państwo zalogowani do swojego rachunku transakcyjnego</p>\n\t\t  </ul>\n\t\t  </div>',
      },
      1: {
        label: "Jak zalogować się na rachunek rzeczywisty w MT5?",
        content:
          '<div class="content"><p>Aby zalogować się na rachunek rzeczywisty na platformie MT5, proszę wykonać następujące kroki</p>\n\t\t  <p>Najpierw należy utworzyć rachunek rzeczywisty na portalu. Aby utworzyć rachunek rzeczywisty, proszę wykonać następujące kroki:</p>\n\t\t  <ul>\n\t\t  <li>Zarejestruj się: Proszę kliknąć na opcję "Dołącz teraz" na portalu</li>.\n\t\t  <li>Proszę wprowadzić swoje dane: Imię i nazwisko, identyfikator e-mail, numer telefonu</li>\n\t\t  <li>Wprowadź kod weryfikacyjny, który otrzymałeś w wiadomości e-mail</li>\n\t\t  <li>Proszę wybrać walutę bazową konta i platformę transakcyjną</li>.\n\t\t  <li>Następnie należy przesłać dokumenty</li>.\n\t\t  <li>Teraz proszę wpłacić środki.</li>\n\t\t  </ul>\n\t\t  <p>Następnie proszę wykonać następujące kroki, aby zalogować się do platformy:</p>\n\t\t  <ul>\n\t\t  <li>Proszę kliknąć na opcję "Plik" na pasku menu</li>.\n\t\t  <li>Proszę wybrać opcję "Zaloguj się do rachunku handlowego"</li>.\n\t\t  <li>Wprowadź swój identyfikator handlowy i hasło</li>\n\t\t  <li>Proszę wybrać Serwer: AAA Fx-FX-Real</li>\n\t\t  <li>Proszę kliknąć na "Zaloguj się"</li>.\n\t\t  </ul>\n\t\t  </div>',
      },
      2: {
        label: "Jak utworzyć/zalogować się na rachunek demo?",
        content:
          '<div class="content"><p>Aby utworzyć konto demo, proszę wykonać następujące kroki:</p>\n\t\t  <ol>\n\t\t  <li>Proszę zalogować się na swoje konto internetowe.</li>\n\t\t  <li>Proszę przejść do "Zarządzaj kontami"</li>.\n\t\t  <li>Proszę kliknąć na "Utwórz rachunek demonstracyjny"</li>.\n\t\t  <li>Proszę wybrać platformę transakcyjną, dźwignię konta, walutę bazową konta i ustawić hasło.</li>\n\t\t  </ol>\n\t\t  <p>Teraz rachunek demonstracyjny został dla Państwa utworzony.</p>\n\t\t  </div>',
      },
      3: {
        label: "Gdzie mogę zobaczyć moje prowizje?",
        content:
          '<div class="content"><p>Aby zobaczyć prowizję, proszę wykonać następujące kroki:</p>\n\t\t  <ul>\n\t\t  <li>Proszę kliknąć na opcję "Widok" na pasku menu</li>.\n\t\t  <li>Proszę wybrać "Terminal"</li>.\n\t\t  <li>Proszę wybrać "Sekcja handlowa"</li>.\n\t\t  <li>Kliknąć prawym przyciskiem myszy na zawartą transakcję</li>\n\t\t  <li>Włączyć prowizje</li>.\n\t\t  </ul>\n\t\t  <p>Teraz mogą Państwo zobaczyć prowizje jako oddzielną kolumnę</p>\n\t\t  </div>',
      },
      4: {
        label:
          "Jak mogę zmienić hasło do mojego rachunku handlowego z poziomu platformy?",
        content:
          '<div class="content"><p>Proszę postępować zgodnie z poniższymi krokami, aby zmienić hasło do konta w MT5:</p>\n\t\t  <ul>\n\t\t  <li>Kliknij na "Narzędzia" na pasku menu</li>\n\t\t  <li>Proszę wybrać "Opcje" > Pojawi się okno dialogowe</li>.\n\t\t  <li>Proszę wpisać nowe hasło > OK</li>.\n\t\t  </ul>.\n\t\t  <LUB</p>\n\t\t  <ul>\n\t\t  <li>W oknie nawigacji, w sekcji Konta > Proszę kliknąć prawym przyciskiem myszy na konto, dla którego ma zostać zmienione hasło</li>.\n\t\t  <li>Wprowadzić aktualne hasło i nowe hasło > Kliknąć na Okay</li>.\n\t\t  </ul>\n\t\t  </div>',
      },
      5: {
        label: "Jak mogę usunąć swój rachunek z platformy MT5?",
        content:
          '<div class="content"><p>Aby usunąć swój rachunek z platformy MT5, proszę kliknąć prawym przyciskiem myszy na rachunek, który ma zostać usunięty i wybrać opcję "Usuń".</p></div>',
      },
      6: {
        label: "Skąd mogę pobrać platformę MT5?",
        content:
          '<div class="content"><p>Aby pobrać platformę proszę wykonać następujące kroki:</p>\n\t\t  <ul>\n\t\t  <li>Proszę kliknąć na zakładkę "Platforma" na portalu</li>.\n\t\t  <li>Proszę kliknąć na "Pobierz tutaj"</li>.\n\t\t  </ul>\n\t\t  </div>',
      },
      7: {
        label: "Czy mogę korzystać z EA / BOT / robota handlowego?",
        content:
          '<div class="content"><p>Z pewnością mogą Państwo korzystać z Expert Advisor w MT5. Proszę sprawdzić te, które są swobodnie dostępne w oknie nawigacji. Jeśli chcą Państwo, można również zakupić EA na stronie MQL 5.</p></div>',
      },
      8: {
        label: "Jak mogę dołączyć EA w MT5?",
        content:
          '<div class="content"><p>Aby dołączyć EA, proszę wykonać następujące kroki:</p>\n\t\t  <ul>\n\t\t  <li>Proszę otworzyć okno nawigatora (Ctrl N)</li>.\n\t\t  <li>Expert Advisor</li>\n\t\t  <li>Kliknij prawym przyciskiem myszy na EA, którego chcesz użyć</li>\n\t\t  <li>Przyłącz do wykresu </li>.\n\t\t  </ul>\n\t\t  <p>A w przypadku chęci zastosowania zakupionego EA ze strony MQL, proszę wykonać następujące kroki:</p>\n\t\t  <ul>\n\t\t  <li>Proszę przejść do zakładki "Plik" na pasku menu</li>\n\t\t  <li>Proszę kliknąć na Otwórz folder danych </li>.\n\t\t  <li>Proszę otworzyć folder "Eksperci" w pliku "MQL".</li>\n\t\t  <li>Otworzyć folder "Eksperci" w pliku "MQL".</li>\n\t\t  <li>Proszę ponownie otworzyć platformę MT4.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      9: {
        label: "Jak skonfigurować domyślne wykresy ze wskaźnikami na MT5?",
        content:
          '<div class="content"><p>Proszę wykonać poniższe kroki:</p>\n\t\t  <p><b>Aby zapisać profil:</b></p>\n\t\t  <p>Po ustawieniu wszystkiego tak, jak chcesz, proszę przejść do Plik - Profile i kliknąć "Zapisz jako" Wprowadź nazwę profilu, a następnie naciśnij "Ok"</p>\n\t\t  <p>Aby załadować zapisany profil, proszę przejść do Plik - Profile, a następnie wybrać profil z listy profili, która się pojawi. Profil powinien się załadować.</p>\n\t\t  <p><b>Aby zapisać szablon:</b></p>\n\t\t  <p>Po skonfigurowaniu wszystkiego na wykresie, proszę przejść do Wykresy - Szablon - Zapisz szablon, aby zapisać szablon. Proszę wprowadzić nazwę szablonu i nacisnąć przycisk Zapisz.\n\t\t  </p>\n\t\t  </div>',
      },
      10: {
        label: "Czy mogę korzystać z wielu rachunków handlowych w MT5?",
        content:
          '<div class="content"><p>Tak, mogą Państwo korzystać z wielu kont handlowych w MT5, aby dodać konto proszę wykonać następujące kroki:</p>\n\t\t  <ul>\n\t\t  <li>Kliknąć prawym przyciskiem myszy na rachunki w oknie nawigatora</li>\n\t\t  <li>Proszę wybrać "Zaloguj się do rachunku handlowego"</li>.\n\t\t  <li>Proszę wpisać swój identyfikator handlowy i hasło</li>.\n\t\t  </ul>\n\t\t  <p>Państwa rachunek transakcyjny zostanie dodany do MT5.</p>\n\t\t  </div>',
      },
      11: {
        label:
          "Gdzie mogę sprawdzić status połączenia z moim rachunkiem handlowym?",
        content:
          '<div class="content"><p>Stan połączenia można sprawdzić w prawym dolnym rogu pod oknem terminala.</p><p>Aby status połączenia był widoczny, proszę kliknąć na "view" > enable status bar</p></div>',
      },
    },
    "Platformy handlowe - ActTrader": {
      0: {
        label:
          "Jak mogę zalogować się do mojego rachunku handlowego w ACT na pulpicie?",
        content:
          '<div class="content"><p>Proszę wykonać poniższe kroki, aby zalogować się na swoje konto handlowe:</p>\n\t\t  <ul>\n\t\t  <li>Proszę kliknąć na <a href="https://aaafx.com/act-trader" target="_blank">link</a>, aby pobrać platformę transakcyjną.</li>.\n\t\t  <li>Instalacja zostanie pobrana do systemu. Proszę kliknąć na instalator, a platforma zostanie zainstalowana.</li>\n\t\t  <li>Po zainstalowaniu platformy proszę wprowadzić nazwę użytkownika i hasło do konta handlowego.</li>\n\t\t  <li>Proszę wybrać serwer - "Demo" dla rachunku demonstracyjnego i "Real" dla rachunku rzeczywistego.</li>\n\t\t  <li>Proszę kliknąć na "Zaloguj się". Zostaną Państwo zalogowani na swoje konto.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      1: {
        label:
          "Jak zalogować się do swojego rachunku handlowego na platformie ACT on web trader?",
        content:
          '<div class="content"><p>Proszę postępować zgodnie z poniższymi krokami, aby zalogować się do swojego konta handlowego na platformie Web Trader:</p>\n\t\t  <ul>\n\t\t  <li>Proszę kliknąć na <a href="https://aaafx.com/act-trader" target="_blank">link</a>, aby otworzyć Web Trader</li>.\n\t\t  <li>Pojawi się nowa zakładka.</li>\n\t\t  <li>Proszę wprowadzić nazwę użytkownika i hasło do rachunku handlowego.</li>\n\t\t  <li>Proszę kliknąć na "Zaloguj się". Zostaną Państwo zalogowani do swojego rachunku.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      2: {
        label:
          "Nie wiem, jak zainstalować aplikację ACT na moim urządzeniu mobilnym. Proszę mi pomóc.",
        content:
          '<div class="content"><p>Proszę wykonać poniższe kroki, aby zainstalować aplikację na swoim urządzeniu mobilnym:</p>\n\t\t  <p><b>ANDROID</b></p>\n\t\t  <ul>\n\t\t  <li>Zaloguj się do swojego portalu klienta na urządzeniu mobilnym.</li>\n\t\t  <li>Proszę kliknąć na <a href="https://aaafx.com/act-trader" target="_blank">link</a></li>.\n\t\t  <li>Przewinąć do dołu okna i kliknąć "ACT ANDROID".</li>\n\t\t  <li>Otworzy się sklep Google i pojawi się aplikacja o nazwie \'ActDroid\'.</li>\n\t\t  <li>Kliknij na \'Zainstaluj\', a aplikacja zostanie zainstalowana na Państwa urządzeniu.</li>\n\t\t  </ul>\n\t\t  <p><b>IOS</b></p>\n\t\t  <ul>\n\t\t  <li>Zaloguj się do swojego portalu klienta na urządzeniu mobilnym.</li>\n\t\t  <li>Proszę kliknąć na <a href="https://aaafx.com/act-trader" target="_blank">link</a></li>.\n\t\t  <li>Przewiń do dołu okna i kliknij ACT IOS.</li>\n\t\t  <li>Otworzy się sklep Google i pojawi się aplikacja o nazwie \'ActPhone\'.</li>\n\t\t  <li>Kliknij "Zainstaluj", a aplikacja zostanie zainstalowana na Państwa urządzeniu.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      3: {
        label:
          "Jak mogę zalogować się do mojego rachunku handlowego na urządzeniu mobilnym?",
        content:
          '<div class="content"><p>Proszę wykonać poniższe kroki, aby zalogować się na swoje konto handlowe na urządzeniu mobilnym:</p>\n\t\t  <p><b>ANDROID</b></p>\n\t\t  <ul>\n\t\t\t<li>Kliknij na aplikację ActDroid na swoim urządzeniu.</li>\n\t\t\t<li>Proszę nacisnąć "Zgadzam się" na umowie licencyjnej.</li>\n\t\t\t<li>Proszę wprowadzić nazwę użytkownika i hasło do rachunku handlowego.</li>\n\t\t\t<li>W zakładce "Typ rachunku" proszę wybrać serwer zgodnie z typem rachunku - "AAAFx-FX-Demo" dla rachunku demo i "AAAFx-FX-Real" dla rachunku rzeczywistego.</li>\n\t\t\t<li>Proszę kliknąć na "Zaloguj się". Są Państwo teraz zalogowani do swojego rachunku.</li>\n\t\t  </ul>\n\t\t  <p><b>IOS</b></p>\n\t\t  <ul>\n\t\t\t<li>Kliknąć na aplikację ActPhone na Państwa urządzeniu.</li>\n\t\t\t<li>Proszę wprowadzić nazwę użytkownika i hasło do rachunku handlowego.</li>\n\t\t\t<li>W zakładce "Typ rachunku" proszę wybrać serwer zgodnie z typem rachunku - "AAAFx-FX-Demo" dla rachunku demo i "AAAFx-FX-Real" dla rachunku rzeczywistego.</li>\n\t\t\t<li>Proszę kliknąć na "Zaloguj się". Są Państwo teraz zalogowani do swojego rachunku.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      4: {
        label: "Jak mogę złożyć zamówienie?",
        content:
          '<div class="content"><p>Można łatwo dokonać transakcji, klikając przyciski Sprzedaj lub Kup w zakładce Strona główna paska narzędzi FXVoyager.</p><p>Można również złożyć zlecenie rynkowe bezpośrednio z okna Kursy transakcyjne, okna Instrumenty lub tabeli kursów transakcyjnych. Wystarczy kliknąć lewym przyciskiem myszy na cenę kupna lub sprzedaży lub kliknąć prawym przyciskiem myszy na kurs i wybrać opcję Zlecenie rynkowe.</p></div>',
      },
      5: {
        label:
          "Jak mogę sprawdzić saldo mojego rachunku handlowego na platformie transakcyjnej?",
        content:
          '<div class="content"><p>Stan konta można sprawdzić w następujący sposób:</p>\n\t\t  <ul>\n\t\t  <li>Zaloguj się do swojego rachunku handlowego.</li>\n\t\t  </li>Proszę kliknąć na zakładkę "Podsumowanie".\n\t\t  </ul>\n\t\t  <p>Pojawią się wszystkie informacje o rachunku, w tym saldo.</p>\n\t\t  <LUB</p>\n\t\t  <p>Stan konta można sprawdzić w lewym dolnym rogu platformy.</p>\n\t\t  </div>',
      },
      6: {
        label: "Czy w ACT mogę zalogować się na kilka kont jednocześnie?",
        content:
          '<div class="content"><p>Nie, ACT nie pozwala użytkownikowi na zalogowanie się do wielu kont handlowych w tym samym czasie.</p></div>',
      },
      7: {
        label: "Jak mogę włączyć handel jednym kliknięciem?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li>Kliknij ikonę ustawienia w lewym górnym rogu</li>.\n\t\t  <li>Proszę wybrać "ustawienia główne"</li>.\n\t\t  <li>Proszę zaznaczyć opcję "Handel jednym kliknięciem"</li>.\n\t\t  <li>Kliknij na Zastosuj</li>.\n\t\t  </ul>\n\t\t  </div>',
      },
      8: {
        label: "Czy mogę zastosować wskaźniki na moim wykresie? W jaki sposób?",
        content:
          '<div class="content"><p>Proszę wykonać poniższe kroki, aby zastosować wskaźniki na swoim wykresie:</p>\n\t\t  <ul>\n\t\t  <li>Otwórz wykres, na którym chcesz zastosować wskaźnik.</li>\n\t\t  <li>Przesunąć kursor na wykres. Proszę kliknąć prawym przyciskiem myszy na obszar wykresu.</li>\n\t\t  <li>Proszę wybrać opcję "Ustaw wskaźniki".</li>\n\t\t  <li>Otworzy się okno z różnymi wskaźnikami.</li>.\n\t\t  <li>Proszę wybrać wskaźnik i nacisnąć przycisk dalej " > "</li>.\n\t\t  <li>Można zmienić ustawienia wybranego wskaźnika w obszarze koperty przed zastosowaniem.</li>\n\t\t  <li>Proszę kliknąć "Zastosuj", a następnie "Ok".</li>\n\t\t  </ul>\n\t\t  <p>Zobaczą Państwo, że wskaźnik został zastosowany na Państwa wykresie.</p>\n\t\t  </div>',
      },
      9: {
        label: "Jak usunąć wskaźnik z wykresu?",
        content:
          '<div class="content"><p>Proszę wykonać poniższe kroki, aby usunąć wskaźniki z wykresu:</p>\n\t\t  <ul>\n\t\t  <li>Otworzyć wykres, z którego chcą Państwo usunąć wskaźnik.</li>\n\t\t  <li>Przesunąć kursor na wykres. Proszę kliknąć prawym przyciskiem myszy na obszar wykresu.</li>\n\t\t  <li>Proszę wybrać opcję "Ustaw wskaźniki".</li>\n\t\t  <li>Otworzy się okno z różnymi wskaźnikami.</li>.\n\t\t  <li>W zakładce "aktywne wskaźniki" można zobaczyć listę wszystkich zastosowanych wskaźników.</li>\n\t\t  <li>Proszę wybrać wskaźnik i nacisnąć przycisk wstecz " < "</li>.\n\t\t  <li>Proszę kliknąć na "Zastosuj", a następnie "Ok".</li>\n\t\t  </ul>\n\t\t  <p>Zobaczą Państwo, że wskaźnik został usunięty z wykresu.</p>\n\t\t  </div>',
      },
      10: {
        label: "Czy mogę usunąć wiele wskaźników z wykresu?",
        content:
          '<div class="content"><p>Tak, z pewnością może Pan to zrobić.</p>\n\t\t  <ul>\n\t\t  <li>Otworzyć wykres, na którym chcą Państwo usunąć wskaźnik.</li>\n\t\t  <Proszę przesunąć kursor na wykres. Proszę kliknąć prawym przyciskiem myszy na obszar wykresu.</li>\n\t\t  <li>Proszę wybrać opcję "Ustaw wskaźniki".</li>\n\t\t  <li>Otworzy się okno z różnymi wskaźnikami.</li>.\n\t\t  <li>W zakładce "aktywne wskaźniki" można zobaczyć listę wszystkich zastosowanych wskaźników.</li>\n\t\t  <li>Kliknij przycisk szybkiego cofania " << ", aby usunąć wszystkie wskaźniki</li>.\n\t\t  <li>Proszę kliknąć "Zastosuj", a następnie "Ok".</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      11: {
        label: "Skąd mogę otworzyć okno kursu transakcyjnego?",
        content:
          '<div class="content"><p>Proszę wykonać poniższe kroki, aby otworzyć okno kursu transakcyjnego:</p>\n\t\t  <ul>\n\t\t  <li>Zaloguj się na swój rachunek handlowy na platformie.</li>\n\t\t  <li>Kliknij na zakładkę "Instrument".</li>\n\t\t  <li>Przesunąć kursor w kierunku konkretnego instrumentu.</li>\n\t\t  <li>Kliknąć prawym przyciskiem myszy i wybrać "Okno indywidualnego kursu transakcyjnego".</li>\n\t\t  <li>Otworzy się wyskakujące okienko z kursem transakcyjnym danej pary.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      12: {
        label: "Jak mogę złożyć zamówienie z okna kursu transakcyjnego?",
        content:
          '<div class="content"><p>Proszę wykonać poniższe kroki, aby otworzyć okno kursu transakcyjnego:</p>\n\t\t  <ul>\n\t\t  <li>Zaloguj się na swój rachunek handlowy na platformie.</li>\n\t\t  <li>Kliknij na zakładkę "Instrument".</li>\n\t\t  <li>Przesunąć kursor w kierunku konkretnego instrumentu.</li>\n\t\t  <li>Kliknąć prawym przyciskiem myszy i wybrać "Okno indywidualnego kursu transakcyjnego".</li>\n\t\t  <li>Otworzy się wyskakujące okienko z kursem transakcyjnym danej pary.</li>\n\t\t  <li>Kliknij dwukrotnie na wyskakujące okienko, zmień wymagane ustawienia i kliknij "OK", aby złożyć zamówienie.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      13: {
        label:
          "Czy mogę pobrać wyciąg z mojego rachunku handlowego z platformy transakcyjnej?",
        content:
          '<div class="content"><p>Tak, wyciąg z rachunku handlowego można pobrać z platformy, wykonując poniższe czynności:</p>\n\t\t  <ul>\n\t\t  <li>Zaloguj się do swojego rachunku handlowego na platformie.</li>\n\t\t  <li>Kliknij na "Raporty".</li>\n\t\t  <li>Proszę wybrać "Wyciąg z rachunku".</li>\n\t\t  <li>Proszę wybrać format czasu i kliknąć na "Uruchom raport".</li>.\n\t\t  <li>Raport otworzy się na ekranie. Proszę wybrać "Export to excel". Raport otworzy się w arkuszu excel, z którego można go zapisać.</li>.\n\t\t  </ul>\n\t\t  </div>',
      },
      14: {
        label:
          " Chcę zmodyfikować moje zlecenie sprzedaży. Jak mogę zastosować poziomy Stop Loss i Take Profit do mojego zlecenia?",
        content:
          '<div class="content"><p>Aby zmodyfikować zlecenie, proszę otworzyć zakładkę "Handel" na pasku narzędzi i kliknąć przycisk "Stop lub Limit". Zlecenie Stop lub Limit można ustawić w oknie Otwarte pozycje. Mogą Państwo również ustawić Predefiniowany Stop lub Limit w oknie dialogowym Nowa Pozycja.</p></div>',
      },
      15: {
        label: "Jak mogę zamknąć transakcję na wykresie?",
        content:
          '<div class="content"><p>Aby zamknąć lub zabezpieczyć pozycję, proszę kliknąć prawym przyciskiem myszy na trójkąt pozycji i wybrać odpowiednie polecenie.</p></div>',
      },
      16: {
        label: "Jak mogę dodać Trailing Stop do zlecenia?",
        content:
          '<div class="content"><p>Proszę wykonać poniższe kroki, aby dodać Trailing Stop do swojego zlecenia:</p>\n\t\t  <ul>\n\t\t  <li>W oknie Otwarte pozycje, proszę kliknąć prawym przyciskiem myszy na wybraną pozycję.</li>\n\t\t  <li>Na ekranie pojawi się menu podręczne.</li>\n\t\t  <li>Proszę wybrać poziom Trailing Stop i kliknąć "OK".</li>\n\t\t  </ul>.\n\t\t  </div>',
      },
      17: {
        label: "Gdzie mogę zobaczyć swoją historię transakcji?",
        content:
          '<div class="content"><p>Historię pozycji można przeglądać w oknie Zamknięte pozycje.</p></div>',
      },
      18: {
        label: "Jak mogę wyświetlić historię transakcji na IOS?",
        content:
          '<div class="content"><p>Aby wyświetlić historię na Ios, proszę kliknąć Menu > Historia. Domyślnie można wyświetlić do 15 pozycji. Liczbę pozycji można zwiększyć, otwierając Menu > Ustawienia.</p></div>',
      },
      19: {
        label: "Jak mogę otworzyć wykres instrumentu handlowego?",
        content:
          '<div class="content"><p>Aby otworzyć okno wykresu w obszarze roboczym handlu, proszę wybrać "Wykresy" w górnym menu panelu, a następnie wybrać "Nowy wykres".</p>\n\t\t  <LUB</p>\n\t\t  <p>Proszę kliknąć prawym przyciskiem myszy na instrument w oknie kursów transakcyjnych i wybrać opcję Otwórz wykres. Proszę wybrać instrument (jeśli kliknęli Państwo prawym przyciskiem myszy na instrument, aby przejść do okna dialogowego Nowy wykres, wówczas instrument ten zostanie wstępnie wybrany) oraz skalę czasową z menu Nowy wykres i nacisnąć OK.\n\t\t  </p>\n\t\t  </div>',
      },
      20: {
        label: "Jak mogę powiększyć i pomniejszyć wykres?",
        content:
          '<div class="content"><p>W górnej części wykresu ikony plus "+" i minus "-" umożliwiają powiększanie, pomniejszanie i domyślne wyświetlanie wykresu.</p></div>',
      },
      21: {
        label: "Czy mogę zmienić kolory wykresu?",
        content:
          '<div class="content"><p>Tak, może Pan zmienić kolory wykresu. Proszę kliknąć prawym przyciskiem myszy na wykres i wybrać "Ustawienia wykresu". Wyświetli się menu rozwijane "Kolory". Kolory można odpowiednio zmienić.</p></div>',
      },
      22: {
        label: "Gdzie mogę zobaczyć linię ceny na wykresie?",
        content:
          '<div class="content"><p>Linia ceny to niebieska linia w tle wykresu. Porusza się ona zgodnie z ruchem ceny instrumentu.</p></div>',
      },
    },
    "Warunki handlowe": {
      0: {
        label:
          "Czy istnieją jakieś ograniczenia dotyczące przyjmowania stylów handlowych? Jestem skalperem.",
        content:
          '<div class="content"><p>Będąc brokerem przyjaznym inwestorom, nie ograniczamy żadnych stylów handlowych. Mogą Państwo hedgować, skalpować i korzystać z EA na swojej platformie transakcyjnej.</p></div>',
      },
      1: {
        label: "Czy stosują Państwo zasadę FIFO do realizacji transakcji?",
        content:
          '<div class="content"><p>Nie, nie przestrzegamy zasady FIFO. Inwestor może zamknąć transakcje zgodnie z własną strategią.</p></div>',
      },
      2: {
        label: "Jaki rodzaj realizacji transakcji Państwo zapewniają?",
        content:
          '<div class="content"><p>W AAAFx realizacja transakcji jest natychmiastowa.</p></div>',
      },
      3: {
        label: "Czy istnieje limit liczby transakcji zawieranych co miesiąc?",
        content:
          '<div class="content"><p>Nie, nie ma takich ograniczeń. Mogą Państwo zawierać transakcje według własnego uznania.</p></div>',
      },
      4: {
        label: "Czy mogę handlować w weekend?",
        content:
          '<div class="content"><p>Nie, handel nie jest dostępny w weekendy.</p></div>',
      },
      5: {
        label: "Jak długo mogę utrzymywać otwarte pozycje?",
        content:
          '<div class="content"><p>Nie ma przymusu co do czasu, przez jaki transakcja może pozostać otwarta. Mogą Państwo utrzymywać ją otwartą tak długo, jak długo mają Państwo wystarczający wolny depozyt zabezpieczający na rachunku.</p></div>',
      },
      6: {
        label: "Czy handlując z Państwem mogę stracić więcej niż wpłaciłem?",
        content:
          '<div class="content"><p>Podczas handlu z AAAFx nie mogą Państwo stracić więcej niż wpłacona kwota, ponieważ zapewniamy ochronę przed ujemnym saldem. AAAFx ustala według własnego uznania i w dobrej wierze, że wystąpienie takiego ujemnego salda nie jest spowodowane złośliwym lub niewłaściwym zachowaniem klienta i nie zostało celowo spowodowane przez klienta.</p></div>',
      },
      7: {
        label:
          "Co zrobić, jeśli na moim rachunku handlowym nie ma wolnego depozytu zabezpieczającego?",
        content:
          '<div class="content"><p>Jeśli nie ma już wolnego depozytu zabezpieczającego, nie mogą Państwo składać dalszych zleceń. Nie można również złożyć wniosku o wypłatę, ponieważ zawsze można wypłacić kwotę dostępną jako wolny depozyt zabezpieczający na rachunku.</p></div>',
      },
      8: {
        label: "Jakie spready oferują Państwo w AAAFx?",
        content:
          '<div class="content"><p>Zapewniamy cienkie jak brzytwa spready wszystkim naszym klientom, niezależnie od różnych typów rachunków. </p></div>',
      },
      9: {
        label: "Jaką dźwignię finansową oferuje AAAFx?",
        content:
          '<div class="content"><p>Maksymalna dźwignia oferowana dla AAAFX Europe wynosi 30X.</p></div>',
      },
      10: {
        label: "W jakiej strefie czasowej ustawione są Państwa serwery?",
        content:
          '<div class="content"><p>Jest ustawiony na czas UTC [UTC +1 w czasie letnim].</p></div>',
      },
      11: {
        label: "Gdzie znajdują się Państwa serwery?",
        content:
          '<div class="content"><p>Nasze serwery znajdują się w Londynie i Nowym Jorku.</p></div>',
      },
      12: {
        label: "Czy oferuje Pan doradztwo handlowe swoim klientom?",
        content:
          '<div class="content"><p>Będąc brokerem, nie udzielamy naszym klientom żadnych porad handlowych. Aby zapoznać się z idealnymi strategiami handlowymi, mogą Państwo odwiedzić stronę internetową Zulutrade i dowiedzieć się jak najwięcej. Co więcej, mogą Państwo również przeczytać o związku między dźwignią a depozytem zabezpieczającym, aby mądrze inwestować swoje środki. Handel na rynku Forex polega na inwestowaniu czasu i pieniędzy w rozsądny sposób. Proszę zacząć inwestować już teraz!</p></div>',
      },
    },
  },
};
